"use strict";

function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = require("react"),
    a = e(t),
    n = e(require("classnames")),
    r = require("accounting"),
    l = e(r),
    o = require("ramda"),
    c = e(require("axios")),
    s = require("luxon"),
    i = e(require("react-text-mask")),
    m = require("text-mask-addons"),
    u = e(require("react-select/async")),
    d = require("d3");

require("d3-axis"), require("d3-scale"), require("d3-format");

var E = e(require("react-dropzone")),
    p = e(require("copy-to-clipboard")),
    N = function N(e) {
  return a.createElement("button", {
    className: n("btn", e.className, {
      "btn-lg": e.large,
      "btn-block": e.block,
      "btn-sm": e.small,
      "btn-light": (t = e, !(t.success || t.info || t.primary || t.danger || t.warning || t.secondary || t.dark || t.link)),
      "btn-success": e.success,
      "btn-info": e.info,
      "btn-primary": e.primary,
      "btn-danger": e.danger,
      "btn-warning": e.warning,
      "btn-dark": e.dark,
      "btn-link": e.link,
      "btn-secondary": e.secondary
    }),
    style: e.style,
    type: e.submit ? "submit" : "button",
    disabled: e.disabled,
    onClick: function onClick() {
      (!e.confirm || window.confirm(e.confirm)) && e.onClick && e.onClick();
    }
  }, e.children);
  var t;
};

N.defaultProps = {
  large: !1,
  onClick: function onClick() {
    return null;
  },
  submit: !1,
  disabled: !1
};

var C = function C(e) {
  var t = e.children,
      r = e.onClick,
      l = e.style;
  return a.createElement(N, {
    link: !0,
    onClick: function onClick() {
      return r && r();
    },
    className: n("text-uppercase list-group-item list-group-item-action font-weight-bold pl-3 text-secondary", {
      "list-group-item-secondary": e.active
    }, e.className),
    style: l
  }, t);
};

C.defaultProps = {
  active: !1
};

var f = function f(e) {
  var t = a.useState(!1),
      r = t[0],
      l = t[1],
      o = e.heading,
      c = e.withTools,
      s = e.footer,
      i = e.success,
      m = e.info,
      u = e.warning,
      d = e.danger,
      E = e.onClose;
  return a.createElement("div", {
    onClick: e.onClick,
    className: n("card mb-3", e.className),
    style: e.style
  }, (o || c) && a.createElement("div", {
    className: "card-header"
  }, a.createElement("div", {
    className: "row h6 align-items-baseline"
  }, a.createElement("span", {
    className: "col"
  }, o), c && a.createElement("div", {
    className: "text-right col-auto"
  }, a.createElement(N, {
    className: "showhide p-0",
    link: !0,
    onClick: function onClick() {
      return l(!r);
    }
  }, a.createElement("i", {
    className: n("fa mx-1", {
      "fa-chevron-down": r,
      "fa-chevron-up": !r
    })
  })), a.createElement(N, {
    link: !0,
    className: "closebox mx-1 p-0",
    onClick: E
  }, a.createElement("i", {
    className: "fa fa-times"
  }))))), a.createElement("div", {
    className: "card-body",
    hidden: r
  }, i && a.createElement("div", {
    className: "alert alert-success"
  }, i), m && a.createElement("div", {
    className: "alert alert-info"
  }, m), u && a.createElement("div", {
    className: "alert alert-warning"
  }, u), d && a.createElement("div", {
    className: "alert alert-danger"
  }, d), e.children), s && a.createElement("div", {
    className: "card-footer"
  }, s));
};

function T() {
  return (T = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

f.defaultProps = {
  heading: "",
  footer: "",
  onClose: function onClose() {},
  onClick: function onClick() {},
  withTools: !1,
  className: ""
};

var v = function v(e) {
  var t = e.header,
      r = e.footer,
      l = e.children,
      o = e.title,
      c = a.createRef();
  return a.useEffect(function () {
    return document.body.classList.add("modal-open"), function () {
      return document.body.classList.remove("modal-open");
    };
  }, []), a.createElement("div", {
    className: n("modal fade show", e.className),
    role: "dialog",
    style: T({}, e.style, {
      display: "block",
      background: "rgba(0,0,0,0.4)"
    }),
    onClick: function onClick(t) {
      var a = e.closeConfirm,
          n = e.onClose;
      c.current === t.target && n && (a ? window.confirm(a) && n() : n());
    },
    ref: c
  }, a.createElement("div", {
    className: "modal-dialog",
    role: "document"
  }, a.createElement("div", {
    className: "modal-content"
  }, t || o && a.createElement("div", {
    className: "modal-header"
  }, o && a.createElement("h5", {
    className: "modal-title"
  }, o), t && t), a.createElement("div", {
    className: "modal-body"
  }, l), r && a.createElement("div", {
    className: "modal-footer"
  }, r))));
},
    g = function g(e) {
  return a.createElement("footer", {
    className: "footer fixed-bottom w-100",
    style: {
      position: "relative",
      marginTop: "0",
      backgroundColor: "rgb(32,43,58)"
    }
  }, e.children);
},
    h = a.createContext({
  toasts: [],
  toast: function toast() {},
  clearToast: function clearToast() {}
}),
    y = function y() {
  var e = a.useContext(h),
      t = e.toasts,
      r = e.clearToast;
  return t.length < 1 ? null : a.createElement("div", {
    style: {
      position: "fixed",
      bottom: "2rem",
      right: "2rem",
      zIndex: 9999
    }
  }, t.map(function (e, t) {
    return a.createElement("div", {
      className: "toast fade show",
      role: "alert",
      "aria-live": "assertive",
      "aria-atomic": "true",
      key: t + e.text
    }, a.createElement("div", {
      className: "toast-header"
    }, a.createElement("strong", {
      className: n("mr-auto", {
        "text-success": "success" === e.type,
        "text-danger": "error" === e.type,
        "text-warning": "warning" === e.type
      })
    }, "success" === e.type && a.createElement("i", {
      className: "fa fa-check"
    }), "warning" === e.type && a.createElement("i", {
      className: "fa fa-warning"
    }), "error" === e.type && a.createElement("i", {
      className: "fa fa-exclamation-circle"
    })), a.createElement("button", {
      type: "button",
      className: "ml-2 mb-1 close",
      "aria-label": "Close",
      onClick: function onClick() {
        return r(e);
      }
    }, a.createElement("span", {
      "aria-hidden": "true"
    }, "×"))), a.createElement("div", {
      className: "toast-body"
    }, e.text));
  }));
},
    A = a.createContext({
  alerts: [],
  alert: function alert() {},
  clearAlert: function clearAlert() {}
}),
    b = function b() {
  var e = a.useContext(A),
      t = e.alerts,
      n = e.clearAlert;
  return t.length < 1 ? null : a.createElement("div", {
    className: "w-100",
    style: {
      position: "fixed",
      top: "5rem",
      zIndex: 9999
    }
  }, t.map(function (e, t) {
    return a.createElement("div", {
      className: "mx-4 alert alert-dismissible fade show alert-" + ("error" === e.type ? "danger" : e.type),
      role: "alert",
      key: t + e.text
    }, e.text, a.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }, a.createElement("span", {
      "aria-hidden": "true",
      onClick: function onClick() {
        return n(e);
      }
    }, "×")));
  }));
},
    S = function S(e) {
  return e.prepend || e.append ? a.createElement("div", {
    className: "input-group"
  }, e.prepend && a.createElement("div", {
    className: "input-group-prepend"
  }, e.prepend), e.children, e.append && a.createElement("div", {
    className: "input-group-append"
  }, e.append)) : a.createElement(a.Fragment, null, e.children);
},
    R = function R(e) {
  return a.createElement(a.Fragment, null, a.createElement(S, Object.assign({}, e), a.createElement(i, {
    mask: function mask(e) {
      return e.length > 5 ? [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/] : [/\d/, /\d/, /\d/, /\d/, /\d/, ""];
    },
    pattern: "^\\d{5}(-\\d{4})?$",
    guide: !1,
    value: e.value,
    name: e.name,
    "aria-labelledby": e.name,
    onChange: function onChange(t) {
      return e.onChange(t.target.value);
    },
    autoComplete: "new-password",
    onBlur: e.onBlur,
    type: e.type,
    placeholder: e.placeholder,
    required: e.required,
    disabled: e.disabled,
    hidden: e.hidden,
    readOnly: e.readOnly,
    className: n("form-control", e.className, {
      error: !!e.error
    }),
    style: e.style
  })), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
},
    I = function I(e) {
  var t = a.useState(null),
      n = t[0],
      r = t[1],
      l = e.value;
  return a.createElement(a.Fragment, null, a.createElement(R, Object.assign({}, e, {
    onChange: function onChange(t) {
      !t || 5 !== t.length && 10 !== t.length || function (t) {
        c.get("https://connect-api.navitascredit.com/v1/zips/" + t).then(function (a) {
          var n = a.data.places;
          n && (1 === n.length ? (e.onCityChange(n[0]["place name"]), e.onStateChange(n[0]["state abbreviation"])) : r(n.map(function (e) {
            return {
              zip: t,
              city: e["place name"],
              state: e["state abbreviation"]
            };
          })));
        });
      }(t), e.onChange(t);
    },
    value: void 0 === l ? "" : l
  })), n && a.createElement(v, null, a.createElement(f, {
    heading: "Please select a location.",
    className: "p-3"
  }, a.createElement("div", {
    className: "row justify-content-center"
  }, n.map(function (t) {
    return a.createElement(N, {
      key: t.city,
      block: !0,
      onClick: function onClick() {
        return function (t) {
          r(null), e.onCityChange(t.city), e.onStateChange(t.state);
        }(t);
      }
    }, t.city + ", " + t.state);
  }), a.createElement(N, {
    block: !0,
    secondary: !0,
    onClick: function onClick() {
      return r(null);
    }
  }, "Cancel")))));
},
    O = {
  quantity: 1
},
    _ = {
  comments: "",
  companyType: "",
  customerCity: "",
  customerCompanyName: "",
  customerContactName: "",
  customerContactEmail: "",
  customerContactPhone: "",
  customerDBA: "",
  customerPhone: "",
  customerRefNum: "",
  customerState: "",
  customerStreet: "",
  customerStreet2: "",
  customerTID: "",
  customerZip: "",
  customerYearsInBusiness: 0,
  assets: [O],
  financeTerm: 12,
  financeType: "",
  guarantors: [{}],
  corp_guarantors: []
},
    P = [{
  label: "Sole Proprietorship",
  value: "Sole Proprietorship"
}, {
  label: "Partnership",
  value: "Partnership"
}, {
  label: "LLC",
  value: "LLC"
}, {
  label: "Corporation",
  value: "Corporation"
}, {
  label: "Non Profit",
  value: "Non Profit"
}, {
  label: "Municipality",
  value: "Municipality"
}, {
  label: "Unknown",
  value: "Unknown"
}],
    D = function D(e) {
  return a.createElement("div", {
    className: n("form-group", e.className, {
      row: e.horizontal,
      "align-items-center": e.horizontal
    }),
    style: e.style
  }, a.createElement("label", {
    htmlFor: e.for,
    className: n({
      "col-sm-auto": e.horizontal
    })
  }, e.label, e.required && a.createElement("span", {
    className: "text-danger",
    style: {
      fontSize: "1.2rem"
    }
  }, " *")), e.horizontal ? a.createElement("div", {
    className: "col-sm"
  }, " ", e.children, " ") : e.children);
},
    L = function L(e) {
  return a.createElement(a.Fragment, null, a.createElement(S, Object.assign({}, e), a.createElement("input", {
    value: e.value,
    name: e.name,
    "aria-labelledby": e.name,
    type: e.type,
    onChange: function onChange(t) {
      return e.onChange(t.target.value);
    },
    onBlur: e.onBlur,
    autoComplete: "new-password",
    placeholder: e.placeholder,
    disabled: e.disabled,
    hidden: e.hidden,
    readOnly: e.readOnly,
    required: e.required,
    maxLength: e.maxLength,
    className: n("form-control", e.className, {
      error: !!e.error
    }),
    style: e.style,
    list: e.list
  })), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
},
    M = function M(e) {
  return a.createElement(a.Fragment, null, a.createElement(S, Object.assign({}, e), a.createElement("textarea", {
    value: e.value,
    name: e.name,
    "aria-labelledby": e.name,
    onChange: function onChange(t) {
      return e.onChange(t.target.value);
    },
    onBlur: e.onBlur,
    autoComplete: "new-password",
    placeholder: e.placeholder,
    disabled: e.disabled,
    hidden: e.hidden,
    readOnly: e.readOnly,
    required: e.required,
    rows: e.rows,
    className: n("form-control", e.className, {
      error: !!e.error
    }),
    style: e.style
  })), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
},
    x = function x(e) {
  return a.createElement(a.Fragment, null, a.createElement(S, Object.assign({}, e), a.createElement("input", {
    name: e.name,
    "aria-labelledby": e.name,
    value: U(e.value),
    onChange: function onChange(t) {
      return e.onChange(F(t.target.value));
    },
    onBlur: e.onBlur,
    type: "date",
    placeholder: e.placeholder,
    required: e.required,
    disabled: e.disabled,
    hidden: e.hidden,
    readOnly: e.readOnly,
    className: n("form-control", e.className, {
      error: !!e.error
    }),
    style: e.style
  })), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
},
    U = function U(e) {
  if (s.DateTime.fromFormat(e, "yyyy-LL-dd").isValid) return e;
  var t = s.DateTime.fromISO(e);
  return t.isValid ? t.toFormat("yyyy-LL-dd") : "";
},
    F = function F(e) {
  var t = s.DateTime.fromFormat(e, "yyyy-LL-dd");
  return t.isValid ? t.toISO() : "";
},
    G = function G(e) {
  return a.createElement(a.Fragment, null, a.createElement(S, Object.assign({}, e), a.createElement("input", {
    value: e.value,
    name: e.name,
    "aria-labelledby": e.name,
    onChange: function onChange(t) {
      return e.onChange("" === t.target.value ? void 0 : +t.target.value);
    },
    onBlur: e.onBlur,
    type: "number",
    placeholder: e.placeholder,
    required: e.required,
    disabled: e.disabled,
    hidden: e.hidden,
    readOnly: e.readOnly,
    className: n("form-control", e.className, {
      error: !!e.error
    }),
    min: e.min,
    max: e.max,
    step: e.step,
    style: e.style
  })), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
};

G.defaultProps = {
  step: 1
};

var w = function w(e) {
  var t = a.useState("" + e.value),
      r = t[0],
      l = t[1];
  return a.useEffect(function () {
    e.value !== k(r) && l(e.value ? "" + e.value : "");
  }, [e.value, r]), a.createElement(a.Fragment, null, a.createElement(S, Object.assign({}, e), a.createElement(i, {
    mask: m.createNumberMask({
      allowDecimal: !0
    }),
    value: r,
    name: e.name,
    "aria-labelledby": e.name,
    onChange: function onChange(t) {
      return l(a = t.target.value), void e.onChange("" === a ? void 0 : k(a));
      var a;
    },
    onBlur: e.onBlur,
    placeholder: e.placeholder,
    autoComplete: "new-password",
    type: "text",
    required: e.required,
    className: n("form-control", e.className, {
      error: !!e.error
    }),
    disabled: e.disabled,
    hidden: e.hidden,
    readOnly: e.readOnly,
    style: e.style
  })), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
},
    k = function k(e) {
  return +e.replace(/[^0-9.]/g, "");
},
    q = function q(e) {
  return a.createElement(a.Fragment, null, a.createElement(S, Object.assign({}, e), a.createElement(i, {
    mask: ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
    value: e.value,
    name: e.name,
    "aria-labelledby": e.name,
    onChange: function onChange(t) {
      return e.onChange(t.target.value);
    },
    onBlur: e.onBlur,
    autoComplete: "new-password",
    type: "tel",
    placeholder: e.placeholder,
    required: e.required,
    disabled: e.disabled,
    readOnly: e.readOnly,
    hidden: e.hidden,
    className: n("form-control", e.className, {
      error: !!e.error
    }),
    pattern: "\\(\\d{3}\\) \\d{3}-\\d{4}",
    style: e.style
  })), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
};

function B(e) {
  var t = e.options,
      r = void 0 === t ? [] : t,
      l = r.findIndex(function (t) {
    return t.value === e.value;
  });
  return l = -1 === l ? void 0 : l, a.createElement(a.Fragment, null, a.createElement(S, Object.assign({}, e), a.createElement("select", {
    name: e.name,
    "aria-labelledby": e.name,
    value: l,
    onChange: function onChange(t) {
      e.onChange(t.target.value ? r[+t.target.value].value : void 0);
    },
    onBlur: e.onBlur,
    required: e.required,
    disabled: e.disabled || e.readOnly,
    hidden: e.hidden,
    className: n("form-control", e.className, {
      error: !!e.error
    }),
    style: e.style
  }, a.createElement("option", null), r.map(function (e, t) {
    var n = e.label;
    return a.createElement("option", {
      value: t,
      key: n + t
    }, n);
  }))), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
}

var V = [{
  label: "Armed Forces Americas (except Canada)",
  value: "AA"
}, {
  label: "Armed Forces Europe, Middle East, Africa, and Canada",
  value: "AE"
}, {
  label: "Alaska",
  value: "AK"
}, {
  label: "Alabama",
  value: "AL"
}, {
  label: "Armed Forces Pacific",
  value: "AP"
}, {
  label: "Arkansas",
  value: "AR"
}, {
  label: "American Samoa",
  value: "AS"
}, {
  label: "Arizona",
  value: "AZ"
}, {
  label: "California",
  value: "CA"
}, {
  label: "Colorado",
  value: "CO"
}, {
  label: "Connecticut",
  value: "CT"
}, {
  label: "District of Columbia",
  value: "DC"
}, {
  label: "Delaware",
  value: "DE"
}, {
  label: "Florida",
  value: "FL"
}, {
  label: "Federated States of Micronesia",
  value: "FM"
}, {
  label: "Georgia",
  value: "GA"
}, {
  label: "Guam",
  value: "GU"
}, {
  label: "Hawaii",
  value: "HI"
}, {
  label: "Iowa",
  value: "IA"
}, {
  label: "Idaho",
  value: "ID"
}, {
  label: "Illinois",
  value: "IL"
}, {
  label: "Indiana",
  value: "IN"
}, {
  label: "Kansas",
  value: "KS"
}, {
  label: "Kentucky",
  value: "KY"
}, {
  label: "Louisiana",
  value: "LA"
}, {
  label: "Massachusetts",
  value: "MA"
}, {
  label: "Maryland",
  value: "MD"
}, {
  label: "Maine",
  value: "ME"
}, {
  label: "Marshall Islands",
  value: "MH"
}, {
  label: "Michigan",
  value: "MI"
}, {
  label: "Minnesota",
  value: "MN"
}, {
  label: "Missouri",
  value: "MO"
}, {
  label: "Northern Mariana Islands",
  value: "MP"
}, {
  label: "Mississippi",
  value: "MS"
}, {
  label: "Montana",
  value: "MT"
}, {
  label: "North Carolina",
  value: "NC"
}, {
  label: "North Dakota",
  value: "ND"
}, {
  label: "Nebraska",
  value: "NE"
}, {
  label: "New Hampshire",
  value: "NH"
}, {
  label: "New Jersey",
  value: "NJ"
}, {
  label: "New Mexico",
  value: "NM"
}, {
  label: "Nevada",
  value: "NV"
}, {
  label: "New York",
  value: "NY"
}, {
  label: "Ohio",
  value: "OH"
}, {
  label: "Oklahoma",
  value: "OK"
}, {
  label: "Oregon",
  value: "OR"
}, {
  label: "Pennsylvania",
  value: "PA"
}, {
  label: "Puerto Rico",
  value: "PR"
}, {
  label: "Palau",
  value: "PW"
}, {
  label: "Rhode Island",
  value: "RI"
}, {
  label: "South Carolina",
  value: "SC"
}, {
  label: "South Dakota",
  value: "SD"
}, {
  label: "Tennessee",
  value: "TN"
}, {
  label: "Texas",
  value: "TX"
}, {
  label: "Utah",
  value: "UT"
}, {
  label: "Virginia",
  value: "VA"
}, {
  label: "Virgin Islands",
  value: "VI"
}, {
  label: "Vermont",
  value: "VT"
}, {
  label: "Washington",
  value: "WA"
}, {
  label: "Wisconsin",
  value: "WI"
}, {
  label: "West Virginia",
  value: "WV"
}, {
  label: "Wyoming",
  value: "WY"
}],
    Y = function Y(e) {
  return a.createElement(B, Object.assign({}, e, {
    options: V
  }));
},
    H = [{
  label: "ALY",
  value: "ALY"
}, {
  label: "ANX",
  value: "ANX"
}, {
  label: "ARC",
  value: "ARC"
}, {
  label: "AVE",
  value: "AVE"
}, {
  label: "BYU",
  value: "BYU"
}, {
  label: "BCH",
  value: "BCH"
}, {
  label: "BND",
  value: "BND"
}, {
  label: "BG",
  value: "BG"
}, {
  label: "BLVD",
  value: "BLVD"
}, {
  label: "BLF",
  value: "BLF"
}, {
  label: "BTM",
  value: "BTM"
}, {
  label: "BYP",
  value: "BYP"
}, {
  label: "BR",
  value: "BR"
}, {
  label: "BRG",
  value: "BRG"
}, {
  label: "BRK",
  value: "BRK"
}, {
  label: "CP",
  value: "CP"
}, {
  label: "CYN",
  value: "CYN"
}, {
  label: "CPE",
  value: "CPE"
}, {
  label: "CSWY",
  value: "CSWY"
}, {
  label: "CTR",
  value: "CTR"
}, {
  label: "CIR",
  value: "CIR"
}, {
  label: "CRK",
  value: "CRK"
}, {
  label: "CLB",
  value: "CLB"
}, {
  label: "CLFS",
  value: "CLFS"
}, {
  label: "COR",
  value: "COR"
}, {
  label: "CORS",
  value: "CORS"
}, {
  label: "CRSE",
  value: "CRSE"
}, {
  label: "CT",
  value: "CT"
}, {
  label: "CTS",
  value: "CTS"
}, {
  label: "CV",
  value: "CV"
}, {
  label: "CRES",
  value: "CRES"
}, {
  label: "XING",
  value: "XING"
}, {
  label: "DL",
  value: "DL"
}, {
  label: "DM",
  value: "DM"
}, {
  label: "DV",
  value: "DV"
}, {
  label: "DR",
  value: "DR"
}, {
  label: "EST",
  value: "EST"
}, {
  label: "EXPY",
  value: "EXPY"
}, {
  label: "EXT",
  value: "EXT"
}, {
  label: "FALL",
  value: "FALL"
}, {
  label: "FLS",
  value: "FLS"
}, {
  label: "FRY",
  value: "FRY"
}, {
  label: "FLD",
  value: "FLD"
}, {
  label: "FLDS",
  value: "FLDS"
}, {
  label: "FLT",
  value: "FLT"
}, {
  label: "FRD",
  value: "FRD"
}, {
  label: "FRST",
  value: "FRST"
}, {
  label: "FRG",
  value: "FRG"
}, {
  label: "FRK",
  value: "FRK"
}, {
  label: "FRKS",
  value: "FRKS"
}, {
  label: "FT",
  value: "FT"
}, {
  label: "FWY",
  value: "FWY"
}, {
  label: "GDNS",
  value: "GDNS"
}, {
  label: "GTWY",
  value: "GTWY"
}, {
  label: "GLN",
  value: "GLN"
}, {
  label: "GRN",
  value: "GRN"
}, {
  label: "GRV",
  value: "GRV"
}, {
  label: "HBR",
  value: "HBR"
}, {
  label: "HVN",
  value: "HVN"
}, {
  label: "HTS",
  value: "HTS"
}, {
  label: "HWY",
  value: "HWY"
}, {
  label: "HL",
  value: "HL"
}, {
  label: "HLS",
  value: "HLS"
}, {
  label: "HOLW",
  value: "HOLW"
}, {
  label: "INLT",
  value: "INLT"
}, {
  label: "IS",
  value: "IS"
}, {
  label: "ISS",
  value: "ISS"
}, {
  label: "ISLE",
  value: "ISLE"
}, {
  label: "JCT",
  value: "JCT"
}, {
  label: "KY",
  value: "KY"
}, {
  label: "KNLS",
  value: "KNLS"
}, {
  label: "LN",
  value: "LN"
}, {
  label: "LK",
  value: "LK"
}, {
  label: "LKS",
  value: "LKS"
}, {
  label: "LNDG",
  value: "LNDG"
}, {
  label: "LCKS",
  value: "LCKS"
}, {
  label: "LDG",
  value: "LDG"
}, {
  label: "LF",
  value: "LF"
}, {
  label: "LGT",
  value: "LGT"
}, {
  label: "LOOP",
  value: "LOOP"
}, {
  label: "MALL",
  value: "MALL"
}, {
  label: "MNR",
  value: "MNR"
}, {
  label: "MDWS",
  value: "MDWS"
}, {
  label: "ML",
  value: "ML"
}, {
  label: "MLS",
  value: "MLS"
}, {
  label: "MSN",
  value: "MSN"
}, {
  label: "MT",
  value: "MT"
}, {
  label: "MTN",
  value: "MTN"
}, {
  label: "NCK",
  value: "NCK"
}, {
  label: "ORCH",
  value: "ORCH"
}, {
  label: "OVAL",
  value: "OVAL"
}, {
  label: "PARK",
  value: "PARK"
}, {
  label: "PKY",
  value: "PKY"
}, {
  label: "PASS",
  value: "PASS"
}, {
  label: "PATH",
  value: "PATH"
}, {
  label: "PIKE",
  value: "PIKE"
}, {
  label: "PNES",
  value: "PNES"
}, {
  label: "PL",
  value: "PL"
}, {
  label: "PLN",
  value: "PLN"
}, {
  label: "PLNS",
  value: "PLNS"
}, {
  label: "PLZ",
  value: "PLZ"
}, {
  label: "PT",
  value: "PT"
}, {
  label: "PRT",
  value: "PRT"
}, {
  label: "PR",
  value: "PR"
}, {
  label: "RADL",
  value: "RADL"
}, {
  label: "RNCH",
  value: "RNCH"
}, {
  label: "RPDS",
  value: "RPDS"
}, {
  label: "RD",
  value: "RD"
}, {
  label: "RDG",
  value: "RDG"
}, {
  label: "RST",
  value: "RST"
}, {
  label: "RIV",
  value: "RIV"
}, {
  label: "ROW",
  value: "ROW"
}, {
  label: "RUN",
  value: "RUN"
}, {
  label: "SHL",
  value: "SHL"
}, {
  label: "SHLS",
  value: "SHLS"
}, {
  label: "SHR",
  value: "SHR"
}, {
  label: "SHRS",
  value: "SHRS"
}, {
  label: "SMT",
  value: "SMT"
}, {
  label: "SPG",
  value: "SPG"
}, {
  label: "SPGS",
  value: "SPGS"
}, {
  label: "SPUR",
  value: "SPUR"
}, {
  label: "SQ",
  value: "SQ"
}, {
  label: "ST",
  value: "ST"
}, {
  label: "STA",
  value: "STA"
}, {
  label: "STRA",
  value: "STRA"
}, {
  label: "STRM",
  value: "STRM"
}, {
  label: "TER",
  value: "TER"
}, {
  label: "TPKE",
  value: "TPKE"
}, {
  label: "TRL",
  value: "TRL"
}, {
  label: "TRCE",
  value: "TRCE"
}, {
  label: "TRAK",
  value: "TRAK"
}, {
  label: "TRFY",
  value: "TRFY"
}, {
  label: "TUNL",
  value: "TUNL"
}, {
  label: "UN",
  value: "UN"
}, {
  label: "VLY",
  value: "VLY"
}, {
  label: "VIA",
  value: "VIA"
}, {
  label: "VW",
  value: "VW"
}, {
  label: "VLG",
  value: "VLG"
}, {
  label: "VL",
  value: "VL"
}, {
  label: "VIS",
  value: "VIS"
}, {
  label: "WALK",
  value: "WALK"
}, {
  label: "WAY",
  value: "WAY"
}, {
  label: "WLS",
  value: "WLS"
}],
    z = function z(e) {
  return a.createElement(B, Object.assign({}, e, {
    options: H
  }));
},
    W = function W(e) {
  return a.createElement(a.Fragment, null, a.createElement(S, Object.assign({}, e), a.createElement(i, {
    mask: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
    pattern: "\\d{3}-\\d{2}-\\d{4}",
    value: e.value,
    name: e.name,
    "aria-labelledby": e.name,
    onChange: function onChange(t) {
      return e.onChange(t.target.value);
    },
    onBlur: e.onBlur,
    placeholder: e.placeholder,
    required: e.required,
    disabled: e.disabled,
    hidden: e.hidden,
    readOnly: e.readOnly,
    className: n("form-control", e.className, {
      error: !!e.error
    }),
    style: e.style
  })), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
},
    j = function j(e) {
  return a.createElement(a.Fragment, null, a.createElement(S, Object.assign({}, e), a.createElement(i, {
    mask: [/\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
    pattern: "\\d{2}-\\d{7}",
    value: e.value,
    name: e.name,
    "aria-labelledby": e.name,
    onChange: function onChange(t) {
      return e.onChange(t.target.value);
    },
    onBlur: e.onBlur,
    placeholder: e.placeholder,
    required: e.required,
    disabled: e.disabled,
    hidden: e.hidden,
    readOnly: e.readOnly,
    className: n("form-control", e.className, {
      error: !!e.error
    }),
    style: e.style
  })), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
},
    Q = function Q(e) {
  return a.createElement(a.Fragment, null, a.createElement("div", {
    style: e.style,
    className: n("input-group", e.className)
  }, e.prepend && a.createElement("div", {
    className: "input-group-prepend"
  }, e.prepend), a.createElement("input", {
    name: e.name,
    "aria-labelledby": e.name,
    value: "" === e.value ? "#FFFFFF" : e.value,
    onChange: function onChange(t) {
      return e.onChange(t.target.value);
    },
    onBlur: e.onBlur,
    type: "color",
    placeholder: e.placeholder,
    required: e.required,
    disabled: e.disabled,
    hidden: e.hidden,
    readOnly: e.readOnly,
    className: n("form-control", "p-0", {
      error: !!e.error
    }),
    style: e.style
  }), a.createElement("div", {
    className: "input-group-append"
  }, a.createElement(N, {
    onClick: function onClick() {
      return e.onChange("#FFFFFF");
    },
    disabled: !e.value
  }, "Clear"))), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
};

function K(e) {
  return a.createElement(a.Fragment, null, e.options && e.options.map(function (t) {
    var r = t.label,
        l = t.value;
    return a.createElement("div", {
      className: "form-check",
      key: r
    }, a.createElement("input", {
      type: "checkbox",
      className: n("form-check-input", e.className),
      name: e.name,
      "aria-labelledby": e.name,
      checked: !!e.value && e.value.includes(l),
      disabled: e.disabled,
      hidden: e.hidden,
      readOnly: e.readOnly,
      onChange: function onChange() {
        return e.onChange(function (e, t) {
          return e.includes(t) ? e.filter(function (e) {
            return e !== t;
          }) : [].concat(e, [t]);
        }("" === e.value ? [] : e.value, l));
      },
      style: e.style
    }), a.createElement("label", {
      className: "form-check-label"
    }, r));
  }), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
}

function Z(e) {
  return e.options ? a.createElement(a.Fragment, null, e.options && e.options.map(function (t) {
    var r = t.label,
        l = t.value;
    return a.createElement("div", {
      className: "form-check form-check-inline",
      key: r
    }, a.createElement("input", {
      required: e.required,
      type: "radio",
      name: e.name,
      "aria-labelledby": e.name,
      className: n("form-check-input", e.className, {
        error: !!e.error
      }),
      checked: e.value === l,
      onChange: function onChange() {
        return e.onChange(l);
      },
      onBlur: e.onBlur,
      disabled: e.disabled,
      hidden: e.hidden,
      readOnly: e.readOnly,
      style: e.style
    }), a.createElement("label", {
      className: "form-check-label"
    }, r));
  }), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error)) : null;
}

var X = function X(e) {
  return a.createElement(a.Fragment, null, a.createElement(S, Object.assign({}, e), a.createElement("input", {
    value: e.value,
    type: "range",
    name: e.name,
    "aria-labelledby": e.name,
    onChange: function onChange(t) {
      return e.onChange(+t.target.value);
    },
    onBlur: e.onBlur,
    placeholder: e.placeholder,
    disabled: e.disabled,
    hidden: e.hidden,
    readOnly: e.readOnly,
    required: e.required,
    min: e.min,
    max: e.max,
    className: n("form-control", e.className, {
      error: !!e.error
    }),
    style: e.style
  })), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
},
    $ = function $(e) {
  var t = 100 * e;
  return Number.isInteger(t) ? "" + t : t.toFixed(1) === "" + t ? t.toFixed(1) : t.toFixed(2);
},
    J = function J(e) {
  return +e / 100;
},
    ee = function ee(e) {
  var t = a.useState("" !== e.value ? $(e.value) : ""),
      r = t[0],
      l = t[1];
  return a.useEffect(function () {
    e.value !== J(r) && l(e.value ? $(e.value) : "");
  }, [e.value, r]), a.createElement(a.Fragment, null, a.createElement("div", {
    className: "input-group"
  }, e.prepend && a.createElement("div", {
    className: "input-group-prepend"
  }, e.prepend), a.createElement("input", {
    value: r,
    name: e.name,
    "aria-labelledby": e.name,
    onChange: function onChange(t) {
      return l(a = t.target.value), void e.onChange("" === a ? void 0 : J(a));
      var a;
    },
    min: "0",
    max: "100",
    step: "0.01",
    onBlur: e.onBlur,
    type: "number",
    placeholder: e.placeholder,
    required: e.required,
    disabled: e.disabled,
    hidden: e.hidden,
    readOnly: e.readOnly,
    className: n("form-control", e.className, {
      error: !!e.error
    }),
    style: e.style
  }), a.createElement("div", {
    className: "input-group-append"
  }, a.createElement("span", {
    className: "input-group-text"
  }, "%"), e.append)), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
},
    te = function te(e) {
  return a.createElement(a.Fragment, null, a.createElement("div", {
    style: e.style,
    className: n(e.className, "btn-group d-flex")
  }, a.createElement(N, {
    primary: !0 === e.value,
    onClick: function onClick() {
      return e.onChange(!0);
    },
    disabled: e.disabled
  }, "Yes"), a.createElement(N, {
    primary: !1 === e.value,
    onClick: function onClick() {
      return e.onChange(!1);
    },
    disabled: e.disabled
  }, "No")), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
},
    ae = function ae(e) {
  return a.createElement(a.Fragment, null, a.createElement(S, Object.assign({}, e), a.createElement(i, {
    mask: [/[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/],
    guide: !1,
    value: e.value,
    name: e.name,
    "aria-labelledby": e.name,
    onChange: function onChange(t) {
      return e.onChange(t.target.value);
    },
    onBlur: e.onBlur,
    placeholder: e.placeholder,
    required: e.required,
    disabled: e.disabled,
    hidden: e.hidden,
    readOnly: e.readOnly,
    className: n("form-control", e.className, {
      error: !!e.error
    }),
    style: e.style
  })), e.error && a.createElement("p", {
    className: "help-block text-danger"
  }, e.error));
},
    ne = function ne(e) {
  switch (e.type) {
    case "boolean":
      return a.createElement(te, Object.assign({}, e));

    case "color":
      return a.createElement(Q, Object.assign({}, e));

    case "currency":
      return a.createElement(w, Object.assign({}, e));

    case "date":
      return a.createElement(x, Object.assign({}, e));

    case "email":
      return a.createElement(L, Object.assign({}, e, {
        type: "email"
      }));

    case "multi-select":
      return a.createElement(K, Object.assign({}, e));

    case "number":
      return a.createElement(G, Object.assign({}, e));

    case "percent":
      return a.createElement(ee, Object.assign({}, e));

    case "radio":
      return a.createElement(Z, Object.assign({}, e));

    case "range":
      return a.createElement(X, Object.assign({}, e));

    case "select":
      return a.createElement(B, Object.assign({}, e));

    case "ssn":
      return a.createElement(W, Object.assign({}, e));

    case "state":
      return a.createElement(Y, Object.assign({}, e));

    case "street-type":
      return a.createElement(z, Object.assign({}, e));

    case "tel":
      return a.createElement(q, Object.assign({}, e));

    case "text":
      return a.createElement(L, Object.assign({}, e));

    case "textarea":
      return a.createElement(M, Object.assign({}, e, {
        type: "textarea"
      }));

    case "tid":
      return a.createElement(j, Object.assign({}, e));

    case "zip":
      return a.createElement(R, Object.assign({}, e));

    case "street-number":
      return a.createElement(ae, Object.assign({}, e));

    default:
      return a.createElement(L, Object.assign({}, e));
  }
};

function re(e) {
  var t = o.isNil(e.value) ? "" : e.value;
  return a.createElement(e.editable ? le : ne, Object.assign({}, e, {
    onChange: function onChange(t) {
      o.isNil(t) || o.isEmpty(t) ? e.onChange(void 0) : e.onChange(t);
    },
    value: t
  }));
}

function le(e) {
  var t = e.override,
      l = e.value,
      c = e.className,
      i = e.style,
      m = a.useState(!1),
      u = m[0],
      d = m[1],
      E = a.useState(!1),
      p = E[0],
      C = E[1],
      f = o.isNil(t) ? l : t,
      T = p ? t : f;
  return u ? a.createElement("div", {
    className: n("input-group editable-input", c),
    style: i
  }, a.createElement("div", {
    className: "input-group-prepend"
  }, a.createElement(N, {
    className: "input-group-text",
    onClick: function onClick() {
      d(!1), C(!1), e.onEditClose && e.onEditClose();
    }
  }, a.createElement("i", {
    className: "fa fa-check"
  })), a.createElement(N, {
    className: "input-group-text",
    onClick: function onClick() {
      C(!1), d(!1), e.onChange(void 0);
    }
  }, a.createElement("i", {
    className: "fa fa-times"
  }))), a.createElement(ne, Object.assign({}, e, {
    value: T || "",
    onChange: function onChange(t) {
      C(!0), e.onChange(t);
    },
    style: void 0,
    className: void 0
  }))) : a.createElement("div", {
    className: n("editable-input", c),
    style: i
  }, a.createElement("a", {
    className: "btn btn-xs btn-default mr-1 p-0",
    onClick: function onClick() {
      return d(!0);
    }
  }, a.createElement("i", {
    className: "fa fa-edit"
  })), a.createElement("span", {
    className: o.isNil(t) ? "not-overridden" : "overridden"
  }, function (e) {
    var t = e.type,
        a = e.placeholder,
        n = void 0 === a ? "" : a,
        l = e.options,
        c = void 0 === l ? [] : l,
        i = e.override,
        m = o.isNil(i) ? e.value : i;
    if (o.isNil(m)) return n;

    if ("string" == typeof m && "date" === t) {
      var u = s.DateTime.fromISO(m);
      if (u.isValid) return u.toLocaleString();
      var d = s.DateTime.fromFormat(m, "yyyy-LL-dd");
      return d.isValid ? d.toLocaleString() : m;
    }

    if ("currency" === t) return r.formatMoney(m);
    if ("percent" === t) return (100 * m).toFixed(2) + "%";

    if ("select" === t) {
      var E = c.find(function (e) {
        return e.value === m;
      });
      return E ? E.label : m;
    }

    return Array.isArray(m) ? m.join(", ") : m;
  }(e)));
}

function oe(e, t) {
  return e = e.toLowerCase().trim(), t.filter(function (t) {
    return t.label.toLowerCase().includes(e);
  });
}

re.defaultProps = {
  type: "text",
  style: {}
};

var ce = function ce(e) {
  var t = "number" === e.termInput,
      n = e.terms.sort();
  return a.createElement(f, {
    style: e.style,
    className: e.className,
    heading: "Term Requested in Months"
  }, a.createElement(D, {
    label: "Select Term in Months"
  }, a.createElement("div", {
    className: "row justify-content-around"
  }, t && a.createElement(a.Fragment, null, a.createElement(re, {
    required: e.required,
    type: "range",
    name: "financeTerm",
    value: e.selected,
    onChange: e.onChange,
    min: Math.min.apply(Math, n),
    max: Math.max.apply(Math, n),
    onBlur: e.onBlur,
    error: e.error
  }), a.createElement("label", {
    style: {
      display: "block"
    },
    className: "text-center"
  }, e.selected)), !t && a.createElement(re, {
    options: n.map(function (e) {
      return {
        label: e.toString(),
        value: e
      };
    }),
    required: e.required,
    type: "radio",
    name: "financeTerm",
    value: e.selected,
    onChange: e.onChange,
    onBlur: e.onBlur,
    error: e.error
  }))));
};

ce.defaultProps = {
  terms: [12, 24, 36, 48, 60],
  termInput: "radio"
};

var se,
    ie = {
  all: "All Activity",
  today: "Today's Activity",
  yesterday: "Yesterday's Activity",
  "this week": "This Week's Activity",
  "last week": "Last Week's Activity",
  "this month": "This Month's Activity",
  "last month": "Last Month's Activity",
  "last 30 days": "Last 30 Days' Activity",
  "this year": "This Year's Activity",
  "last year": "Last Year's Activity"
},
    me = function me(e) {
  return a.createElement(f, {
    onClick: e.onClick,
    className: n(e.selected ? "selected" : "", e.className),
    style: e.style
  }, a.createElement("div", {
    className: "text-center"
  }, a.createElement("h1", {
    className: "m-3 font-weight-bold"
  }, e.number), a.createElement("h4", {
    className: "font-weight-bold text-success my-0"
  }, e.amount), a.createElement("h6", {
    className: "m-xs"
  }, e.title)));
};

me.defaultProps = {
  selected: !1,
  onClick: function onClick() {
    return null;
  }
}, function (e) {
  e[e.ASC = 0] = "ASC", e[e.DESC = 1] = "DESC";
}(se || (se = {}));

var ue = function ue(e) {
  var t = "sort";
  return e.selected && e.sortOrder === se.DESC ? t = "sort-amount-desc" : e.selected && e.sortOrder === se.ASC && (t = "sort-amount-asc"), a.createElement("th", {
    onClick: e.onClick
  }, e.label, " ", a.createElement("i", {
    className: "fa fa-" + t
  }));
},
    de = function de(e, t) {
  return e === t ? 0 : e ? t && e > t ? 1 : -1 : 1;
},
    Ee = function Ee(e, t) {
  return void 0 === e && (e = ""), void 0 === t && (t = ""), s.DateTime.fromISO(t).diff(s.DateTime.fromISO(e), "milliseconds").milliseconds;
},
    pe = Math.min(150, 150) / 2,
    Ne = d.arc().outerRadius(pe - 10).innerRadius(pe - 30),
    Ce = [{
  name: "AUTO REPAIR",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "BEAUTY SALON",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "CHURCH OR RELIGIOUS ORGANIZATION",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "CONSTRUCTION, COMMERCIAL",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "CONSTRUCTION, RESIDENTAL",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "DRY CLEANERS",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "EMBROIDERY AND ENGRAVING",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "EQUIPMENT RENTAL",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "FARMING/AGRICULTURAL",
  status: "RESTRICTED",
  color: "text-danger"
}, {
  name: "GAMING/GAMBLING",
  status: "RESTRICTED",
  color: "text-danger"
}, {
  name: "GAS STATION/C-STORE",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "GROCERY STORE",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "GYM OR FITNESS FACILITY",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "HOME HEALTH CARE",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "HOTEL/MOTEL",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "INSURANCE AGENT OR BROKER",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "LANDSCAPING",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "LOGGING",
  status: "RESTRICTED",
  color: "text-danger"
}, {
  name: "MANUFACTURING",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "MEDICAL, DENTAL SERVICES",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "MINING",
  status: "RESTRICTED",
  color: "text-danger"
}, {
  name: "MISCELLANEOUS BUSINESS SERVICES",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "MUNICIPALITY",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "OIL & GAS EXPLORATION",
  status: "RESTRICTED",
  color: "text-danger"
}, {
  name: "PHARMACY",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "PLUMBING",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "PRINTING",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "REFUSE COLLECTION",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "RESTAURANT/ FOOD SERVICE",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "RETAIL- VARIETY STORE",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "SOFTWARE DEVELOPER",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "SPA/MEDI-SPA",
  status: "BEAUTY SALON OKAY, OTHERWISE RESTRICTED",
  color: "text-warning"
}, {
  name: "TANNING SALON",
  status: "RESTRICTED",
  color: "text-danger"
}, {
  name: "TATTOO/PIERCING SHOP",
  status: "RESTRICTED",
  color: "text-danger"
}, {
  name: "TELECOMMUNICATIONS",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "TRUCKING, LOCAL",
  status: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "TRUCKING, LONG-DISTANCE",
  status: "RESTRICTED",
  color: "text-danger"
}, {
  name: "VENDING ROUTE OPERATOR",
  status: "RESTRICTED",
  color: "text-danger"
}, {
  name: "OTHER",
  status: "CONTACT US TO DISCUSS",
  color: "text-warning"
}],
    fe = Ce.map(function (e) {
  return {
    label: e.name,
    value: e.name
  };
}),
    Te = [{
  name: "ATM MACHINES",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "ATV (QUAD)/SNOWMOBILES",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "AIRCRAFT/WATERCRAFT/RAILROAD",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "AUTOMOTIVE REPAIR",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "AWNINGS",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "BIOFEEDBACK MACHINES",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "CELLULAR PHONES",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "CLEANING",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "COMMERCIAL LAUNDRY",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "COMPUTER/IT EQUIPMENT",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY; USED IS RESTRICTED",
  color: "text-success"
}, {
  name: "CONSTRUCTION",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "CONTAINERS",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "COPIERS",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "CREDIT CARD TERMINALS",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "CREMATORIUMS",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "DIALERS",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "ELECTRONIC EQUIPMENT",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "EMBROIDERY / ENGRAVING ",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "ENERGY MANAGEMENT",
  message: "LED ACCEPTED, SOLAR IS RESTRICTED; FINANCE AGREEMENT ONLY",
  color: "text-warning"
}, {
  name: "EQUIPMENT REFINANCES",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "EXPENDABLES",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "FARM EQUIPMENT",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "FITNESS / RECREATION",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "FLOATING DOCKS",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "FURNITURE / FURNISHINGS",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "GAMING DEVICES",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "GAS PUMPS AND/OR TANKS",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY; INSURANCE REQUIRED PRIOR TO FUNDING",
  color: "text-success"
}, {
  name: "HAZARDOUS MATERIALS HANDLING EQUIPMENT",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "HEATING / AIR EQUIPMENT",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "ICE CREAM / YOGURT MACHINES",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "INDUSTRIAL",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "INFLATABLES",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "INVENTORY",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "LANDSCAPE / GARDENING",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "LASERS",
  message: "CAUTIONARY, CONTACT US TO DISCUSS FURTHER",
  color: "text-warning"
}, {
  name: "LEASEHOLD IMPROVEMENTS",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "LIVESTOCK",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "MACHINE TOOLS ",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "MEDICAL",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "MINING",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "NUCLEAR/TOXIC WASTE EQUIPMENT/CONTAINERS",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "PAGERS",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "PLUMBING EQUIPMENT",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "POINT OF SALE",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "POOL EQUIPMENT",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "PORTABLE AND/OR METAL  BUILDINGS",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "PORTABLE TOILETS",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "PRINTERS",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "RESTAURANT EQUIPMENT ",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "RV'S/MOBILE HOMES",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "SALE LEASEBACKS",
  message: "RESTRICTED IF OVER 60 DAYS SINCE PURCHASE",
  color: "text-success"
}, {
  name: "SALON EQUIPMENT",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "SECURITY SYSTEMS",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "SIGNS",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "SOFTWARE",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "SOLAR PANELS",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "TANNING BEDS",
  message: "RESTRICTED",
  color: "text-danger"
}, {
  name: "TELECOMMUNICATION EQUIP.",
  message: "ACCEPTABLE, FINANCE AGREEMENT ONLY",
  color: "text-success"
}, {
  name: "TESTING & MEASUREMENT",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "TITLED VEHICLES",
  message: "VOCATIONAL VEHICLES ACCEPTABLE, PERSONAL VEHICLES AND SLEEPER CABS RESTRICTED",
  color: "text-warning"
}, {
  name: "VENDING",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "WATER COOLERS",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "WATER SYSTEMS",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "WOODWORKING",
  message: "ACCEPTABLE",
  color: "text-success"
}, {
  name: "OTHER",
  message: "CONTACT US TO DISCUSS",
  color: "text-danger"
}],
    ve = Te.map(function (e) {
  return {
    label: e.name,
    value: e.name
  };
}),
    ge = function ge(e) {
  var t = e.isCorporate,
      r = e.label,
      l = e.selected,
      c = e.onChange,
      s = e.guarantors[l],
      i = Object.values(s).some(function (e) {
    return !!e;
  }),
      m = e.errors[l] || {},
      u = function u() {
    var t = e.onAddGuarantor,
        r = e.onRemoveGuarantor,
        l = e.onEditGuarantor,
        c = e.errors,
        s = e.isCorporate;
    return a.createElement(a.Fragment, null, a.createElement("table", {
      className: "table table-sm"
    }, a.createElement("tbody", null, e.guarantors.map(function (e, t) {
      return a.createElement("tr", {
        key: t
      }, a.createElement("td", {
        className: n("pl-3", {
          "text-danger": !!c[t] || o.isEmpty(c[t])
        })
      }, s ? e.company_name ? e.company_name : "" : (e.first_name ? e.first_name : "") + " " + (e.last_name ? e.last_name : ""), !!c[t] && a.createElement("i", {
        className: "fa fa-exclamation-triangle"
      })), a.createElement("td", {
        className: "text-right"
      }, a.createElement(N, {
        className: "mr-1",
        small: !0,
        onClick: function onClick() {
          return l(t);
        }
      }, a.createElement("i", {
        className: "fa fa-edit"
      }), "Edit"), a.createElement(N, {
        small: !0,
        onClick: function onClick() {
          return r(t);
        }
      }, a.createElement("i", {
        className: "fa fa-close"
      }), "remove")));
    }))), a.createElement("div", {
      className: "row justify-content-end mb-2"
    }, a.createElement("div", {
      className: "col-auto mr-2"
    }, a.createElement(N, {
      onClick: t
    }, a.createElement("i", {
      className: "fa fa-plus",
      style: {
        marginRight: "10px"
      }
    }), "Add Guarantor"))));
  };

  return s ? a.createElement(f, {
    heading: r,
    footer: u(),
    key: l,
    style: e.style,
    className: e.className
  }, t ? a.createElement(D, {
    label: "Federal Tax ID"
  }, a.createElement(re, {
    type: "tid",
    name: "tax_id",
    placeholder: "",
    value: s.tax_id,
    onChange: function onChange(e) {
      return c(l, {
        tax_id: e
      });
    },
    error: m.tax_id
  })) : a.createElement(D, {
    required: i,
    label: "SSN"
  }, a.createElement(re, {
    type: "ssn",
    name: "snn",
    placeholder: "",
    value: s.ssn,
    onChange: function onChange(e) {
      return c(l, {
        ssn: e
      });
    },
    error: m.ssn,
    required: i
  })), t ? a.createElement(D, {
    label: "Company Name"
  }, a.createElement(re, {
    name: "company_name",
    placeholder: "",
    value: s.company_name,
    onChange: function onChange(e) {
      return c(l, {
        company_name: e
      });
    },
    error: m.company_name
  })) : a.createElement(a.Fragment, null, a.createElement(D, {
    required: i,
    label: "First Name"
  }, a.createElement(re, {
    name: "first_name",
    placeholder: "",
    value: s.first_name,
    onChange: function onChange(e) {
      return c(l, {
        first_name: e
      });
    },
    error: m.first_name,
    required: i
  })), a.createElement(D, {
    label: "Middle Initial"
  }, a.createElement(re, {
    name: "middle_initial",
    placeholder: "",
    value: s.middle_initial,
    onChange: function onChange(e) {
      return c(l, {
        middle_initial: e
      });
    },
    error: m.middle_initial
  })), a.createElement(D, {
    required: i,
    label: "Last Name"
  }, a.createElement(re, {
    name: "last_name",
    placeholder: "",
    value: s.last_name,
    onChange: function onChange(e) {
      return c(l, {
        last_name: e
      });
    },
    error: m.last_name,
    required: i
  }))), a.createElement(D, {
    required: i,
    label: "Street Number"
  }, a.createElement(re, {
    name: "street_number",
    type: "street-number",
    placeholder: "",
    value: s.street_number,
    onChange: function onChange(e) {
      return c(l, {
        street_number: e
      });
    },
    error: m.street_number,
    required: i
  })), a.createElement(D, {
    required: i,
    label: "Street Name"
  }, a.createElement(re, {
    name: "street_name",
    placeholder: "",
    value: s.street_name,
    onChange: function onChange(e) {
      return c(l, {
        street_name: e
      });
    },
    error: m.street_name,
    required: i
  })), a.createElement(D, {
    label: "Street Type"
  }, a.createElement(re, {
    name: "street_type",
    type: "street-type",
    value: s.street_type,
    onChange: function onChange(e) {
      return c(l, {
        street_type: e
      });
    },
    error: m.street_type
  })), a.createElement(D, {
    required: i,
    label: "Zip Code"
  }, a.createElement(I, {
    name: "zip",
    placeholder: "",
    value: s.zip,
    onChange: function onChange(e) {
      return c(l, {
        zip: e
      });
    },
    onCityChange: function onCityChange(e) {
      return c(l, {
        city: e
      });
    },
    onStateChange: function onStateChange(e) {
      return c(l, {
        state: e
      });
    },
    error: m.zip,
    required: i
  })), a.createElement(D, {
    required: i,
    label: "City"
  }, a.createElement(re, {
    readOnly: !0,
    name: "city",
    placeholder: "",
    value: s.city,
    onChange: function onChange(e) {
      return c(l, {
        city: e
      });
    },
    error: m.city,
    required: i
  })), a.createElement(D, {
    required: i,
    label: "State"
  }, a.createElement(re, {
    readOnly: !0,
    type: "state",
    name: "state",
    value: s.state,
    onChange: function onChange(e) {
      return c(l, {
        state: e
      });
    },
    error: m.state,
    required: i
  })), a.createElement(D, {
    label: t ? "Phone" : "Cell Phone"
  }, a.createElement(re, {
    type: "tel",
    name: "phone",
    value: s.phone,
    onChange: function onChange(e) {
      return c(l, {
        phone: e
      });
    },
    error: m.phone
  })), a.createElement(D, {
    label: "Email"
  }, a.createElement(re, {
    name: "email",
    type: "email",
    placeholder: "",
    value: s.email,
    onChange: function onChange(e) {
      return c(l, {
        email: e
      });
    },
    error: m.email
  })), !t && a.createElement(D, {
    label: "% Ownership"
  }, a.createElement(re, {
    type: "number",
    name: "ownership",
    placeholder: "",
    value: s.ownership,
    onChange: function onChange(e) {
      return c(l, {
        ownership: e
      });
    },
    min: 0,
    max: 100,
    error: m.ownership
  })), !!t && a.createElement(a.Fragment, null, a.createElement(D, {
    label: "Authorized Signer"
  }, a.createElement(re, {
    name: "signer",
    value: s.signer,
    onChange: function onChange(e) {
      return c(l, {
        signer: e
      });
    },
    error: m.signer
  })), a.createElement(D, {
    label: "Signer Title"
  }, a.createElement(re, {
    name: "signer_title",
    value: s.signer_title,
    onChange: function onChange(e) {
      return c(l, {
        signer_title: e
      });
    },
    error: m.signer_title
  })))) : a.createElement(f, {
    heading: r,
    footer: u()
  });
};

ge.defaultProps = {
  isCorporate: !1,
  label: "Guarantor Information"
};

var he = function he(e) {
  var t = e.asset,
      n = e.errors,
      r = e.onChange,
      l = e.vendors,
      o = void 0 === l ? [] : l,
      c = [].concat(o.map(function (e) {
    return {
      label: e.display_name + " — (" + e.vendor_status + ")",
      value: e.id
    };
  }), [{
    label: "OTHER",
    value: "OTHER"
  }]);
  return a.createElement(f, {
    heading: "Equipment Information",
    className: e.className,
    style: e.style
  }, a.createElement(D, {
    required: !0,
    label: "Equipment Financed"
  }, a.createElement(re, {
    type: "textarea",
    required: !0,
    name: "asset_type",
    value: t.asset_type || "",
    onChange: function onChange(e) {
      return r({
        asset_type: e
      });
    },
    error: n.asset_type
  })), a.createElement(D, {
    required: !0,
    label: "Quantity"
  }, a.createElement(re, {
    required: !0,
    type: "number",
    min: 1,
    name: "quantity",
    value: t.quantity || 1,
    onChange: function onChange(e) {
      return r({
        quantity: e
      });
    },
    error: n.quantity
  })), a.createElement(D, {
    required: !0,
    label: "Equipment Cost"
  }, a.createElement(re, {
    required: !0,
    type: "currency",
    name: "cost",
    value: t.cost,
    onChange: function onChange(e) {
      return r({
        cost: e
      });
    },
    error: n.cost
  })), a.createElement(D, {
    label: "Serial/VIN"
  }, a.createElement(re, {
    name: "serial_number",
    value: t.serial_number || "",
    onChange: function onChange(e) {
      return r({
        serial_number: e
      });
    },
    error: n.serial_number
  })), e.titledVehicleField && a.createElement(D, {
    required: !0,
    label: "Is This a Titled Vehicle or Private Sale Transaction?"
  }, a.createElement(re, {
    required: !0,
    name: "titled_vehicle",
    type: "boolean",
    value: t.titled_vehicle,
    onChange: function onChange(e) {
      return r({
        titled_vehicle: e
      });
    },
    options: [{
      label: "Yes",
      value: !0
    }, {
      label: "No",
      value: !1
    }],
    error: n.titled_vehicle
  })), 0 !== o.length && a.createElement(D, {
    required: !0,
    label: "Select Vendor"
  }, a.createElement(re, {
    name: "vendor_id",
    value: t.vendor_id,
    onChange: function onChange(e) {
      return r({
        vendor_id: e
      });
    },
    type: "select",
    required: !0,
    options: c
  })), "OTHER" === t.vendor_id && a.createElement(a.Fragment, null, a.createElement(D, {
    required: !0,
    label: "Vendor Name"
  }, a.createElement(re, {
    required: !0,
    name: "vendor_name",
    value: t.vendor_name || "",
    onChange: function onChange(e) {
      return r({
        vendor_name: e
      });
    },
    error: n.vendor_name
  })), a.createElement(D, {
    required: !0,
    label: "Vendor Phone"
  }, a.createElement(re, {
    required: !0,
    type: "tel",
    name: "vendor_phone",
    value: t.vendor_phone || "",
    onChange: function onChange(e) {
      return r({
        vendor_phone: e
      });
    },
    error: n.vendor_phone
  })), a.createElement(D, {
    required: !0,
    label: "Vendor Address"
  }, a.createElement(re, {
    required: !0,
    name: "vendor_address",
    value: t.vendor_address || "",
    onChange: function onChange(e) {
      return r({
        vendor_address: e
      });
    },
    error: n.vendor_address
  }))));
};

he.defaultProps = {
  titledVehicleField: !1
};

var ye = function ye(e) {
  var t = e.guarantor,
      r = e.onChange,
      l = e.overrides,
      o = e.onEditClose;
  return t.hidden || l.hidden ? a.createElement("div", {
    className: "row"
  }, a.createElement("p", {
    className: "col-sm-6"
  }, t.first_name ? t.first_name + " " + t.last_name + " " : "Guarantor ", "is hidden."), a.createElement("div", {
    className: "col-sm-6"
  }, a.createElement(N, {
    primary: !0,
    onClick: e.onToggleHidden
  }, "Unhide Guarantor")), a.createElement("hr", null)) : a.createElement(a.Fragment, null, a.createElement("dl", {
    className: n("row app-detail-list", e.className),
    style: e.style
  }, !e.corporate && a.createElement(a.Fragment, null, a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, " First Name "), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "first_name",
    onChange: function onChange(e) {
      return r({
        first_name: e
      });
    },
    onEditClose: o,
    value: t.first_name,
    override: l.first_name,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, " Middle I "), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "middle_initial",
    onChange: function onChange(e) {
      return r({
        middle_initial: e
      });
    },
    onEditClose: o,
    value: t.middle_initial,
    override: l.middle_initial,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, " Last Name "), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "last_name",
    onChange: function onChange(e) {
      return r({
        last_name: e
      });
    },
    onEditClose: o,
    value: t.last_name,
    override: l.last_name,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, " Email "), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "email",
    onChange: function onChange(e) {
      return r({
        email: e
      });
    },
    value: t.email,
    onEditClose: o,
    override: l.email,
    editable: !0
  }))), !!e.corporate && a.createElement(a.Fragment, null, a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Company Name"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "company_name",
    onChange: function onChange(e) {
      return r({
        company_name: e
      });
    },
    onEditClose: o,
    value: t.company_name,
    override: l.company_name,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Tax Id"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "tax_id",
    type: "tid",
    onChange: function onChange(e) {
      return r({
        tax_id: e
      });
    },
    onEditClose: o,
    value: t.tax_id,
    override: l.tax_id,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Authorized Signer"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "authorized_signer",
    onChange: function onChange(e) {
      return r({
        signer: e
      });
    },
    onEditClose: o,
    value: t.signer,
    override: l.signer,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Title"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "signer_title",
    onChange: function onChange(e) {
      return r({
        signer_title: e
      });
    },
    onEditClose: o,
    value: t.signer_title,
    override: l.signer_title,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Email"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "email",
    onChange: function onChange(e) {
      return r({
        email: e
      });
    },
    onEditClose: o,
    value: t.email,
    override: l.email,
    editable: !0
  })))), a.createElement(N, {
    onClick: e.onToggleHidden
  }, "Hide Guarantor"));
};

ye.defaultProps = {
  overrides: {}
};

var Ae = function Ae(e) {
  var t = e.asset,
      r = e.onChange,
      l = e.onEditClose,
      o = e.overrides,
      c = e.vendors,
      s = void 0 === c ? [] : c,
      i = [].concat(s.map(function (e) {
    return {
      label: e.display_name + " — (" + e.vendor_status + ")",
      value: e.id
    };
  }), [{
    label: "OTHER",
    value: "OTHER"
  }]),
      m = o.vendor_id || t.vendor_id || "";
  return a.createElement("dl", {
    className: n("row app-detail-list", e.className),
    style: e.style
  }, a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Equipment"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    type: "textarea",
    name: "description",
    onChange: function onChange(e) {
      return r({
        description: e
      });
    },
    onEditClose: l,
    value: t.description,
    override: o.description,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Quantity"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "quantity",
    type: "number",
    onChange: function onChange(e) {
      return r({
        quantity: e
      });
    },
    onEditClose: l,
    value: t.quantity,
    override: o.quantity,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Estimated Cost"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "cost",
    type: "currency",
    onChange: function onChange(e) {
      return r({
        cost: e
      });
    },
    onEditClose: l,
    value: t.cost,
    override: o.cost,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Serial/VIN"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "serial_number",
    onChange: function onChange(e) {
      return r({
        serial_number: e
      });
    },
    onEditClose: l,
    value: t.serial_number,
    override: o.serial_number,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Street Address"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "street",
    onChange: function onChange(e) {
      return r({
        street: e
      });
    },
    onEditClose: l,
    value: t.street,
    override: o.street,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Zipcode"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "zip",
    type: "zip",
    onChange: function onChange(e) {
      return r({
        zip: e
      });
    },
    onEditClose: l,
    value: t.zip,
    override: o.zip,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "City"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "city",
    onChange: function onChange(e) {
      return r({
        city: e
      });
    },
    onEditClose: l,
    value: t.city,
    override: o.city,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "State"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "state",
    type: "state",
    onChange: function onChange(e) {
      return r({
        state: e
      });
    },
    onEditClose: l,
    value: t.state,
    override: o.state,
    editable: !0
  })), 0 !== s.length && a.createElement(a.Fragment, null, a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Vendor"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "vendor_id",
    value: m,
    onEditClose: l,
    onChange: function onChange(e) {
      return r({
        vendor_id: e
      });
    },
    type: "select",
    options: i,
    override: o.vendor_id,
    editable: !0
  }))), ("OTHER" === o.vendor_id || "OTHER" === t.vendor_id) && a.createElement(a.Fragment, null, a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Vendor Name"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "vendor_name",
    value: t.vendor_name || "",
    onChange: function onChange(e) {
      return r({
        vendor_name: e
      });
    },
    onEditClose: l,
    override: o.vendor_name,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Vendor Phone"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    type: "tel",
    name: "vendor_phone",
    value: t.vendor_phone || "",
    onChange: function onChange(e) {
      return r({
        vendor_phone: e
      });
    },
    onEditClose: l,
    override: o.vendor_phone,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Vendor Address"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "vendor_address",
    onChange: function onChange(e) {
      return r({
        vendor_address: e
      });
    },
    value: t.vendor_address || "",
    onEditClose: l,
    override: o.vendor_address,
    editable: !0
  }))));
};

Ae.defaultProps = {
  overrides: {}
};

var be = function be(e) {
  var t = e.onChange,
      r = e.reimbursement,
      l = e.onEditClose,
      o = e.overrides;
  return a.createElement("dl", {
    className: n("row app-detail-list", e.className),
    style: e.style
  }, a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Vendor Name"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "vendor_name",
    onChange: function onChange(e) {
      return t({
        vendor_name: e
      });
    },
    onEditClose: l,
    value: r.vendor_name,
    override: o.vendor_name,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Bill Type"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "bill_type",
    onChange: function onChange(e) {
      return t({
        bill_type: e
      });
    },
    type: "select",
    options: [{
      label: "Invoice",
      value: "Invoice"
    }, {
      label: "Quote",
      value: "Quote"
    }, {
      label: "Estimate",
      value: "Estimate"
    }, {
      label: "Proforma",
      value: "Proforma"
    }, {
      label: "Other",
      value: "Other"
    }],
    onEditClose: l,
    value: r.bill_type,
    override: o.bill_type,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "# Paid By Customer"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "number_paid",
    onChange: function onChange(e) {
      return t({
        number_paid: e
      });
    },
    onEditClose: l,
    value: r.number_paid,
    override: o.number_paid,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Date Paid By Customer"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "date_paid",
    type: "date",
    onChange: function onChange(e) {
      return t({
        date_paid: e
      });
    },
    value: r.date_paid,
    onEditClose: l,
    override: o.date_paid,
    editable: !0
  })));
};

be.defaultProps = {
  overrides: {}
};

var Se = function Se(e) {
  var t,
      n = e.event;

  switch (n.status) {
    case "success":
      t = a.createElement("span", {
        className: "label label-success"
      }, n.status);
      break;

    case "error":
    case "failure":
      t = a.createElement("span", {
        className: "label label-danger"
      }, n.status);
      break;

    default:
      t = n.status;
  }

  return a.createElement("tr", {
    key: n.uploaded_at
  }, a.createElement("td", null, s.DateTime.fromISO(n.uploaded_at).toLocaleString()), a.createElement("td", null, t), a.createElement("td", null, n.name));
},
    Re = function Re(e) {
  return a.createElement(E, {
    style: {
      border: "none",
      height: "auto"
    },
    onDrop: e.onUpload
  }, function () {
    return a.createElement("a", {
      className: "btn btn-default btn-block"
    }, a.createElement("i", {
      className: "fa fa-upload"
    }), " Upload Attachment");
  });
},
    Ie = function Ie(e) {
  var t = e.overrides;
  return T({}, e, void 0 === t ? {} : t, {
    assets: Oe(e),
    guarantors: _e(e, !1),
    corp_guarantors: _e(e, !0)
  });
},
    Oe = function Oe(e) {
  for (var t = [], a = e.overrides, n = e.assets, r = void 0 === n ? [] : n, l = (void 0 === a ? {} : a).assets, o = void 0 === l ? [] : l, c = Math.max(r.length, o.length), s = 0; s < c; ++s) {
    (r[s] || o[s]) && (t[s] = T({}, r[s], o[s]));
  }

  return t;
},
    _e = function _e(e, t) {
  for (var a = [], n = e.overrides, r = void 0 === n ? {} : n, l = (t ? e.corp_guarantors : e.guarantors) || [], o = (t ? r.corp_guarantors : r.guarantors) || [], c = Math.max(l.length, o.length), s = 0; s < c; ++s) {
    (l[s] || o[s]) && (a[s] = T({}, l[s], o[s]));
  }

  return a;
},
    Pe = function Pe(e) {
  return a.createElement("div", {
    className: n("row align-items-baseline mx-3", e.className),
    style: e.style
  }, a.createElement("label", {
    className: "col-auto control-label text-right h4 mt-3"
  }, e.label), a.createElement("div", {
    className: "col form-group"
  }, a.createElement("span", {
    className: "input-group input-group-lg"
  }, a.createElement("div", {
    className: "input-group-prepend"
  }, a.createElement("span", {
    className: "input-group-text"
  }, "$")), a.createElement(re, {
    name: "quoter-equipment-cost",
    type: "number",
    onChange: function onChange(t) {
      return e.onChange(t);
    },
    value: e.value,
    placeholder: "100,000"
  }))));
},
    De = function De(e) {
  return a.createElement(f, {
    style: e.style,
    className: e.className
  }, a.createElement("div", {
    className: "row justify-content-between mx-3"
  }, 0 !== e.products.length && a.createElement("div", {
    className: "col-auto"
  }, a.createElement("div", {
    className: "btn-group border rounded"
  }, e.products.map(function (t) {
    return a.createElement(N, {
      key: t,
      primary: e.selectedProducts.includes(t),
      onClick: function onClick() {
        return e.onProductToggle(t);
      },
      className: "px-5"
    }, t);
  }))), a.createElement("div", {
    className: "col-auto"
  }, a.createElement("div", {
    className: "btn-group border rounded"
  }, e.terms.map(function (t) {
    return a.createElement(N, {
      key: t,
      primary: e.selectedTerms.includes(t),
      onClick: function onClick() {
        return e.onTermToggle(t);
      },
      className: "px-3"
    }, t);
  })))));
},
    Le = function Le(e) {
  return a.createElement(f, {
    style: e.style,
    className: e.className
  }, a.createElement("div", {
    className: "text-center"
  }, e.term + " Month Equipment " + e.category, e.footnotes && a.createElement("sup", null, e.footnotes)), a.createElement("div", {
    className: "my-2",
    style: {
      borderTop: "2px solid " + (e.selected ? "#ffb606" : "#e4e5e7")
    }
  }), a.createElement("div", {
    className: n("my-4 font-weight-bold text-center h4", {
      "text-muted": !e.selected
    })
  }, r.formatMoney(e.cost)), a.createElement(N, {
    onClick: e.onToggle,
    primary: e.selected,
    secondary: !e.selected,
    block: !0
  }, e.selected ? "Deselect" : "Select"));
},
    Me = function Me(e) {
  return a.createElement(f, {
    className: n("bg-light text-muted", e.className),
    style: e.style
  }, a.createElement("sup", null, e.number), e.children);
},
    xe = function xe(e) {
  for (var t = +e.max > 10 ? 10 : +e.max, r = [], l = 0; l < t + 1; l++) {
    r.push({
      label: l.toString(),
      value: l
    });
  }

  return a.createElement("div", {
    className: n("row align-items-baseline", e.className),
    style: e.style
  }, a.createElement("div", {
    className: "form-group col"
  }, a.createElement("label", {
    className: ""
  }, "Points"), a.createElement(re, {
    name: "quoter_points",
    onChange: e.onChange,
    type: "select",
    options: r,
    value: e.value,
    min: e.min,
    max: e.max
  })));
};

function Ue(e, t) {
  try {
    var a = e();
  } catch (e) {
    return t(e);
  }

  return a && a.then ? a.then(void 0, t) : a;
}

"undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))), "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));

var Fe = {
  name: "",
  first_name: "",
  last_name: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  phone: "",
  email: "",
  slug: ""
},
    Ge = function Ge(e, t) {
  var a = e.customer,
      n = e.vendor,
      r = e.estimates;

  switch (t.type) {
    case "update":
      return T({}, e, t.payload);

    case "toggleMonthlyPassthrough":
      return T({}, e, {
        showMonthlyPassthrough: !e.showMonthlyPassthrough
      });

    case "updateCustomer":
      return T({}, e, {
        customer: T({}, a, t.payload)
      });

    case "updateVendor":
      return T({}, e, {
        vendor: T({}, n, t.payload)
      });

    case "clearSelection":
      return T({}, e, {
        estimates: r.map(function (e) {
          return T({}, e, {
            selected: !1
          });
        })
      });

    case "toggleEstimate":
      return T({}, e, {
        estimates: r.map(function (e, a) {
          return a === t.payload ? T({}, e, {
            selected: !e.selected
          }) : e;
        })
      });

    case "toggleTerm":
      return T({}, e, {
        estimates: r.map(function (e) {
          return e.term === t.payload ? T({}, e, {
            selected: !e.selected
          }) : e;
        })
      });

    case "toggleProduct":
      return T({}, e, {
        estimates: r.map(function (e) {
          return e.product === t.payload ? T({}, e, {
            selected: !e.selected
          }) : e;
        })
      });

    case "setEstimates":
      return T({}, e, {
        estimates: t.payload
      });

    case "quoteSuccess":
      return T({}, e, {
        success: t.payload
      });

    case "setQuoteVendor":
      return T({}, e, {
        quoteVendor: t.payload
      });

    default:
      return e;
  }
},
    we = {
  customer: {},
  vendor: {},
  taxRate: 21,
  showMonthlyPassthrough: !1,
  valid: !0,
  estimates: [],
  formattedEstimates: "",
  section179Active: !1,
  pdfUrl: ""
},
    ke = "";

switch (process.env.REACT_APP_STAGE) {
  case "production":
    ke = "https://navitex.navitascredit.com/api/v2";
    break;

  case "demo":
    ke = "https://navitex-demo.navitascredit.com/api/v2";
    break;

  default:
    ke = "http://localhost:4000/api/v2";
}

var qe = function qe(e, t) {
  return o.isEmpty(e) ? "" : "&" + t + "[name]=" + (e.name || '""') + "&" + t + "[first_name]=" + (e.first_name || '""') + "&" + t + "[last_name]=" + (e.last_name || '""') + "&" + t + "[address]=" + (e.address || '""') + "&" + t + "[city]=" + (e.city || '""') + "&" + t + "[state]=" + (e.state || '""') + "&" + t + "[zip]=" + (e.zip || '""') + "&" + t + "[phone]=" + (e.phone || '""') + "&" + t + "[email]=" + (e.email || '""');
},
    Be = function Be() {
  return a.createElement("div", {
    className: "rainbow-divider"
  }, a.createElement("div", {
    className: "blue"
  }), a.createElement("div", {
    className: "teal"
  }), a.createElement("div", {
    className: "green"
  }));
},
    Ve = function Ve(e) {
  var t = e.update,
      n = e.updateAndGetEstimates,
      r = a.createElement(D, {
    label: "Additional Monthly Fees Billed (service, maintenance, usage, etc.)",
    className: "no-print"
  }, a.createElement(re, {
    name: "monthlyPassthrough",
    type: "currency",
    value: e.monthlyPassthrough,
    onChange: function onChange(e) {
      return n({
        monthlyPassthrough: e
      });
    }
  })),
      l = a.createElement(N, {
    secondary: !0,
    onClick: function onClick() {
      return t({
        showMonthlyPassthrough: !0
      });
    }
  }, "Add Monthly Charges");
  return a.createElement("div", {
    className: "equipment card no-print"
  }, a.createElement("div", {
    className: "subheader"
  }, a.createElement("span", null, "Payment Quote Summary")), a.createElement(Be, null), a.createElement(D, {
    label: "Transaction Cost"
  }, a.createElement(re, {
    name: "amount",
    type: "currency",
    value: e.amount,
    onChange: function onChange(t) {
      return n({
        amount: t,
        points: e.points
      });
    }
  })), e.enablePoints && a.createElement(xe, {
    className: "w-25",
    value: e.points || 0,
    onChange: function onChange(e) {
      return n({
        points: e
      });
    },
    min: 0,
    max: e.maxPoints || 0
  }), e.enableMonthlyPassthrough && (e.showMonthlyPassthrough ? r : l), a.createElement(N, {
    secondary: !0,
    className: "my-2",
    onClick: function onClick() {
      return t({
        section179Active: !e.section179Active
      });
    }
  }, "Section 179 Tax Savings"));
},
    Ye = o.range(0, 100).map(function (e) {
  return {
    value: e,
    label: e + "%"
  };
}),
    He = function He(e) {
  var t = e.taxRate,
      n = e.amount,
      l = void 0 === n ? 0 : n,
      o = e.updateAndGetEstimates,
      c = ze(l),
      s = l - c,
      i = 0 * (l - c - s),
      m = c + s + i,
      u = m * (t / 100),
      d = l - u;
  return a.createElement("div", {
    className: "section-179 no-print"
  }, a.createElement("div", {
    className: "subheader"
  }, a.createElement("span", null, "IRS Section 179 Write Off & Bonus Depreciation")), a.createElement("table", {
    className: "table table-striped mx-3"
  }, a.createElement("tbody", null, a.createElement("tr", null, a.createElement("td", null, "Transaction Cost"), a.createElement("td", null, r.formatMoney(l))), a.createElement("tr", null, a.createElement("td", {
    className: "d-flex flex-column"
  }, "1st Year Section 179 Write Off", a.createElement("span", {
    className: "small"
  }, "The first year standard depreciation is $0 in 2022 based on an expected 5 year asset life.")), a.createElement("td", null, r.formatMoney(c))), a.createElement("tr", null, a.createElement("td", {
    className: "d-flex flex-column"
  }, "1st Year Bonus Depreciation", a.createElement("span", {
    className: "small"
  }, "The first year bonus depreciation is set at 100% for any amount over the $1,080,000 write off amount in 2022.")), a.createElement("td", null, r.formatMoney(s))), a.createElement("tr", null, a.createElement("td", {
    className: "d-flex flex-column"
  }, "1st Year Standard Depreciation", a.createElement("span", {
    className: "small"
  }, "The first year standard depreciation is $0 in 2022 based on an expected 5 year asset life.")), a.createElement("td", null, r.formatMoney(i))), a.createElement("tr", null, a.createElement("td", null, "Total Deduction In 1st Year"), a.createElement("td", null, r.formatMoney(m))), a.createElement("tr", null, a.createElement("td", {
    className: "d-flex flex-column"
  }, "Potential Tax Savings", a.createElement("span", {
    className: "small"
  }, "Assuming a 21% tax bracket.")), a.createElement("td", null, r.formatMoney(u))), a.createElement("tr", null, a.createElement("td", null, a.createElement("strong", null, "Bottom Line Transaction Cost After Tax Savings")), a.createElement("td", null, r.formatMoney(d))))), a.createElement(D, {
    className: "mx-3",
    horizontal: !0,
    label: "Estimated Federal Tax Rate (Only for Section 179 Savings)"
  }, a.createElement(re, {
    type: "select",
    name: "taxRate",
    value: t,
    onChange: function onChange(e) {
      return void 0 === e && (e = 0), o({
        taxRate: e
      });
    },
    options: Ye
  })));
},
    ze = function ze(e) {
  return e < 1e6 ? e : 1e6 <= e && e <= 25e5 ? 1e6 : 25e5 < e && e <= 35e5 ? 1e6 - (e - 25e5) : 0;
},
    We = function We(e) {
  var t = e.representatives;
  return a.createElement("div", {
    className: e.type + "-profile card col-sm"
  }, a.createElement("div", null, a.createElement("div", {
    className: "subheader contact-header"
  }, a.createElement("span", null, e.label, " Profile")), a.createElement(Be, null)), a.createElement("div", null, t && e.renderReps && a.createElement(D, {
    label: "Representative"
  }, a.createElement(re, {
    name: "representative",
    type: "select",
    options: t.map(function (e) {
      return {
        label: e.first_name + " " + e.last_name,
        value: "" + e.id
      };
    }),
    value: "" + e.contact.id,
    onChange: function onChange(a) {
      void 0 === a && (a = "");
      var n = t.find(function (e) {
        return e.id === +a;
      });
      n && e.onChange(n);
    }
  })), a.createElement(D, {
    required: !0,
    label: "Company Name"
  }, a.createElement(re, {
    name: "company_name",
    value: e.contact.name,
    onChange: function onChange(t) {
      return e.onChange({
        name: t
      });
    },
    required: !0
  })), a.createElement("div", {
    className: "row"
  }, a.createElement(D, {
    label: "First Name",
    className: "col"
  }, a.createElement(re, {
    name: "first_name",
    value: e.contact.first_name,
    onChange: function onChange(t) {
      return e.onChange({
        first_name: t
      });
    },
    disabled: e.disabled
  })), a.createElement(D, {
    label: "Last Name",
    className: "col"
  }, a.createElement(re, {
    name: "last_name",
    value: e.contact.last_name,
    onChange: function onChange(t) {
      return e.onChange({
        last_name: t
      });
    },
    disabled: e.disabled
  }))), a.createElement(D, {
    label: "Address"
  }, a.createElement(re, {
    name: "address",
    value: e.contact.address,
    onChange: function onChange(t) {
      return e.onChange({
        address: t
      });
    },
    disabled: e.disabled
  })), a.createElement("div", {
    className: "row"
  }, a.createElement(D, {
    label: "City",
    className: "col"
  }, a.createElement(re, {
    name: "city",
    value: e.contact.city,
    onChange: function onChange(t) {
      return e.onChange({
        city: t
      });
    },
    disabled: e.disabled
  })), a.createElement(D, {
    label: "State",
    className: "col-4"
  }, a.createElement(re, {
    type: "state",
    name: "state",
    value: e.contact.state,
    onChange: function onChange(t) {
      return e.onChange({
        state: t
      });
    },
    disabled: e.disabled
  }))), a.createElement(D, {
    label: "Zip"
  }, a.createElement(re, {
    name: "zip",
    type: "zip",
    value: e.contact.zip,
    onChange: function onChange(t) {
      return e.onChange({
        zip: t
      });
    },
    disabled: e.disabled
  })), a.createElement("div", {
    className: "row"
  }, a.createElement(D, {
    label: "Phone",
    className: "col"
  }, a.createElement(re, {
    name: "phone",
    type: "phone",
    value: e.contact.phone,
    onChange: function onChange(t) {
      return e.onChange({
        phone: t
      });
    },
    disabled: e.disabled
  })), a.createElement(D, {
    required: !0,
    label: "Email",
    className: "col"
  }, a.createElement(re, {
    name: "email",
    type: "email",
    value: e.contact.email,
    required: !0,
    onChange: function onChange(t) {
      return e.onChange({
        email: t
      });
    },
    disabled: e.disabled
  }))), a.createElement(N, {
    secondary: !0,
    onClick: function onClick() {
      return e.onChange(Fe);
    },
    className: "w-100"
  }, "Clear")));
},
    je = o.uniqBy(o.prop("product")),
    Qe = function Qe(e) {
  var l = e.estimates,
      c = t.useMemo(function () {
    return je(l);
  }, [l]),
      s = t.useMemo(function () {
    return function (e) {
      var t = o.groupBy(o.prop("product"), e),
          a = Object.entries(t),
          n = function n(e, t) {
        return e + ("number" == typeof (a = t.value) ? a : Math.max(a.high, a.low));
        var a;
      };

      return o.sortBy(function (e) {
        var t = e[1];
        return t.reduce(n, 0) / t.length;
      }, a);
    }(l);
  }, [l]);
  return 0 === l.length ? null : a.createElement("div", {
    className: "estimates no-print"
  }, a.createElement("div", {
    className: "subheader"
  }, a.createElement("span", null, "Monthly Payment Options")), a.createElement("p", null, "Click to select the purchase options or the specific terms you would like to print."), s.map(function (t) {
    var l = t[0],
        c = t[1],
        s = c[0].label.split(":"),
        i = s[0],
        m = s[1];
    return a.createElement("table", {
      className: "table",
      key: l
    }, a.createElement("thead", null, a.createElement("tr", null, a.createElement("th", {
      className: "options"
    }, "Terms"), function (e) {
      return o.uniqBy(function (e) {
        return e.term;
      }, e).map(function (e) {
        return e.term;
      }).sort();
    }(c).map(function (t) {
      return a.createElement("th", {
        onClick: function onClick() {
          return e.toggleTerm(t);
        },
        key: t
      }, t);
    }))), a.createElement("tbody", null, a.createElement("tr", null, a.createElement("td", {
      className: "product",
      onClick: function onClick() {
        return e.toggleProduct(l);
      }
    }, a.createElement("p", null, a.createElement("strong", null, i), m && a.createElement("strong", null, ":", m))), o.sortBy(o.prop("term"), c).map(function (t) {
      var l = t.value;
      return a.createElement("td", {
        key: "" + t.term + t.product,
        onClick: function onClick() {
          return e.toggleEstimate(e.estimates.indexOf(t));
        },
        className: n("estimate", {
          selected: t.selected
        })
      }, a.createElement("span", null, "number" == typeof l ? r.formatMoney(l) : r.formatMoney(l.low) + " to " + r.formatMoney(l.high)));
    }))));
  }), c.map(function (e) {
    var t = e.label,
        n = e.description;
    return a.createElement("p", {
      key: t,
      className: "small"
    }, a.createElement("strong", null, t + ": "), n);
  }), a.createElement("div", {
    className: "d-flex"
  }, a.createElement(N, {
    secondary: !0,
    large: !0,
    onClick: e.clearSelection,
    className: "mr-3"
  }, "Clear"), !e.hideCopy && a.createElement(N, {
    secondary: !0,
    large: !0,
    onClick: e.copy
  }, "Copy To Clipboard")));
},
    Ke = function Ke(e) {
  return a.createElement("div", {
    className: "results no-print"
  }, e.success && a.createElement("p", {
    className: "success mb-3"
  }, "You have successfully sent your quote."), a.createElement("div", {
    className: "row mb-3"
  }, !e.hidePrint && a.createElement("div", {
    className: "col"
  }, a.createElement(N, {
    className: "w-100",
    secondary: !0,
    onClick: function onClick() {
      return window.print();
    }
  }, "Print")), a.createElement("div", {
    className: "col"
  }, a.createElement("a", {
    href: e.pdfHref,
    download: !0,
    className: n("btn btn-secondary w-100", {
      disabled: e.disabled
    })
  }, "Download PDF"))), !e.hideSend && a.createElement(N, {
    secondary: !0,
    onClick: e.sendQuote,
    disabled: e.disabled
  }, "Send Quote"));
},
    Ze = function Ze(e) {
  var t = e.state;
  return a.createElement("div", {
    className: "only-print"
  }, a.createElement("h1", null, "Navitex Quoter"), a.createElement("dl", null, a.createElement("dt", null, "Amount"), a.createElement("dd", null, t.amount && r.formatMoney(t.amount)), a.createElement("dt", null, "Tax Rate"), a.createElement("dd", null, t.taxRate, "%"), a.createElement("dt", null, "Description"), a.createElement("dd", null, t.description), a.createElement("dt", null, a.createElement("strong", null, "Customer")), a.createElement("dt", null, "Company Name"), a.createElement("dd", null, t.customer.name), a.createElement("dt", null, "First Name"), a.createElement("dd", null, t.customer.first_name), a.createElement("dt", null, "Last Name"), a.createElement("dd", null, t.customer.last_name), a.createElement("dt", null, "Address"), a.createElement("dd", null, t.customer.address), a.createElement("dt", null, "City"), a.createElement("dd", null, t.customer.city), a.createElement("dt", null, "State"), a.createElement("dd", null, t.customer.state), a.createElement("dt", null, "Zip"), a.createElement("dd", null, t.customer.zip), a.createElement("dt", null, "Phone"), a.createElement("dd", null, t.customer.phone), a.createElement("dt", null, "Email"), a.createElement("dd", null, t.customer.email), a.createElement("dt", null, a.createElement("strong", null, "Selected Estimates")), t.estimates.filter(function (e) {
    return e.selected;
  }).map(function (e) {
    return a.createElement(a.Fragment, {
      key: "" + e.term + e.product
    }, a.createElement("dt", null, e.term, " months ", e.label), a.createElement("dd", null, "Amount:", " ", "number" == typeof e.value ? r.formatMoney(e.value) : r.formatMoney(e.value.low) + " to " + r.formatMoney(e.value.high)));
  })));
};

c.defaults.baseURL = ke;

var Xe,
    $e = function $e(e) {
  return {
    cost: e.amount,
    points: e.points,
    description: e.description,
    tax_rate: e.taxRate,
    state: e.customer.state,
    monthly_passthrough: e.monthlyPassthrough,
    rate_set_id: e.quoteVendor && e.quoteVendor.rate_set_id
  };
},
    Je = function Je(e) {
  var t = e.logo,
      n = e.cobrandLogo,
      r = n || "//" + t;
  return a.createElement(a.Fragment, null, a.createElement("div", {
    className: "row align-items-center justify-content-between mb-3 no-print"
  }, a.createElement("div", {
    className: "col"
  }, a.createElement("img", {
    className: "logo ",
    src: "//webtools.navitascredit.com/images/navitas_credit_corp_logo_color.png",
    alt: "Navitas Credit Corp."
  })), a.createElement("div", {
    className: "col"
  }, a.createElement("h4", {
    className: "text-right"
  }, n || t ? a.createElement("div", {
    className: "m-2",
    style: {
      height: "2rem",
      backgroundImage: "url(" + r + "\n                  )",
      backgroundPosition: "right",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat"
    }
  }) : "Navitas Financing Quoter"))), a.createElement("div", {
    className: "row no-print"
  }, a.createElement("div", {
    className: "col"
  }, a.createElement("h4", null, (n || t) && "Navitas Financing Quoter"))));
},
    et = function et(e) {
  var t = e.required,
      r = e.onChange,
      l = e.description;
  return a.createElement("div", {
    className: "description card no-print"
  }, a.createElement("div", {
    className: "subheader"
  }, a.createElement("span", null, "Transaction Description")), a.createElement(Be, null), a.createElement("p", null, "Please enter a brief description of the transaction or equipment below."), a.createElement(re, {
    name: "description",
    type: "textarea",
    className: n({
      "border border-danger": t
    }),
    value: l,
    onChange: r,
    rows: 2
  }));
},
    tt = function tt() {
  return a.createElement(a.Fragment, null, a.createElement("div", {
    className: "d-flex justify-content-center no-print"
  }, a.createElement("img", {
    className: "logo no-print",
    src: "//webtools.navitascredit.com/images/navitas_credit_corp_logo_color.png",
    alt: ""
  })), a.createElement("div", {
    className: "footer no-print"
  }, a.createElement("div", {
    className: "footer-text"
  }, a.createElement("p", {
    className: "text-center m-0"
  }, "We look forward to helping your company meet all its future financing needs."), a.createElement("p", {
    className: "text-center m-0"
  }, "Navitas Credit Corp. | 203 Fort Wade Road | Suite 300 | Ponte Vedra Beach, FL 32081"))));
};

function at(e) {
  var t = a.useState({
    data: e.initialValues || {},
    errors: {}
  }),
      r = t[0],
      l = t[1],
      c = function c() {
    try {
      return Promise.resolve(e.onSubmit(r.data)).then(function (e) {
        e && l(T({}, r, {
          data: e
        }));
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  function s(t, c, s) {
    void 0 === s && (s = {});
    var i = c.join(".");
    return a.createElement(D, {
      className: n(t._className, {
        "col-sm-6": e.split && c.length <= 1
      }),
      style: t._style,
      label: t._label,
      key: i,
      required: t._required
    }, a.createElement(re, {
      type: t.type,
      name: i,
      onChange: function onChange(e) {
        return l(T({}, r, {
          data: o.assocPath(c, e, r.data)
        }));
      },
      value: o.path(c, r.data),
      error: o.path(c, r.errors),
      disabled: t._disabled,
      hidden: t._hidden,
      max: t._max,
      maxLength: t._maxLength,
      min: t._min,
      options: t._options,
      placeholder: t._placeholder,
      readOnly: t._readOnly,
      required: t._required,
      rows: t._rows,
      step: t._step,
      append: s.append
    }));
  }

  function i(t, c, m) {
    return void 0 === c && (c = []), void 0 === m && (m = {}), t ? a.createElement("div", {
      className: n({
        "form-row": m.nested || e.split && c.length <= 1
      })
    }, Object.entries(t).map(function (t) {
      var m = t[1],
          u = [].concat(c, [t[0]]);
      if (!m) return null;
      var d = m;
      return d._component ? function (e, t) {
        var n = r.data,
            c = t.join("."),
            s = e._component;
        return s ? a.createElement(s, {
          name: c,
          key: c,
          onChange: function onChange(e) {
            return l(T({}, r, {
              data: o.assocPath(t, e, n)
            }));
          },
          value: o.path(t, n),
          error: o.path(t, r.errors),
          required: e._required,
          label: e._label
        }) : null;
      }(d, u) : "objectArray" === d.type || "array" === d.type ? function (t, c) {
        var m = r.data,
            u = c.join("."),
            d = o.path(c, m) || [],
            E = !!t._schema;
        return a.createElement("div", {
          key: u,
          className: n({
            "col-sm-6": e.split && c.length <= 1
          })
        }, t._label && a.createElement("label", {
          htmlFor: u
        }, t._label), t._label && a.createElement("hr", {
          style: {
            padding: 0
          }
        }), d.map(function (e, n) {
          var u = o.over(o.lensPath(c), function (e) {
            return void 0 === e && (e = []), o.remove(n, 1, e);
          }),
              d = a.createElement(N, {
            danger: !0,
            onClick: function onClick() {
              return l(T({}, r, {
                data: u(m)
              }));
            }
          }, "Delete");
          return a.createElement(a.Fragment, {
            key: n
          }, t._schema && i(t._schema, [].concat(c, [n])), t._schema && d, t._subField && s(Object.assign({}, t, {
            type: t._subField,
            label: void 0
          }), [].concat(c, [n]), {
            append: d
          }));
        }), a.createElement("div", null, a.createElement(N, {
          success: !0,
          onClick: function onClick() {
            return l(T({}, r, {
              data: o.assocPath([].concat(c, [d.length]), E ? {} : "", m)
            }));
          }
        }, "Add")));
      }(d, u) : d._schema ? function (t, r) {
        var l = r.join(".");
        return a.createElement("div", {
          className: n({
            "col-sm-6": e.split && r.length <= 1
          }),
          key: l
        }, t._label && a.createElement("label", {
          htmlFor: l
        }, t._label), t._label && a.createElement("hr", {
          style: {
            padding: 0
          }
        }), i(t._schema || void 0, r));
      }(d, u) : s(d, u);
    })) : null;
  }

  return e.nested ? a.createElement(a.Fragment, null, i(e.schema), a.createElement(N, {
    onClick: function onClick() {
      return c();
    },
    success: !0,
    className: "mt-3"
  }, e.submitLabel)) : a.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault(), e.stopPropagation(), c();
    }
  }, i(e.schema), a.createElement(N, {
    submit: !0,
    success: !0,
    className: "mt-3"
  }, e.submitLabel));
}

at.defaultProps = {
  submitLabel: "Submit"
};

var nt = function () {
  function e(e, t) {
    void 0 === e && (e = ""), void 0 === t && (t = ""), this.type = e, this._label = t, this._component = null, this._schema = null, this._required = !1, this._options = [];
  }

  var t = e.prototype;
  return t.label = function (e) {
    return this._label = e, this;
  }, t.className = function (e) {
    return this._className = e, this;
  }, t.disabled = function () {
    return this._disabled = !0, this;
  }, t.hidden = function () {
    return this._hidden = !0, this;
  }, t.maxLength = function (e) {
    return this._maxLength = e, this;
  }, t.max = function (e) {
    return this._max = e, this;
  }, t.min = function (e) {
    return this._min = e, this;
  }, t.range = function (e) {
    var t = e[1];
    return this._min = e[0], this._max = t, this;
  }, t.options = function (e) {
    return this._options = e, this;
  }, t.placeholder = function (e) {
    return this._placeholder = e, this;
  }, t.readOnly = function () {
    return this._readOnly = !0, this;
  }, t.required = function () {
    return this._required = !0, this;
  }, t.rows = function (e) {
    return this._rows = e, this;
  }, t.step = function (e) {
    return this._step = e, this;
  }, t.style = function (e) {
    return this._style = e, this;
  }, t.subField = function (e) {
    return this._subField = e, this;
  }, t.component = function (e) {
    return this._component = e, this;
  }, t.schema = function (e) {
    return this._schema = e, this;
  }, e;
}(),
    rt = {
  boolean: function boolean(e) {
    return new nt("boolean", e);
  },
  color: function color(e) {
    return new nt("color", e);
  },
  currency: function currency(e) {
    return new nt("currency", e);
  },
  date: function date(e) {
    return new nt("date", e);
  },
  email: function email(e) {
    return new nt("email", e);
  },
  multiSelect: function multiSelect(e) {
    return new nt("multi-select", e);
  },
  number: function number(e) {
    return new nt("number", e);
  },
  password: function password(e) {
    return new nt("password", e);
  },
  percent: function percent(e) {
    return new nt("percent", e);
  },
  radio: function radio(e) {
    return new nt("radio", e);
  },
  range: function range(e) {
    return new nt("range", e);
  },
  select: function select(e) {
    return new nt("select", e);
  },
  ssn: function ssn(e) {
    return new nt("ssn", e);
  },
  state: function state(e) {
    return new nt("state", e);
  },
  streetType: function streetType(e) {
    return new nt("streetType", e);
  },
  tel: function tel(e) {
    return new nt("tel", e);
  },
  text: function text(e) {
    return new nt("text", e);
  },
  textarea: function textarea(e) {
    return new nt("textarea", e);
  },
  tid: function tid(e) {
    return new nt("tid", e);
  },
  zip: function zip(e) {
    return new nt("zip", e);
  },
  custom: function custom(e) {
    return new nt().component(e);
  },
  object: function object(e, t) {
    return new nt("object", t).schema(e);
  },
  objectArray: function objectArray(e, t) {
    return new nt("objectArray", t).schema(e);
  },
  array: function array(e, t) {
    return new nt("array", t).subField(e);
  }
};

c.defaults.baseURL = ke;

var lt = function lt(e) {
  var t = e.cobrandLogo;
  return a.createElement(a.Fragment, null, a.createElement("div", {
    className: "row align-items-center justify-content-between mb-3"
  }, a.createElement("div", {
    className: "col"
  }, a.createElement("img", {
    className: "logo",
    src: "//webtools.navitascredit.com/images/navitas_credit_corp_logo_color.png",
    alt: "Navitas Credit Corp."
  })), a.createElement("div", {
    className: "col"
  }, t ? a.createElement("div", {
    style: {
      height: "2rem",
      backgroundImage: "url(" + t + ")",
      backgroundPosition: "right",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat"
    }
  }) : a.createElement("h4", null, "Customer Credit Profile Questionnaire"))), a.createElement("div", {
    className: "row mb-3"
  }, a.createElement("div", {
    className: "col"
  }, t && a.createElement("h4", null, "Customer Credit Profile Questionnaire"))));
},
    ot = [{
  value: "<630",
  label: "630 or Lower"
}, {
  value: "631-660",
  label: "631-660"
}, {
  value: "661-690",
  label: "661-690"
}, {
  value: "691-720",
  label: "691-720"
}, {
  value: ">720",
  label: "720 or Higher"
}],
    ct = [{
  value: ">5",
  label: "5 or More"
}, {
  value: "2-4",
  label: "2-4"
}, {
  value: "1orless",
  label: "1 or Less"
}],
    st = [{
  value: "<5000",
  label: "Less than $5,000"
}, {
  value: "5001-10000",
  label: "$5,001 - $10,000"
}, {
  value: "10001-15000",
  label: "$10,001 - $15,000"
}, {
  value: "15001-25000",
  label: "$15,001 - $25,000"
}, {
  value: ">25000",
  label: "Greater Than $25,000"
}],
    it = [{
  value: "0-23",
  label: "0-23"
}, {
  value: "24-47",
  label: "24-47"
}, {
  value: "48-96",
  label: "48-96"
}, {
  value: ">96",
  label: "More than 96"
}],
    mt = [{
  value: "ALCHOHOL MONITORING SYSTEMS",
  label: "ALCHOHOL MONITORING SYSTEMS"
}, {
  value: "ARCHITECTURAL EQUIPMENT",
  label: "ARCHITECTURAL EQUIPMENT"
}, {
  value: "AUDIO VISUAL",
  label: "AUDIO VISUAL"
}, {
  value: "AUTOMOTIVE",
  label: "AUTOMOTIVE"
}, {
  value: "AWNINGS",
  label: "AWNINGS"
}, {
  value: "BUILDINGS",
  label: "BUILDINGS"
}, {
  value: "CADD SYSTEMS",
  label: "CADD SYSTEMS"
}, {
  value: "CLEANING",
  label: "CLEANING"
}, {
  value: "COMMERCIAL LAUNDRY",
  label: "COMMERCIAL LAUNDRY"
}, {
  value: "COMPUTER EQUIPMENT",
  label: "COMPUTER EQUIPMENT"
}, {
  value: "CONSTRUCTION",
  label: "CONSTRUCTION"
}, {
  value: "CONTAINERS",
  label: "CONTAINERS"
}, {
  value: "COPIERS",
  label: "COPIERS"
}, {
  value: "COURT REPORTING EQUIPMENT",
  label: "COURT REPORTING EQUIPMENT"
}, {
  value: "CREMATORIUMS",
  label: "CREMATORIUMS"
}, {
  value: "ELECTRONIC EQUIPMENT",
  label: "ELECTRONIC EQUIPMENT"
}, {
  value: "EMBROIDERY / ENGRAVING",
  label: "EMBROIDERY / ENGRAVING"
}, {
  value: "ENERGY MANAGEMENT",
  label: "ENERGY MANAGEMENT"
}, {
  value: "FARM EQUIPMENT",
  label: "FARM EQUIPMENT"
}, {
  value: "FITNESS / RECREATION",
  label: "FITNESS / RECREATION"
}, {
  value: "FURNITURE / FURNISHINGS",
  label: "FURNITURE / FURNISHINGS"
}, {
  value: "GAS PUMPS",
  label: "GAS PUMPS"
}, {
  value: "GENERAL OFFICE EQUIPMENT",
  label: "GENERAL OFFICE EQUIPMENT"
}, {
  value: "GENERATORS",
  label: "GENERATORS"
}, {
  value: "GPS",
  label: "GPS"
}, {
  value: "HEATING / AIR EQUIPMENT",
  label: "HEATING / AIR EQUIPMENT"
}, {
  value: "HEAVY MACHINERY",
  label: "HEAVY MACHINERY"
}, {
  value: "INDUSTRIAL",
  label: "INDUSTRIAL"
}, {
  value: "IRRIGATION EQUIPMENT",
  label: "IRRIGATION EQUIPMENT"
}, {
  value: "LANDSCAPE / GARDENING",
  label: "LANDSCAPE / GARDENING"
}, {
  value: "LEASE",
  label: "LEASE"
}, {
  value: "MACHINE TOOLS",
  label: "MACHINE TOOLS"
}, {
  value: "MAILING MACHINES",
  label: "MAILING MACHINES"
}, {
  value: "MEDICAL",
  label: "MEDICAL"
}, {
  value: "MOBILE",
  label: "MOBILE"
}, {
  value: "MUSIC ON HOLD",
  label: "MUSIC ON HOLD"
}, {
  value: "OTHER",
  label: "OTHER"
}, {
  value: "PLUMBING EQUIPMENT",
  label: "PLUMBING EQUIPMENT"
}, {
  value: "POINT OF SALE",
  label: "POINT OF SALE"
}, {
  value: "PORTABLE TOILETS",
  label: "PORTABLE TOILETS"
}, {
  value: "PRESSURE WASHERS",
  label: "PRESSURE WASHERS"
}, {
  value: "PRINTERS",
  label: "PRINTERS"
}, {
  value: "RESTAURANT EQUIPMENT",
  label: "RESTAURANT EQUIPMENT"
}, {
  value: "SALON EQUIPMENT",
  label: "SALON EQUIPMENT"
}, {
  value: "SECURITY SYSTEMS",
  label: "SECURITY SYSTEMS"
}, {
  value: "SIGNS",
  label: "SIGNS"
}, {
  value: "SOFTWARE",
  label: "SOFTWARE"
}, {
  value: "TELECOMMUNICATION EQUIP.",
  label: "TELECOMMUNICATION EQUIP."
}, {
  value: "  TEST & MEASUREMENT",
  label: "  TEST & MEASUREMENT"
}, {
  value: "TITLED VEHICLES",
  label: "TITLED VEHICLES"
}, {
  value: "TRADE SHOW BOOTHS",
  label: "TRADE SHOW BOOTHS"
}, {
  value: "VENDING",
  label: "VENDING"
}, {
  value: "WATER COOLERS",
  label: "WATER COOLERS"
}, {
  value: "WATER SYSTEMS",
  label: "WATER SYSTEMS"
}, {
  value: "WOODWORKING",
  label: "WOODWORKING"
}],
    ut = function ut(e) {
  return a.createElement(f, {
    heading: "Generate Documents",
    style: e.style,
    className: e.className
  }, a.createElement("div", {
    className: "mb-3"
  }, a.createElement("h6", null, "Select document style"), a.createElement("div", {
    className: "row"
  }, a.createElement("div", {
    className: "col-sm-6"
  }, a.createElement(N, {
    success: "generic" === e.docStyle,
    block: !0,
    onClick: function onClick() {
      return e.onStyleChange("generic");
    }
  }, "Generic")), a.createElement("div", {
    className: "col-sm-6"
  }, a.createElement(N, {
    success: "navitas" === e.docStyle,
    block: !0,
    onClick: function onClick() {
      return e.onStyleChange("navitas");
    }
  }, "Navitas")))), a.createElement("h6", null, "Click to select documents for package"), e.documents.map(function (t, n) {
    var r = t.selected,
        l = t.name,
        o = t.editable;
    return a.createElement("div", {
      key: n,
      className: "d-flex btn-group"
    }, a.createElement(N, {
      onClick: function onClick() {
        return e.onToggle(n);
      },
      success: r,
      className: "col text-left"
    }, r ? a.createElement("i", {
      className: "fa fa-check mr-3"
    }) : a.createElement("input", {
      className: "mr-3",
      type: "checkbox"
    }), l), o && a.createElement(N, {
      className: "col-auto",
      onClick: function onClick() {
        return e.onEdit(n);
      }
    }, a.createElement("i", {
      className: "fa fa-edit "
    })));
  }), a.createElement(N, {
    disabled: e.disabled,
    className: "mt-3",
    primary: !0,
    block: !0,
    onClick: e.onGenerate
  }, "Generate"));
};

ut.defaultProps = {
  documents: [],
  docStyle: "generic"
};

var dt,
    Et = function Et(e) {
  var t = e.envelope,
      n = t.documents,
      r = void 0 === n ? [] : n,
      l = a.useMemo(function () {
    return r.filter(function (t) {
      return e.showSummary || "Summary" !== t.name;
    });
  }, [r, e.showSummary]),
      o = t.docusign_id || t.id + " - created " + s.DateTime.fromISO(t.created_at).toLocaleString(s.DateTime.DATETIME_MED);
  return a.createElement(f, {
    heading: "Envelope : " + o,
    footer: a.createElement(pt, {
      loadingProgress: e.loadingProgress,
      envelope: t,
      onDownload: e.onDownload,
      onReset: e.onReset,
      docusignHidden: e.docusignHidden,
      onSend: e.onSend,
      docusignError: e.docusignError
    }),
    success: "signed" === status && "Status: Signed",
    danger: "rejected" === status && "Status: Rejected",
    warning: "created" === status && "Status: Created",
    info: status && -1 === ["signed", "rejected", "created"].indexOf(status) && "Status: " + status,
    style: e.style,
    className: e.className
  }, e.showDocs && a.createElement(a.Fragment, null, 0 === l.length && a.createElement("p", null, "No Documents"), l.map(function (t) {
    return a.createElement(N, {
      key: t.id,
      className: "border",
      small: !0,
      block: !0,
      onClick: function onClick() {
        return e.onDocumentClick(t);
      }
    }, t.name);
  })), e.children);
},
    pt = function pt(e) {
  if (null === e.envelope.docusign_id) return a.createElement(Nt, {
    amount: e.loadingProgress
  });
  var t = "sent" !== e.envelope.docusign_status && "completed" !== e.envelope.docusign_status;
  return a.createElement(a.Fragment, null, a.createElement("div", {
    className: "btn-group"
  }, a.createElement(N, {
    secondary: !0,
    onClick: e.onDownload,
    key: "download-button"
  }, a.createElement("i", {
    className: "fa fa-download"
  }), a.createElement("span", {
    className: "ml-2"
  }, "DOWNLOAD")), t && a.createElement(N, {
    danger: !0,
    onClick: e.onReset,
    confirm: "Are you sure?",
    key: "discard-button"
  }, a.createElement("i", {
    className: "fa fa-times"
  }), a.createElement("span", {
    className: "ml-2"
  }, "RESET"))), a.createElement("div", {
    className: "pull-right"
  }, !e.docusignHidden && t && a.createElement(a.Fragment, null, a.createElement(N, {
    onClick: e.onSend,
    key: "send-button",
    disabled: !!e.docusignError
  }, a.createElement("span", {
    className: "mr-2"
  }, "SEND WITH"), a.createElement("img", {
    alt: "docusign",
    height: "20",
    src: "https://s3.us-east-2.amazonaws.com/lapis.navitascredit.com/docusign_logo.png",
    style: {
      opacity: e.docusignError ? .3 : 1
    }
  })), e.docusignError)));
},
    Nt = function Nt(e) {
  var t = e.amount;
  return t ? a.createElement("div", {
    className: "progress"
  }, a.createElement("div", {
    className: "progress-bar progress-bar-striped active",
    role: "progressbar",
    "aria-valuenow": t,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    style: {
      width: t + "%",
      backgroundColor: "dodgerBlue",
      color: "white"
    }
  }, "" + t, "%")) : null;
};

Et.defaultProps = {
  showDocs: !0,
  showSummary: !0
}, function (e) {
  e[e.ASC = 0] = "ASC", e[e.DESC = 1] = "DESC", e[e.NONE = 2] = "NONE";
}(dt || (dt = {}));
var Ct = "https://static.navitascredit.com/DOCUMENT_LIBRARY/GENERAL_INFORMATION/",
    ft = "https://static.navitascredit.com/DOCUMENT_LIBRARY/MAIN_CONTRACTS/",
    Tt = "https://static.navitascredit.com/DOCUMENT_LIBRARY/ASSIGNMENT_DOCUMENTS/",
    vt = "http://static.navitascredit.com/DOCUMENT_LIBRARY/NAVITAS_SUPPORTING_DOCUMENTS/",
    gt = "https://static.navitascredit.com/DOCUMENT_LIBRARY/GENERIC_SUPPORTING_DOCUMENTS/",
    ht = "https://static.navitascredit.com/DOCUMENT_LIBRARY/MISC_DOCUMENTS/",
    yt = "https://static.navitascredit.com/DOCUMENT_LIBRARY/ULTIMATE_OFFICE/",
    At = [{
  category: "GENERAL INFORMATION",
  name: "RATES",
  fileType: "PDF",
  url: Ct + "RATES.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "CREDIT QUICK REF GUIDE",
  fileType: "PDF",
  url: Ct + "CREDIT_QUICK_REF_GUIDE.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "ELITE PARTNER PROGRAM",
  fileType: "PDF",
  url: Ct + "ELITE_PARTNER_PROGRAM.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "FUNDING QUICK REF GUIDE",
  fileType: "PDF",
  url: Ct + "FUNDING_QUICK_REF_GUIDE.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "STATE & USURY RESTRICTIONS",
  fileType: "PDF",
  url: Ct + "STATE_AND_USURY_RESTRICTIONS.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "SCAN & FAX TO FUND GUIDELINES",
  fileType: "PDF",
  url: Ct + "SCAN_AND_FAX_TO_FUND_GUIDELINES.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "CHECK BY PHONE FORM",
  fileType: "PDF",
  url: Ct + "CHECK_BY_PHONE_FORM.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "SALES TAX INSTRUCTIONS",
  fileType: "PDF",
  url: Ct + "SALES_TAX_INSTRUCTIONS.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "START UP BUSINESS PROGRAM",
  fileType: "PDF",
  url: Ct + "START_UP_PROGRAM.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "TITLING PROGRAM OVERVIEW",
  fileType: "PDF",
  url: Ct + "TITLING_PROGRAM_OVERVIEW.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "DOUBLE PLAY PROGRAM",
  fileType: "PDF",
  url: Ct + "DOUBLE_PLAY_PROGRAM.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "DOCIT PROGRAM",
  fileType: "PDF",
  url: Ct + "DOC_PREP_PROGRAM.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "MEDICAL PROGRAM",
  fileType: "PDF",
  url: Ct + "MEDICAL_PROGRAM.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "VAULTING GUIDELINES",
  fileType: "PDF",
  url: Ct + "VAULTING_GUIDELINES.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "APP ONLY TO $250K PROGRAM",
  fileType: "PDF",
  url: Ct + "APP_ONLY_TO_$250.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "AUTHORIZED SIGNERS LIST",
  fileType: "PDF",
  url: Ct + "AUTHORIZED_SIGNERS_LIST.pdf"
}, {
  category: "MAIN CONTRACTS",
  name: "NAVITAS LEASE AGREEMENT",
  fileType: "PDF",
  url: ft + "NAVITAS_LEASE_AGREEMENT.pdf"
}, {
  category: "MAIN CONTRACTS",
  name: "NAVITAS FINANCE AGREEMENT",
  fileType: "PDF",
  url: ft + "NAVITAS_FINANCE_AGREEMENT.pdf"
}, {
  category: "MAIN CONTRACTS",
  name: "GENERIC LEASE AGREEMENT",
  fileType: "PDF",
  url: ft + "GENERIC_LEASE_AGREEMENT.pdf"
}, {
  category: "MAIN CONTRACTS",
  name: "GENERIC FINANCE AGREEMENT",
  fileType: "PDF",
  url: ft + "GENERIC_FINANCE_AGREEMENT.pdf"
}, {
  category: "ASSIGNMENT DOCUMENTS",
  name: "SEPARATE ASSIGNMENT",
  fileType: "PDF",
  url: Tt + "SEPARATE_ASSIGNMENT.pdf"
}, {
  category: "ASSIGNMENT DOCUMENTS",
  name: "INSTRUCTIONS FOR SEPARATE ASSIGNMENT",
  fileType: "PDF",
  url: Tt + "INSTRUCTIONS_FOR_SEPARATE_ASSIGNMENT.pdf"
}, {
  category: "ASSIGNMENT DOCUMENTS",
  name: "DISCOUNT ASSIGNMENT",
  fileType: "XLS",
  url: Tt + "DISCOUNT_ASSIGNMENT.xls"
}, {
  category: "ASSIGNMENT DOCUMENTS",
  name: "INSTRUCTIONS FOR DISCOUNT ASSIGNMENT",
  fileType: "PDF",
  url: Tt + "INSTRUCTIONS_FOR_DISCOUNT_ASSIGNMENT.pdf"
}, {
  category: "ASSIGNMENT DOCUMENTS",
  name: "RESIDUAL TO BROKER AMENDMENT",
  fileType: "PDF",
  url: Tt + "RESIDUAL_TO_BROKER_AMENDMENT.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "ACH AUTHORIZATION",
  fileType: "PDF",
  url: vt + "NAVITAS_ACH_AUTHORIZATION.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "ADDENDUM TO AMEND",
  fileType: "PDF",
  url: vt + "NAVITAS_ADDENDUM_TO_AMEND.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "ADDITIONAL PAY PROCEEDS",
  fileType: "PDF",
  url: vt + "NAVITAS_ADDITIONAL_PAY_PROCEEDS.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "ADD’L COLLATERAL SECURITY AGRMT",
  fileType: "PDF",
  url: vt + "NAVITAS_ADDITIONAL_COLLATERAL_SECURITY_AGRMT.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "ASSG OF INV/DISCLAIMER OF OWNERSHIP",
  fileType: "PDF",
  url: vt + "NAVITAS_ASSIGNMENT_OF_INV_DISCLAIMER_OF_OWNERSHIP.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "NAVITAS BENEFICIAL OWNERS FORM",
  fileType: "PDF",
  url: vt + "NAVITAS_BENEFICIAL_OWNERS_FORM.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "CERT OF AUTHORIZATION – BORROWER",
  fileType: "PDF",
  url: vt + "NAVITAS_CERT_OF_AUTHORIZATION_BORROWER.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "CERT OF AUTHORIZATION – GUARANTY",
  fileType: "PDF",
  url: vt + "NAVITAS_CERT_OF_AUTHORIZATION_GUARANTY.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "CORPORATE-PARTNERSHIP GUARANTY",
  fileType: "PDF",
  url: vt + "NAVITAS_CORPORATE_PARTNERSHIP_GUARANTY.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "CONFIRMATION LETTER",
  fileType: "PDF",
  url: vt + "NAVITAS_CONFIRMATION_LETTER.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "CROSS COLLATERAL AGREEMENT",
  fileType: "PDF",
  url: vt + "NAVITAS_CROSS_COLLATERAL_AGREEMENT.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "DELIVERY & ACCEPTANCE CERTIFICATE",
  fileType: "PDF",
  url: vt + "NAVITAS_DELIVERY_AND_ACCEPTANCE_CERTIFICATE.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "DRIVERS LICENSE REQUEST FORM",
  fileType: "PDF",
  url: vt + "NAVITAS_DRIVERS_LICENSE_REQUEST_FORM.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "EQUIPMENT SCHEDULE A",
  fileType: "PDF",
  url: vt + "NAVITAS_EQUIPMENT_SCHEDULE_A.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "FMV/PURCHASE OPTION",
  fileType: "PDF",
  url: vt + "NAVITAS_FMV_PURCHASE_OPTION.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "FMV/$1 “PUT” ADDENDUM",
  fileType: "PDF",
  url: vt + "NAVITAS_FMV_PUT_ADDENDUM.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "INSURANCE AUTHORIZATION",
  fileType: "PDF",
  url: vt + "NAVITAS_INSURANCE_AUTHORIZATION.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "LOCATION ADDENDUM",
  fileType: "PDF",
  url: vt + "NAVITAS_LOCATION_ADDENDUM.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "PARTIAL PAYMENTS / PREFUND",
  fileType: "PDF",
  url: vt + "NAVITAS_PARTIAL_PAYMENTS_PREFUND.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "PAYMENT SCHEDULE",
  fileType: "PDF",
  url: vt + "NAVITAS_PAYMENT_SCHEDULE.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "PERSONAL GUARANTY",
  fileType: "PDF",
  url: vt + "NAVITAS_PERSONAL_GUARANTY.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "REAL PROPERTY (LANDLORD) WAIVER",
  fileType: "PDF",
  url: vt + "NAVITAS_REAL_PROPERTY_WAIVER_LANDLORD.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "SIGNATURE VERIFICATION",
  fileType: "PDF",
  url: vt + "NAVITAS_SIGNATURE_VERIFICATION.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "SUBORDINATION AGREEMENT",
  fileType: "PDF",
  url: vt + "NAVITAS_SUBORDINATION_AGREEMENT.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "3RD PARTY LOC ADDENDUM – LEASE",
  fileType: "PDF",
  url: vt + "NAVITAS_3RD_PARTY_LOC_ADDENDUM_LEASE.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "3RD PARTY LOC ADDENDUM – EFA",
  fileType: "PDF",
  url: vt + "NAVITAS_3RD_PARTY_LOC_ADDENDUM_EFA.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "USED EQUIPMENT CONDITION REPORT",
  fileType: "PDF",
  url: vt + "NAVITAS_USED_EQUIPMENT_CONDITION_REPORT.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "VENDOR QUALIFICATION FORM",
  fileType: "PDF",
  url: vt + "NAVITAS_VENDOR_QUALIFICATION_FORM.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "ACH AUTHORIZATION",
  fileType: "PDF",
  url: gt + "GENERIC_ACH_AUTHORIZATION.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "ADDENDUM TO AMEND",
  fileType: "PDF",
  url: gt + "GENERIC_ADDENDUM_TO_AMEND.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "ADDITIONAL PAY PROCEEDS",
  fileType: "PDF",
  url: gt + "GENERIC_ADDITIONAL_PAY_PROCEEDS.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "ADD’L COLLATERAL SECURITY AGRMT",
  fileType: "PDF",
  url: gt + "GENERIC_ADDITIONAL_COLLATERAL_SECURITY_AGREEMENT.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "ASSG OF INV/DISCLAIMER OF OWNERSHIP",
  fileType: "PDF",
  url: gt + "GENERIC_ASSOCIATION_OF_INV_DISCLAIMER_OF_OWNERSHIP.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "GENERIC BENEFICIAL OWNERS FORM",
  fileType: "PDF",
  url: gt + "GENERIC_BENEFICIAL_OWNERS_FORM.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "CERT OF AUTHORIZATION – BORROWER",
  fileType: "PDF",
  url: gt + "GENERIC_CERT_OF_AUTHORIZATION_BORROWER.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "CERT OF AUTHORIZATION – GUARANTY",
  fileType: "PDF",
  url: gt + "GENERIC_CERT_OF_AUTHORIZATION_GUARANTY.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "CORPORATE-PARTNERSHIP GUARANTY",
  fileType: "PDF",
  url: gt + "GENERIC_CORPORATE_PARTNERSHIP_GUARANTY.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "CONFIRMATION LETTER",
  fileType: "PDF",
  url: gt + "GENERIC_CONFIRMATION_LETTER.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "CROSS COLLATERAL AGREEMENT",
  fileType: "PDF",
  url: gt + "GENERIC_CROSS_COLLATERAL_AGREEMENT.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "DELIVERY & ACCEPTANCE CERTIFICATE",
  fileType: "PDF",
  url: gt + "GENERIC_DELIVERY_AND_ACCEPTANCE_CERTIFICATE.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "DRIVERS LICENSE REQUEST FORM",
  fileType: "PDF",
  url: gt + "GENERIC_DRIVERS_LICENSE_REQUEST_FORM.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "EQUIPMENT SCHEDULE A",
  fileType: "PDF",
  url: gt + "GENERIC_EQUIPMENT_SCHEDULE_A.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "FMV/PURCHASE OPTION",
  fileType: "PDF",
  url: gt + "GENERIC_FMV_PURCHASE_OPTION.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "FMV/$1 “PUT” ADDENDUM",
  fileType: "PDF",
  url: gt + "GENERIC_FMV_PUT_ADDENDUM.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "INSURANCE AUTHORIZATION",
  fileType: "PDF",
  url: gt + "GENERIC_INSURANCE_AUTHORIZATION.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "LOCATION ADDENDUM",
  fileType: "PDF",
  url: gt + "GENERIC_LOCATION_ADDENDUM.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "PARTIAL PAYMENTS / PREFUND",
  fileType: "PDF",
  url: gt + "GENERIC_PARTIAL_PAYMENTS_PREFUND.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "PAYMENT SCHEDULE",
  fileType: "PDF",
  url: gt + "GENERIC_PAYMENT_SCHEDULE.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "PERSONAL GUARANTY",
  fileType: "PDF",
  url: gt + "GENERIC_PERSONAL_GUARANTY.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "REAL PROPERTY (LANDLORD) WAIVER",
  fileType: "PDF",
  url: gt + "GENERIC_REAL_PROPERTY_WAIVER_LANDLORD.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "SIGNATURE VERIFICATION",
  fileType: "PDF",
  url: gt + "GENERIC_SIGNATURE_VERIFICATION.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "SUBORDINATION AGREEMENT",
  fileType: "PDF",
  url: gt + "GENERIC_SUBORDINATION_AGREEMENT.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "3RD PARTY LOC ADDENDUM – LEASE",
  fileType: "PDF",
  url: gt + "GENERIC_3RD_PARTY_LOC_ADDENDUM_LEASE.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "3RD PARTY LOC ADDENDUM – EFA",
  fileType: "PDF",
  url: gt + "GENERIC_3RD_PARTY_LOC_ADDENDUM_EFA.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "USED EQUIPMENT CONDITION REPORT",
  fileType: "PDF",
  url: gt + "GENERIC_USED_EQUIPMENT_CONDITION_REPORT.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - GENERIC DOCUMENTS",
  name: "VENDOR QUALIFICATION FORM",
  fileType: "PDF",
  url: gt + "GENERIC_VENDOR_QUALIFICATION_FORM.pdf"
}, {
  category: "MISC DOCUMENTS",
  name: "VENDOR/BROKER ACH",
  fileType: "PDF",
  url: ht + "VENDOR_BROKER_ACH.pdf"
}, {
  category: "MISC DOCUMENTS",
  name: "POWER OF ATTORNEY",
  fileType: "PDF",
  url: ht + "POWER_OF_ATTORNEY.pdf"
}],
    bt = [{
  category: "GENERAL INFORMATION",
  name: "CREDIT QUICK REF GUIDE",
  fileType: "PDF",
  url: Ct + "CREDIT_QUICK_REF_GUIDE.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "ELITE PARTNER PROGRAM",
  fileType: "PDF",
  url: Ct + "ELITE_PARTNER_PROGRAM.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "RATES",
  fileType: "PDF",
  url: Ct + "RATES.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "SCAN & FAX TO FUND GUIDELINES",
  fileType: "PDF",
  url: Ct + "SCAN_AND_FAX_TO_FUND_GUIDELINES.pdf"
}, {
  category: "GENERAL INFORMATION",
  name: "START UP BUSINESS PROGRAM",
  fileType: "PDF",
  url: Ct + "START_UP_PROGRAM.pdf"
}, {
  category: "ASSIGNMENT DOCUMENTS",
  name: "INSTRUCTIONS FOR SEPARATE ASSIGNMENT",
  fileType: "PDF",
  url: Tt + "INSTRUCTIONS_FOR_SEPARATE_ASSIGNMENT.pdf"
}, {
  category: "ASSIGNMENT DOCUMENTS",
  name: "INSTRUCTIONS FOR DISCOUNT ASSIGNMENT",
  fileType: "PDF",
  url: Tt + "INSTRUCTIONS_FOR_DISCOUNT_ASSIGNMENT.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "CONFIRMATION LETTER",
  fileType: "PDF",
  url: vt + "NAVITAS_CONFIRMATION_LETTER.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "DELIVERY & ACCEPTANCE CERTIFICATE"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "DELIVERY & ACCEPTANCE CERTIFICATE",
  url: vt + "NAVITAS_DELIVERY_AND_ACCEPTANCE_CERTIFICATE.pdf"
}],
    St = [{
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "BILL OF SALE",
  fileType: "PDF",
  url: yt + "NAVITAS_BILL_OF_SALE.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "TITLE INFORMATION SHEET",
  fileType: "PDF",
  url: yt + "NAVITAS_TITLE_INFORMATION_SHEET.pdf"
}, {
  category: "SUPPORTING DOCUMENTS - NAVITAS DOCUMENTS",
  name: "CREDIT APPLICATION",
  fileType: "PDF",
  url: yt + "NAVITAS_CREDIT_APPLICATION.pdf"
}],
    Rt = At.filter(function (e) {
  return !bt.find(function (t) {
    return t.category === e.category && t.name === e.name;
  });
}).concat(St);
exports.ActivitySelector = function (e) {
  var t = a.useState("All Activity"),
      n = t[0],
      r = t[1],
      l = a.useState(""),
      o = l[0],
      c = l[1],
      i = function i(t) {
    var a = ie[t],
        n = function (e) {
      var t = s.DateTime.local().startOf("day"),
          a = t.startOf("week"),
          n = t.startOf("month"),
          r = t.startOf("year"),
          l = t.minus({
        days: 30
      });

      switch (e) {
        case "all":
          return null;

        case "today":
          return s.Interval.fromDateTimes(t, t.endOf("day"));

        case "yesterday":
          return s.Interval.fromDateTimes(t.minus({
            days: 1
          }), t.minus({
            days: 1
          }).endOf("day"));

        case "this week":
          return s.Interval.fromDateTimes(a, a.plus({
            weeks: 1
          }));

        case "last week":
          return s.Interval.fromDateTimes(a.minus({
            weeks: 1
          }), a);

        case "this month":
          return s.Interval.fromDateTimes(n, n.plus({
            months: 1
          }));

        case "last month":
          return s.Interval.fromDateTimes(n.minus({
            months: 1
          }), n);

        case "last 30 days":
          return s.Interval.fromDateTimes(l, t);

        case "this year":
          return s.Interval.fromDateTimes(r, r.plus({
            years: 1
          }));

        case "last year":
          return s.Interval.fromDateTimes(r.minus({
            years: 1
          }), r);

        default:
          return null;
      }
    }(t),
        l = "",
        o = null;

    if (null !== n) if (o = n.toISO(), n instanceof s.DateTime) l = n.toLocaleString(s.DateTime.DATE_SHORT);else if (n instanceof s.Interval) {
      var i = n.end;
      l = n.start.toLocaleString(s.DateTime.DATE_SHORT) + " - " + i.toLocaleString(s.DateTime.DATE_SHORT);
    }
    e.onChange(o), r(a), c(l);
  };

  return a.createElement(f, {
    style: e.style,
    className: e.className
  }, a.createElement("h2", {
    className: "font-weight-light justify-content-center"
  }, a.createElement("span", null, n, o && a.createElement("span", {
    style: {
      fontSize: "40%",
      marginLeft: "10px"
    }
  }, o))), a.createElement("nav", {
    className: "font-size-xl "
  }, a.createElement("ol", {
    className: "breadcrumb justify-content-center"
  }, a.createElement("li", {
    className: "breadcrumb-item"
  }, a.createElement(N, {
    link: !0,
    onClick: function onClick() {
      return i("all");
    }
  }, "all")), a.createElement("li", {
    className: "breadcrumb-item"
  }, a.createElement(N, {
    link: !0,
    onClick: function onClick() {
      return i("today");
    }
  }, "today")), a.createElement("li", {
    className: "breadcrumb-item"
  }, a.createElement(N, {
    link: !0,
    onClick: function onClick() {
      return i("yesterday");
    }
  }, "yesterday")), a.createElement("li", {
    className: "breadcrumb-item"
  }, a.createElement(N, {
    link: !0,
    onClick: function onClick() {
      return i("this week");
    }
  }, "this week")), a.createElement("li", {
    className: "breadcrumb-item"
  }, a.createElement(N, {
    link: !0,
    onClick: function onClick() {
      return i("last week");
    }
  }, "last week")), a.createElement("li", {
    className: "breadcrumb-item"
  }, a.createElement(N, {
    link: !0,
    onClick: function onClick() {
      return i("this month");
    }
  }, "this month")), a.createElement("li", {
    className: "breadcrumb-item"
  }, a.createElement(N, {
    link: !0,
    onClick: function onClick() {
      return i("last month");
    }
  }, "last month")), a.createElement("li", {
    className: "breadcrumb-item"
  }, a.createElement(N, {
    link: !0,
    onClick: function onClick() {
      return i("last 30 days");
    }
  }, "last 30 days")), a.createElement("li", {
    className: "breadcrumb-item"
  }, a.createElement(N, {
    link: !0,
    onClick: function onClick() {
      return i("this year");
    }
  }, "this year")), a.createElement("li", {
    className: "breadcrumb-item"
  }, a.createElement(N, {
    link: !0,
    onClick: function onClick() {
      return i("last year");
    }
  }, "last year")))));
}, exports.AlertProvider = function (e) {
  var t = a.useState(e.alerts || []),
      n = t[0],
      r = t[1],
      l = function l(e) {
    return r(function (t) {
      return t.filter(function (t) {
        return t.text !== e.text;
      });
    });
  };

  return a.createElement(A.Provider, {
    value: {
      alert: function alert(e, t) {
        void 0 === t && (t = "success");
        var a = {
          text: e,
          type: t
        };
        n.every(function (e) {
          return e.text !== a.text;
        }) && (setTimeout(function () {
          return l(a);
        }, 3e3), r(function (e) {
          return [].concat(e, [a]);
        }));
      },
      alerts: n,
      clearAlert: l
    }
  }, a.createElement(b, null), e.children);
}, exports.AppUploadLog = function (e) {
  var t = e.application;
  return a.createElement(f, {
    heading: "Upload Log",
    style: e.style,
    className: e.className
  }, a.createElement("table", {
    className: "table table-striped table-sm table-hover mb-3"
  }, a.createElement("tbody", null, t.upload_logs && t.upload_logs.map(function (e) {
    return a.createElement(Se, {
      key: e.name,
      event: e
    });
  }))));
}, exports.ApplicationDetails = function (e) {
  var t = e.application;
  return a.createElement(f, {
    heading: "Application Details",
    style: e.style,
    className: e.className
  }, a.createElement("dl", {
    className: "row app-detail-list"
  }, a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Application Number"), a.createElement("dd", {
    className: "col-sm-8"
  }, t.leaseworks_id), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Date Submitted"), a.createElement("dd", {
    className: "col-sm-8"
  }, t.submit_at), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Broker Name"), a.createElement("dd", {
    className: "col-sm-8"
  }, t.vendor_name), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Sales Rep"), a.createElement("dd", {
    className: "col-sm-8"
  }, t.rep_name), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Broker Reference #"), a.createElement("dd", {
    className: "col-sm-8"
  }, t.tracking_number)));
}, exports.ApplicationGraph = function (e) {
  var t = a.createRef();
  return a.useEffect(function () {
    var a,
        n = e.applications.filter(function (e) {
      return !!e.submit_at;
    }).sort(function (e, t) {
      return +new Date(t.submit_at || "") - +new Date(e.submit_at || "");
    });

    if (t.current && !(n.length < 2)) {
      var r = {
        approved: (a = n).filter(function (e) {
          return ["Approved", "Funded", "Funding", "Partial Funding"].includes(e.status);
        }),
        submitted: a,
        funded: a.filter(function (e) {
          return ["Funded", "Funding", "Partial Funding"].includes(e.status);
        })
      },
          l = r.approved,
          o = r.submitted,
          c = r.funded,
          s = d.max(n, function (e) {
        return +new Date(e.submit_at || "");
      }) || 0,
          i = d.min(n, function (e) {
        return +new Date(e.submit_at || "");
      }) || 0,
          m = d.sum(n, function (e) {
        return e.cost;
      }),
          u = t.current;
      u.innerHTML = "";

      var E = d.select(u).append("g").attr("transform", "translate(50, 6)"),
          p = d.scaleTime().domain([new Date(i), new Date(s)]).range([0, 739]),
          N = d.scaleLinear().domain([0, m]).range([269, 0]),
          C = function (e, t, a) {
        var n = t - a,
            r = n > 1728e5 && n < 6912e5,
            l = n > 6048e5 && n < 27648e5,
            o = n > 26784e5 && n < 31536e6,
            c = n > 31536e6,
            s = d.axisBottom(e).tickSize(-269);
        return r ? s.tickArguments([d.timeDay.every(1)]) : l ? s.tickArguments([d.timeWeek.every(1)]) : o ? s.tickArguments([d.timeMonth.every(1)]) : c && s.tickArguments([d.timeYear.every(1)]), s;
      }(p, i, s),
          f = E.append("g").attr("class", "grid").attr("fill", "white").attr("transform", "translate(0,269)"),
          T = d.axisLeft(N).ticks(5, "$s").tickSize(-739);

      E.append("g").attr("class", "grid").call(T), f.call(C);

      var v = 0,
          g = 0,
          h = 0,
          y = d.line().x(function (e) {
        return p(new Date(e.submit_at || ""));
      }).y(function (e) {
        return N(v += e.cost);
      }),
          A = d.line().x(function (e) {
        return p(new Date(e.submit_at || ""));
      }).y(function (e) {
        return N(g += e.cost);
      }),
          b = d.line().x(function (e) {
        return p(new Date(e.submit_at || ""));
      }).y(function (e) {
        return N(h += e.cost);
      }),
          S = function S(e, t) {
        return new Date(e.submit_at || "") > new Date(t.submit_at || "") ? 1 : -1;
      };

      E.append("path").data([o.sort(S)]).attr("class", "line submitted").attr("d", y), E.append("path").data([l.sort(S)]).attr("class", "line approved").attr("d", A), E.append("path").data([c.sort(S)]).attr("class", "line funded").attr("d", b);
    }
  }, [e.applications, t]), a.createElement("div", {
    className: n("application-graph", e.className),
    style: e.style
  }, a.createElement("svg", {
    ref: t,
    viewBox: "0 0 800 300",
    width: "100%"
  }), a.createElement("table", null, a.createElement("tbody", null, a.createElement("tr", null, a.createElement("td", {
    className: "legendColorBox"
  }, a.createElement("div", {
    style: {
      border: "1px solid #ccc",
      padding: "1px"
    }
  }, a.createElement("div", {
    style: {
      width: "4px",
      height: "0",
      border: "5px solid rgb(96,189,104)",
      overflow: "hidden"
    }
  }))), a.createElement("td", {
    className: "legendLabel"
  }, "Submitted")), a.createElement("tr", null, a.createElement("td", {
    className: "legendColorBox"
  }, a.createElement("div", {
    style: {
      border: "1px solid #ccc",
      padding: "1px"
    }
  }, a.createElement("div", {
    style: {
      width: "4px",
      height: "0",
      border: "5px solid rgb(178,118,178)",
      overflow: "hidden"
    }
  }))), a.createElement("td", {
    className: "legendLabel"
  }, "Approved")), a.createElement("tr", null, a.createElement("td", {
    className: "legendColorBox"
  }, a.createElement("div", {
    style: {
      border: "1px solid #ccc",
      padding: "1px"
    }
  }, a.createElement("div", {
    style: {
      width: "4px",
      height: "0",
      border: "5px solid rgb(93,165,218)",
      overflow: "hidden"
    }
  }))), a.createElement("td", {
    className: "legendLabel"
  }, "Funded")))));
}, exports.ApplicationGroupSelector = me, exports.ApplicationTable = function (e) {
  var t = e.style,
      r = e.className,
      c = a.useState(""),
      i = c[0],
      m = c[1],
      u = a.useState("submit_at"),
      d = u[0],
      E = u[1],
      p = a.useState(se.DESC),
      C = p[0],
      T = p[1],
      v = a.useState(0),
      g = v[0],
      h = v[1],
      y = a.useMemo(function () {
    return function (e, t, a, n) {
      void 0 === n && (n = []);
      var r = e.toLowerCase(),
          l = n.filter(function (e) {
        return e.company_name && e.company_name.toLowerCase().includes(r) || e.dba && e.dba.toLowerCase().includes(r) || e.guarantor_name && e.guarantor_name.toLowerCase().includes(r) || e.status && e.status.toLowerCase().includes(r);
      });
      if (!a) return l;
      var o = l.sort(function (e, t) {
        switch (a) {
          case "submit_at":
            return Ee(e.submit_at, t.submit_at);

          case "leaseworks_id":
            return de(e.leaseworks_id, t.leaseworks_id);

          case "company_name":
            return de(e.company_name, t.company_name);

          case "guarantor_name":
            return de(e.guarantor_name, t.guarantor_name);

          case "cost":
            return t.cost - e.cost;

          case "status":
            return de(e.status, t.status);

          case "approved_at":
            return Ee(e.approved_at, t.approved_at);

          default:
            return 0;
        }
      });
      return t === se.DESC ? o : o.reverse();
    }(i, C, d, e.applications);
  }, [i, C, d, e.applications]).slice(10 * g, 10 * g + 10),
      A = e.applications.length,
      b = Math.floor((A - 1) / 10),
      S = function (e, t, a) {
    return e <= 5 ? o.range(0, a + 1) : t - 2 < 0 ? o.range(0, 5) : t + 3 > a ? o.range(a - 4, a + 1) : o.range(t - 2, t + 3);
  }(A, g, b),
      R = function R(e) {
    var t = function (e, t, a) {
      return t === e && a === se.DESC ? {
        sort: e,
        sortOrder: se.ASC
      } : t === e ? {
        sort: null,
        sortOrder: se.DESC
      } : {
        sort: t,
        sortOrder: se.DESC
      };
    }(d, e, C);

    E(t.sort), T(t.sortOrder);
  };

  return a.createElement(f, {
    style: t,
    className: r
  }, a.createElement("div", {
    className: "row"
  }, e.onRefresh && a.createElement("div", {
    className: "col"
  }, a.createElement(N, {
    success: !0,
    onClick: e.onRefresh
  }, a.createElement("i", {
    className: "fa fa-refresh fa-lg"
  }))), a.createElement("div", {
    className: "col"
  }, a.createElement(D, {
    label: "Search",
    horizontal: !0,
    for: "search"
  }, a.createElement(re, {
    type: "search",
    name: "search",
    value: i,
    onChange: function onChange(e) {
      return void 0 === e && (e = ""), m(e);
    }
  })))), a.createElement("div", {
    className: "table-responsive"
  }, a.createElement("table", {
    className: "table table-striped table-bordered table-hover"
  }, a.createElement("thead", null, a.createElement("tr", null, a.createElement("th", null), a.createElement(ue, {
    onClick: function onClick() {
      return R("submit_at");
    },
    label: "Submit Date",
    selected: "submit_at" === d,
    sortOrder: C
  }), a.createElement(ue, {
    onClick: function onClick() {
      return R("leaseworks_id");
    },
    label: "Application #",
    selected: "leaseworks_id" === d,
    sortOrder: C
  }), a.createElement(ue, {
    onClick: function onClick() {
      return R("company_name");
    },
    label: "Customer Name",
    selected: "company_name" === d,
    sortOrder: C
  }), a.createElement(ue, {
    onClick: function onClick() {
      return R("guarantor_name");
    },
    label: "Guarantor Name",
    selected: "submit_at" === d,
    sortOrder: C
  }), a.createElement(ue, {
    onClick: function onClick() {
      return R("cost");
    },
    label: "Equipment Cost",
    selected: "cost" === d,
    sortOrder: C
  }), a.createElement(ue, {
    onClick: function onClick() {
      return R("status");
    },
    label: "Status",
    selected: "status" === d,
    sortOrder: C
  }), a.createElement(ue, {
    onClick: function onClick() {
      return R("approved_at");
    },
    label: "Approval Date",
    selected: "approved_at" === d,
    sortOrder: C
  }))), a.createElement("tbody", null, y.map(function (t, n) {
    return a.createElement("tr", {
      key: n
    }, a.createElement("td", null, e.applicationLink(t)), a.createElement("td", null, t.submit_at && s.DateTime.fromISO(t.submit_at).toLocaleString(s.DateTime.DATETIME_SHORT)), a.createElement("td", null, t.leaseworks_id), a.createElement("td", null, t.company_name), a.createElement("td", null, t.guarantor_name), a.createElement("td", null, l.formatMoney(t.cost)), a.createElement("td", null, t.status), a.createElement("td", null, t.approved_at && s.DateTime.fromISO(t.approved_at).toLocaleString(s.DateTime.DATETIME_SHORT)));
  })))), a.createElement("div", {
    className: "row justify-content-between"
  }, a.createElement("div", {
    className: "col-auto"
  }, "Showing " + (10 * g + 1) + " of " + (10 * g + 10) + " of " + A + " entries"), a.createElement("div", {
    className: "col-auto"
  }, a.createElement("div", {
    className: "btn-group"
  }, a.createElement(N, {
    onClick: function onClick() {
      return h(0);
    }
  }, "«"), a.createElement(N, {
    disabled: 0 === g,
    onClick: function onClick() {
      return h(g - 1);
    }
  }, "‹"), S.map(function (e) {
    return a.createElement(N, {
      key: e,
      className: n("pagniate_button", {
        active: e === g
      }),
      onClick: function onClick() {
        return h(e);
      }
    }, e + 1);
  }), a.createElement(N, {
    disabled: g === b,
    onClick: function onClick() {
      return h(g + 1);
    }
  }, "›"), a.createElement(N, {
    onClick: function onClick() {
      return h(b);
    }
  }, "»")))));
}, exports.Attachments = function (e) {
  var t = e.application,
      n = e.onDownload,
      r = e.onUpload,
      l = e.style,
      o = e.className;
  return a.createElement(f, {
    heading: "Attachments",
    footer: r && a.createElement(Re, {
      onUpload: r
    }),
    style: l,
    className: o
  }, a.createElement("table", {
    className: "table table-striped table-sm table-hover mb-3",
    style: {
      tableLayout: "fixed"
    }
  }, a.createElement("tbody", null, t.attachments ? t.attachments.map(function (e) {
    a.createElement("tr", {
      key: e.seqnum
    }, a.createElement("td", {
      style: {
        width: "80%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    }, e.file_name, a.createElement("div", {
      className: "pull-right"
    }, a.createElement("i", {
      className: "fa fa-download",
      onClick: function onClick() {
        return n(e.seqnum);
      }
    }))));
  }) : a.createElement("tr", null, a.createElement("td", null, "No Attachments")))));
}, exports.AuthCertificateInfoModal = function (e) {
  var t = !!e.guarantors,
      n = t ? "Authorizer Role (Person Authorizing the Signer of the Corp Guaranty)" : "Authorizer Role (Person Authorizing the Contract Signer)",
      r = t ? "State Where Corp Guarantor is Organized" : "State Where Company is Organized";
  return a.createElement(v, {
    onClose: e.onCancel,
    closeConfirm: e.cancelConfirm,
    title: t ? "Certificate of Authorization Info - Guaranty" : "Certificate of Authorization Info"
  }, a.createElement("form", {
    onSubmit: e.onSubmit
  }, a.createElement(D, {
    label: t ? "Type of Entity (Corp Guarantor)" : "Type of Entity"
  }, a.createElement(re, {
    name: "entity_type",
    value: e.data.entity_type,
    onChange: function onChange(t) {
      return e.onChange({
        entity_type: t
      });
    },
    type: "select",
    options: [{
      label: "Corporation",
      value: "corporation"
    }, {
      label: "Partnership",
      value: "partnership"
    }, {
      label: "LLC",
      value: "llc"
    }],
    required: !0
  })), a.createElement(D, {
    label: r
  }, a.createElement(re, {
    name: "state",
    type: "state",
    value: e.data.state,
    onChange: function onChange(t) {
      return e.onChange({
        state: t
      });
    },
    required: !0
  })), a.createElement("hr", null), !t && a.createElement(a.Fragment, null, a.createElement(D, {
    label: "Contract Signer Name"
  }, a.createElement(re, {
    name: "officer_1_name",
    value: e.data.officer_1_name,
    onChange: function onChange(t) {
      return e.onChange({
        officer_1_name: t
      });
    },
    required: !0
  })), a.createElement(D, {
    label: "Contract Signer Title"
  }, a.createElement(re, {
    name: "officer_1_title",
    value: e.data.officer_1_title,
    onChange: function onChange(t) {
      return e.onChange({
        officer_1_title: t
      });
    },
    required: !0
  }))), !!e.guarantors && a.createElement(D, {
    label: "Corporate Guarantor"
  }, a.createElement(re, {
    name: "guarantor",
    value: e.data.guarantor,
    onChange: function onChange(t) {
      return e.onChange({
        guarantor: t
      });
    },
    type: "select",
    options: e.guarantors.map(function (e, t) {
      return {
        value: t,
        label: "" + e.company_name
      };
    }),
    required: !0
  })), a.createElement(D, {
    label: "Authorizer Name"
  }, a.createElement(re, {
    name: "authorization_party_name",
    value: e.data.authorization_party_name,
    onChange: function onChange(t) {
      return e.onChange({
        authorization_party_name: t
      });
    },
    required: !0
  })), a.createElement(D, {
    label: n
  }, a.createElement(re, {
    name: "management_type",
    type: "select",
    value: e.data.management_type,
    onChange: function onChange(t) {
      return e.onChange({
        management_type: t
      });
    },
    options: [{
      label: "Secretary (if Corporation)",
      value: "corporation"
    }, {
      label: "Managing/General Partner (if Partnership)",
      value: "partnership"
    }, {
      label: "Managing Member (if LLC)",
      value: "llc"
    }]
  })), a.createElement(D, {
    label: "Authorizer Title"
  }, a.createElement(re, {
    name: "authorization_party_title",
    value: e.data.authorization_party_title,
    onChange: function onChange(t) {
      return e.onChange({
        authorization_party_title: t
      });
    },
    required: !0
  })), a.createElement(D, {
    label: "Authorizer Email"
  }, a.createElement(re, {
    name: "authorization_party_email",
    value: e.data.authorization_party_email,
    onChange: function onChange(t) {
      return e.onChange({
        authorization_party_email: t
      });
    },
    type: "email",
    required: !0
  })), a.createElement(D, {
    label: "Date"
  }, a.createElement(re, {
    name: "date",
    value: s.DateTime.local().toLocaleString(s.DateTime.DATE_MED),
    onChange: function onChange(e) {
      return e;
    },
    disabled: !0
  })), a.createElement("div", {
    className: "pull-right"
  }, a.createElement(N, {
    className: "mr-3",
    onClick: e.onCancel,
    confirm: e.cancelConfirm
  }, "Cancel"), a.createElement(N, {
    success: !0,
    submit: !0
  }, "Submit"))));
}, exports.AutoZipInput = I, exports.Autocomplete = function (e) {
  var t = e.completeMethod,
      n = void 0 === t ? oe : t,
      r = e.items,
      l = void 0 === r ? [] : r,
      o = e.onChange;
  return a.createElement(u, {
    placeholder: e.placeholder,
    name: e.name,
    options: l,
    loadOptions: function loadOptions(e, t) {
      try {
        return Promise.resolve(n(e, l)).then(t);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    onChange: function onChange(e) {
      null == e ? o(void 0) : "value" in e && o(e);
    },
    style: e.style,
    className: e.className,
    isDisabled: e.disabled
  });
}, exports.Button = N, exports.CERTIFICATE_OF_AUTHORIZATION = "Certificate of Authorization", exports.CERTIFICATE_OF_AUTHORIZATION_FOR_GUARANTY = "Certificate of Authorization for Guaranty", exports.Card = f, exports.Comments = function (e) {
  var t = e.application.comments,
      n = void 0 === t ? [] : t;
  return a.createElement(f, {
    heading: "Comments",
    style: e.style,
    className: e.className
  }, a.createElement("ul", null, 0 === n.length && a.createElement("li", null, "No Comments"), n.map(function (e) {
    return a.createElement("li", {
      key: e.text
    }, e.text);
  })));
}, exports.CompanyTypeSelector = function (e) {
  return a.createElement(f, {
    heading: "Type of Company",
    style: e.style,
    className: e.className
  }, a.createElement("div", {
    className: "row justify-content-around"
  }, P.map(function (t) {
    var n = t.label,
        r = t.value;
    return a.createElement("div", {
      key: r,
      className: "form-check form-check-inline"
    }, a.createElement("input", {
      type: "radio",
      name: "companyType",
      className: "form-check-input",
      value: r,
      checked: e.selected === r,
      onChange: function onChange(t) {
        return e.onChange(t.target.value);
      },
      required: e.required
    }), a.createElement("label", {
      key: r,
      className: "form-check-label"
    }, n));
  })));
}, exports.CustomerForm = function (e) {
  var t = e.data,
      n = e.onChange,
      r = e.errors;
  return a.createElement(f, {
    heading: "Customer Information",
    className: e.className,
    style: e.style
  }, a.createElement(D, {
    required: !0,
    label: "Company Name"
  }, a.createElement(re, {
    required: !0,
    name: "customerCompanyName",
    placeholder: "",
    value: t.customerCompanyName,
    onChange: function onChange(e) {
      return n({
        customerCompanyName: e
      });
    }
  })), a.createElement(D, {
    label: "DBA"
  }, a.createElement(re, {
    name: "customerDBA",
    placeholder: "",
    value: t.customerDBA,
    onChange: function onChange(e) {
      return n({
        customerDBA: e
      });
    }
  })), a.createElement(D, {
    required: !0,
    label: "Years in Business"
  }, a.createElement(re, {
    required: !0,
    type: "number",
    name: "customerYearsInBusiness",
    placeholder: "",
    value: t.customerYearsInBusiness,
    onChange: function onChange(e) {
      return n({
        customerYearsInBusiness: e
      });
    },
    min: 0
  })), a.createElement(D, {
    required: !0,
    label: "Street Address"
  }, a.createElement(re, {
    required: !0,
    name: "customerStreet",
    placeholder: "",
    value: t.customerStreet,
    onChange: function onChange(e) {
      return n({
        customerStreet: e
      });
    },
    error: r.customerStreet
  })), a.createElement(D, {
    label: "Street Address 2"
  }, a.createElement(re, {
    name: "customerStreet2",
    placeholder: "",
    value: t.customerStreet2,
    onChange: function onChange(e) {
      return n({
        customerStreet2: e
      });
    }
  })), a.createElement(D, {
    required: !0,
    label: "Zip Code"
  }, a.createElement(I, {
    required: !0,
    name: "customerZip",
    placeholder: "",
    value: t.customerZip,
    onChange: function onChange(e) {
      return n({
        customerZip: e
      });
    },
    onCityChange: function onCityChange(e) {
      return n({
        customerCity: e
      });
    },
    onStateChange: function onStateChange(e) {
      return n({
        customerState: e
      });
    },
    error: r.customerZip
  })), a.createElement(D, {
    required: !0,
    label: "City"
  }, a.createElement(re, {
    required: !0,
    readOnly: !0,
    name: "customerCity",
    placeholder: "",
    value: t.customerCity,
    onChange: function onChange(e) {
      return n({
        customerCity: e
      });
    },
    error: r.customerCity
  })), a.createElement(D, {
    required: !0,
    label: "State"
  }, a.createElement(re, {
    required: !0,
    readOnly: !0,
    name: "customerState",
    type: "state",
    value: t.customerState,
    onChange: function onChange(e) {
      return n({
        customerState: e
      });
    },
    error: r.customerState
  })), a.createElement(D, {
    required: !0,
    label: "Company Phone"
  }, a.createElement(re, {
    required: !0,
    type: "tel",
    placeholder: "",
    name: "customerPhone",
    value: t.customerPhone,
    onChange: function onChange(e) {
      return n({
        customerPhone: e
      });
    },
    error: r.customerPhone
  })), a.createElement(D, {
    label: "Contact Name"
  }, a.createElement(re, {
    name: "customerContactName",
    placeholder: "",
    value: t.customerContactName,
    onChange: function onChange(e) {
      return n({
        customerContactName: e
      });
    }
  })), a.createElement(D, {
    label: "Contact Email"
  }, a.createElement(re, {
    type: "email",
    name: "customerContactEmail",
    placeholder: "",
    value: t.customerContactEmail,
    onChange: function onChange(e) {
      return n({
        customerContactEmail: e
      });
    }
  })), a.createElement(D, {
    label: "Contact Phone #"
  }, a.createElement(re, {
    type: "tel",
    name: "customerContactPhone",
    placeholder: "",
    value: t.customerContactPhone,
    onChange: function onChange(e) {
      return n({
        customerContactPhone: e
      });
    }
  })), a.createElement(D, {
    label: "Federal Tax ID"
  }, a.createElement(re, {
    name: "customerTID",
    type: "tid",
    placeholder: "",
    value: t.customerTID,
    onChange: function onChange(e) {
      return n({
        customerTID: e
      });
    }
  })), a.createElement(D, {
    label: "Broker Reference #"
  }, a.createElement(re, {
    name: "customerRefNum",
    placeholder: "",
    value: t.customerRefNum,
    onChange: function onChange(e) {
      return n({
        customerRefNum: e
      });
    }
  })));
}, exports.CustomerInformation = function (e) {
  var t = e.application,
      n = e.onChange,
      r = e.onEditClose,
      l = t.overrides,
      o = void 0 === l ? {} : l;
  return a.createElement(f, {
    heading: "Customer Information",
    style: e.style,
    className: e.className
  }, a.createElement("dl", {
    className: "app-detail-list row"
  }, a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Company Name"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "company_name",
    value: t.company_name,
    override: o.company_name,
    onChange: function onChange(e) {
      return n({
        company_name: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Company Type"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    type: "select",
    name: "business_type",
    value: t.business_type,
    override: o.business_type,
    onChange: function onChange(e) {
      return n({
        business_type: e
      });
    },
    onEditClose: r,
    options: P
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "DBA"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "dba",
    value: t.dba,
    override: o.dba,
    onChange: function onChange(e) {
      return n({
        dba: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Tax Id"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "customer_taxid",
    type: "tid",
    value: t.customer_taxid,
    override: o.customer_taxid,
    onChange: function onChange(e) {
      return n({
        customer_taxid: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Years in Business"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "years_in_business",
    type: "number",
    min: 0,
    value: t.years_in_business,
    override: o.years_in_business,
    onChange: function onChange(e) {
      return n({
        years_in_business: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Street Address"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "street",
    value: t.street,
    override: o.street,
    onChange: function onChange(e) {
      return n({
        street: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Street Address 2"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "street",
    value: t.street2,
    override: o.street2,
    onChange: function onChange(e) {
      return n({
        street2: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "City"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "city",
    value: t.city,
    override: o.city,
    onChange: function onChange(e) {
      return n({
        city: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "State"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "state",
    type: "state",
    value: t.state,
    override: o.state,
    onChange: function onChange(e) {
      return n({
        state: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Zip Code"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "zip",
    type: "zip",
    value: t.zip,
    override: o.zip,
    onChange: function onChange(e) {
      return n({
        zip: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Company Phone"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "phone",
    type: "tel",
    value: t.phone,
    override: o.phone,
    onChange: function onChange(e) {
      return n({
        phone: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Contact Name"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "contact_name",
    value: t.contact_name,
    override: o.contact_name,
    onChange: function onChange(e) {
      return n({
        contact_name: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Contact Phone"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "phone2",
    type: "tel",
    value: t.phone2,
    override: o.phone2,
    onChange: function onChange(e) {
      return n({
        phone2: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Signer Name"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "signer_name",
    value: t.signer_name,
    override: o.signer_name,
    onChange: function onChange(e) {
      return n({
        signer_name: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Signer Title"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "signer_title",
    value: t.signer_title,
    override: o.signer_title,
    onChange: function onChange(e) {
      return n({
        signer_title: e
      });
    },
    onEditClose: r
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Signer Email"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    editable: !0,
    name: "email",
    type: "email",
    value: t.email,
    override: o.email,
    onChange: function onChange(e) {
      return n({
        email: e
      });
    },
    onEditClose: r
  }))));
}, exports.DRIVER_LICENSE_REQUEST = "Driver License Request", exports.DefaultFooter = function () {
  return a.createElement(g, null, a.createElement("div", {
    className: "row"
  }, a.createElement("div", {
    className: "col text-center"
  }, a.createElement("ul", {
    className: "footer-menu"
  }, a.createElement("li", null, a.createElement("strong", null, "Vendor Services")), a.createElement("li", null, a.createElement("a", {
    href: "http://www.navitascredit.com/equipment-sellers.html"
  }, "Dealer Services")), a.createElement("li", null, a.createElement("a", {
    href: "http://www.navitascredit.com/equipment-manufacturers.html"
  }, "Strategic Accounts")), a.createElement("li", null, a.createElement("a", {
    href: "http://www.navitascredit.com/healthcare.html"
  }, "Healthcare Services")), a.createElement("li", null, a.createElement("a", {
    href: "http://www.navitascredit.com/specialty-vehicles---equipment.html"
  }, "Specialty Vehicles")))), a.createElement("div", {
    className: "col text-center"
  }, a.createElement("ul", {
    className: "footer-menu"
  }, a.createElement("li", null, a.createElement("strong", null, "Partner Funding")), a.createElement("li", null, a.createElement("a", {
    href: "http://www.navitascredit.com/partner-funding.html"
  }, "Asset Based Lending")), a.createElement("li", null, a.createElement("a", {
    href: "http://www.navitascredit.com/partner-funding.html"
  }, "Credit Based Lending")), a.createElement("br", null), a.createElement("li", null, a.createElement("strong", null, "Business Lending")), a.createElement("li", null, a.createElement("a", {
    href: "http://www.navitascredit.com/business-owners.html"
  }, "Business Lending")))), a.createElement("div", {
    className: "col text-center"
  }, a.createElement("a", {
    href: "http://www.navitascredit.com"
  }, a.createElement("img", {
    src: process.env.PUBLIC_URL && process.env.PUBLIC_URL + "images/navitas_logo_bw.png"
  }))), a.createElement("div", {
    className: "col text-center"
  }, a.createElement("ul", {
    className: "footer-menu"
  }, a.createElement("li", null, a.createElement("strong", null, a.createElement("a", {
    href: "http://www.navitascredit.com/about-us.html"
  }, "About Us"))), a.createElement("li", null, a.createElement("strong", null, a.createElement("a", {
    href: "http://www.navitascredit.com/customer-care.html"
  }, "Customer Care"))), a.createElement("li", null, a.createElement("strong", null, a.createElement("a", {
    href: "http://www.navitascredit.com/careers.html"
  }, "Careers"))), a.createElement("li", null, a.createElement("strong", null, a.createElement("a", {
    href: "http://www.navitascredit.com/contact-us.html"
  }, "Contact Us"))), a.createElement("li", null, a.createElement("strong", null, a.createElement("a", {
    href: "http://www.navitascredit.com/privacy-policy.html"
  }, "Privacy Policy"))), a.createElement("li", null, a.createElement("strong", null, a.createElement("a", {
    href: "http://www.navitascredit.com/terms---conditions.html"
  }, "Terms of Use"))))), a.createElement("div", {
    className: "col text-center"
  }, a.createElement("ul", {
    className: "footer-menu"
  }, a.createElement("li", null, a.createElement("strong", null, "203 Wade Road, Suite 300")), a.createElement("li", null, a.createElement("strong", null, "Ponte Vedra, FL 32081")), a.createElement("li", null, a.createElement("strong", null, "877.628.4827")), a.createElement("li", null, a.createElement("a", {
    href: "mailto:info@navitascredit.com"
  }, a.createElement("strong", null, "info@navitascredit.com"))), a.createElement("li", null, a.createElement("a", {
    className: "nodecoration",
    href: "https://twitter.com/NavitasCredit/followers?lang=en",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      display: "inline",
      padding: "0px 10px 0px 0px",
      lineHeight: "40px"
    }
  }, a.createElement("img", {
    alt: "Twitter",
    src: "https://marketing.navitascredit.com/cdnr/50/acton/attachment/1857/f-0ec3/1/-/-/-/-/twitter.png",
    width: "30",
    height: "30"
  })), a.createElement("a", {
    className: "nodecoration",
    href: "https://www.facebook.com/Navitas-Credit-Corp-1129251440465419",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      display: "inline",
      padding: "0px 10px 0px 0px",
      lineHeight: "40px"
    }
  }, a.createElement("img", {
    alt: "LinkedIn",
    src: "https://marketing.navitascredit.com/cdnr/50/acton/attachment/1857/f-0ec1/1/-/-/-/-/facebook.png",
    width: "30",
    height: "30"
  })), a.createElement("a", {
    className: "nodecoration",
    href: "https://www.linkedin.com/company/navitas-credit-corp.",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      display: "inline",
      padding: "0px 10px 0px 0px",
      lineHeight: "40px"
    }
  }, a.createElement("img", {
    alt: "Facebook",
    src: "https://marketing.navitascredit.com/cdnr/50/acton/attachment/1857/f-0ec2/1/-/-/-/-/linkedin.png",
    width: "30",
    height: "30"
  })))))));
}, exports.DocumentLibrary = function (e) {
  var t = e.style,
      n = e.className,
      r = e.office,
      l = a.useState(""),
      o = l[0],
      c = l[1],
      s = a.useState(""),
      i = s[0],
      m = s[1],
      u = a.useState(dt.NONE),
      d = u[0],
      E = u[1],
      p = function p(e) {
    m(e), E(i !== e ? dt.ASC : d === dt.ASC ? dt.DESC : d === dt.DESC ? dt.NONE : dt.ASC);
  },
      C = ("ultimate" === r ? Rt : At).filter(function (e) {
    return function (e, t) {
      void 0 === e && (e = "");
      var a = t.category,
          n = t.fileType;
      return t.name.toUpperCase().includes(e.toUpperCase()) || a.toUpperCase().includes(e.toUpperCase()) || n.toUpperCase().includes(e.toUpperCase());
    }(o, e);
  }),
      T = a.useMemo(function () {
    return C.sort(function (e, t) {
      return function (e, t, a, n) {
        return n !== dt.NONE && a ? n === dt.ASC ? e[a] > t[a] ? 1 : t[a] > e[a] ? -1 : 0 : n === dt.DESC ? e[a] < t[a] ? 1 : t[a] < e[a] ? -1 : 0 : 0 : 0;
      }(e, t, i, d);
    });
  }, [C, i, d]);

  return a.createElement(f, {
    style: t,
    className: n
  }, a.createElement("span", null, a.createElement("div", {
    className: "d-flex mb-4"
  }, a.createElement("h2", {
    className: "font-weight-light"
  }, "Document Library"), a.createElement(re, {
    value: o,
    type: "text",
    name: "search",
    placeholder: "search",
    className: "w-50 ml-auto",
    onChange: c
  })), a.createElement("div", {
    className: "row-fluid"
  }, a.createElement("div", {
    className: "col-12"
  }, a.createElement("table", {
    className: "table table-striped table-bordered table-hover"
  }, a.createElement("thead", null, a.createElement("tr", null, a.createElement("th", null), a.createElement("th", {
    onClick: function onClick() {
      return p("name");
    }
  }, "Name"), a.createElement("th", {
    onClick: function onClick() {
      return p("category");
    }
  }, "Category"), a.createElement("th", {
    onClick: function onClick() {
      return p("fileType");
    }
  }, "File Type"))), a.createElement("tbody", null, T.map(function (e, t) {
    return a.createElement("tr", {
      key: t,
      onClick: function onClick() {
        return window.open(e.url, "_blank");
      }
    }, a.createElement("td", null, a.createElement(N, {
      className: "btn btn-primary"
    }, a.createElement("i", {
      className: "fa fa-file-o"
    }))), a.createElement("td", null, e.name), a.createElement("td", null, e.category), a.createElement("td", null, e.fileType));
  })))))));
}, exports.DocumentSelector = ut, exports.DonutGraph = function (e) {
  var t = e.domain,
      n = void 0 === t ? [0, 0, .5, 1, 1] : t,
      r = e.label,
      l = void 0 === r ? "" : r,
      o = e.percent;
  isNaN(o) && (o = 0);
  var c = d.scaleLinear().domain(n).range(["red", "red", "yellow", "#60bd68", "#60bd68"]),
      s = Math.floor(100 * o),
      i = [o, 1 - o],
      m = d.pie().sort(null)(i);
  return a.createElement("div", {
    style: e.style,
    className: e.className
  }, a.createElement("div", {
    className: "col"
  }, a.createElement("div", {
    className: "row justify-content-center"
  }, a.createElement("svg", {
    width: 150,
    height: 150
  }, a.createElement("g", {
    transform: "translate(75, 75)"
  }, m.map(function (e) {
    return a.createElement("g", {
      className: "arc",
      key: "a" + e.index
    }, a.createElement("path", {
      d: Ne(e) || void 0,
      fill: 0 === e.index ? c(e.value) : "grey"
    }));
  }), a.createElement("text", {
    textAnchor: "middle",
    x: "2%",
    y: "8%",
    style: {
      fontWeight: "bold",
      fontSize: "35px"
    }
  }, s + "%")))), a.createElement("div", {
    className: "row justify-content-center"
  }, a.createElement("span", {
    className: "h2 font-weight-light mb-3"
  }, l))));
}, exports.EnvelopeStatus = Et, exports.EquipmentChecker = function (e) {
  var t = a.useState(),
      n = t[0],
      r = t[1];
  return a.createElement("div", {
    style: e.style,
    className: e.className
  }, a.createElement("div", {
    className: "row"
  }, a.createElement(D, {
    label: "Equipment Checker"
  }, a.createElement(re, {
    name: "equipment_checker",
    value: n && n.name,
    type: "select",
    onChange: function onChange(e) {
      return t = e, a = Te.find(function (e) {
        return e.name === t;
      }), void r(a);
      var t, a;
    },
    options: ve
  }))), n && a.createElement("div", {
    className: "row"
  }, a.createElement("h4", {
    className: n.color + " pl-4"
  }, n.message)));
}, exports.EquipmentInformation = Ae, exports.EquipmentInformationForm = he, exports.EquipmentLocationForm = function (e) {
  var t = e.asset,
      n = e.errors,
      r = e.onChange,
      l = e.style,
      o = e.className;
  return a.createElement(f, {
    heading: a.createElement("div", {
      className: "row justify-content-between"
    }, a.createElement("div", {
      className: "col"
    }, "Equipment Location"), e.onCopy && a.createElement("div", {
      className: "col-auto"
    }, a.createElement(N, {
      small: !0,
      onClick: e.onCopy
    }, a.createElement("i", {
      className: "fa fa-copy"
    }), " Copy From Customer Information"))),
    style: l,
    className: o
  }, a.createElement(D, {
    label: "Street Address",
    required: !0
  }, a.createElement(re, {
    name: "street",
    required: !0,
    placeholder: "",
    value: t.street || "",
    onChange: function onChange(e) {
      return r({
        street: e
      });
    },
    error: n.street
  })), a.createElement(D, {
    label: "Zip Code",
    required: !0
  }, a.createElement(I, {
    name: "zip",
    required: !0,
    placeholder: "",
    value: t.zip || "",
    onChange: function onChange(e) {
      return r({
        zip: e
      });
    },
    onCityChange: function onCityChange(e) {
      return r({
        city: e
      });
    },
    onStateChange: function onStateChange(e) {
      return r({
        state: e
      });
    },
    error: n.zip
  })), a.createElement(D, {
    label: "City",
    required: !0
  }, a.createElement(re, {
    readOnly: !0,
    required: !0,
    name: "city",
    placeholder: "",
    value: t.city || "",
    onChange: function onChange(e) {
      return r({
        city: e
      });
    },
    error: n.city
  })), a.createElement(D, {
    label: "State",
    required: !0
  }, a.createElement(re, {
    readOnly: !0,
    required: !0,
    type: "state",
    name: "state",
    value: t.state || "",
    onChange: function onChange(e) {
      return r({
        state: e
      });
    },
    error: n.state
  })));
}, exports.Features = function (e) {
  var t = o.splitEvery(2, e.features);
  return a.createElement("section", {
    style: e.style,
    className: e.className
  }, a.createElement("div", {
    className: "row justify-content-center"
  }, a.createElement("div", {
    className: "col-6 text-center"
  }, a.createElement("h2", null, e.title), e.subtitle && a.createElement("p", null, e.subtitle))), t.map(function (e) {
    return a.createElement("div", {
      className: "row justify-content-center",
      key: "container" + e[0].title
    }, e.map(function (e, t) {
      return a.createElement("div", {
        key: t,
        className: "col-4"
      }, a.createElement("div", {
        className: "row"
      }, e.fontawesome && a.createElement("div", {
        className: "col-2 align-items-center d-flex"
      }, a.createElement("i", {
        style: {
          fontSize: "2.8rem"
        },
        className: "fa fa-" + e.fontawesome
      })), a.createElement("div", {
        className: "col"
      }, a.createElement("strong", null, e.title), a.createElement("p", null, e.description), e.onClick && a.createElement(N, {
        success: !0,
        onClick: e.onClick
      }, "Learn more"))));
    }));
  }));
}, exports.FinanceAgreementSelector = function (e) {
  var t = e.selected,
      n = e.onChange,
      r = e.error,
      l = e.agreements.map(function (e) {
    return {
      label: e,
      value: e
    };
  });
  return a.createElement(f, {
    style: e.style,
    className: e.className
  }, a.createElement(D, {
    required: !0,
    label: "Type of Agreement"
  }, a.createElement(re, {
    name: "finance_agreement",
    value: t,
    required: !0,
    type: "select",
    onChange: n,
    options: l,
    error: r
  })));
}, exports.FinanceInformation = function (e) {
  var t = e.application,
      n = e.onChange,
      l = e.onEditClose,
      o = t.overrides,
      c = void 0 === o ? {} : o,
      s = 0;
  return [c.advance_payment_beginning_amount || t.advance_payment_beginning_amount, c.advance_payment_ending_amount || t.advance_payment_ending_amount, c.security_deposit || t.security_deposit, c.fees || t.fees].forEach(function (e) {
    "number" == typeof e && (s += e);
  }), a.createElement(f, {
    heading: "Finance Information",
    className: e.className,
    style: e.style
  }, a.createElement("dl", {
    className: "row app-detail-list"
  }, a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Term in Months"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "term",
    type: "number",
    onChange: function onChange(e) {
      return n({
        term: e
      });
    },
    onEditClose: l,
    value: t.term,
    override: c.term,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Total Amount Financed"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    type: "currency",
    name: "amount_financed",
    value: t.amount_financed,
    override: c.amount_financed,
    onChange: function onChange(e) {
      return n({
        amount_financed: e
      });
    },
    onEditClose: l,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Payment"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    type: "currency",
    name: "each_payment_amount",
    value: t.each_payment_amount,
    override: c.each_payment_amount,
    onChange: function onChange(e) {
      return n({
        each_payment_amount: e
      });
    },
    onEditClose: l,
    editable: !0
  }), a.createElement("a", {
    className: "btn btn-link",
    style: {
      color: "rgb(0, 123, 255)",
      textDecoration: "underline"
    },
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://s3.amazonaws.com/partnerfundingdocs.navitascredit.com/protected_documents/general_information/Sales+Tax+Instructions-+9-28-18.pdf"
  }, "(Tax Instructions)"), a.createElement("a", {
    className: "btn btn-xs btn-secondary",
    href: "#payment-builder"
  }, "use payment builder")), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "First Payment Amount"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    type: "currency",
    name: "advance_payment_beginning_amount",
    value: t.advance_payment_beginning_amount,
    override: c.advance_payment_beginning_amount,
    onChange: function onChange(e) {
      return n({
        advance_payment_beginning_amount: e
      });
    },
    onEditClose: l,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Last Payment Amount"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    type: "currency",
    name: "advance_payment_ending_amount",
    value: t.advance_payment_ending_amount,
    override: c.advance_payment_ending_amount,
    onChange: function onChange(e) {
      return n({
        advance_payment_ending_amount: e
      });
    },
    onEditClose: l,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Security Deposit"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    type: "currency",
    name: "security_deposit",
    value: t.security_deposit,
    override: c.security_deposit,
    onChange: function onChange(e) {
      return n({
        security_deposit: e
      });
    },
    onEditClose: l,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Fees"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    type: "currency",
    name: "fees",
    value: t.fees,
    override: c.fees,
    onChange: function onChange(e) {
      return n({
        fees: e
      });
    },
    onEditClose: l,
    editable: !0
  })), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Initial Amount Due"), a.createElement("dd", {
    className: "col-sm-8",
    style: {
      paddingLeft: 35
    }
  }, r.formatMoney(s)), e.financeTypes && a.createElement(a.Fragment, null, a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Purchase Option"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    name: "purchase_option",
    type: "select",
    onChange: function onChange(e) {
      return n({
        purchase_option: e
      });
    },
    onEditClose: l,
    value: t.purchase_option,
    override: c.purchase_option,
    options: e.financeTypes.map(function (e) {
      return {
        label: e,
        value: e
      };
    }),
    editable: !0
  }))), a.createElement("dt", {
    className: "col-sm-4 text-right text-nowrap"
  }, "Residual Amount"), a.createElement("dd", {
    className: "col-sm-8"
  }, a.createElement(re, {
    type: "currency",
    name: "residual_amount",
    value: t.residual_amount,
    override: c.residual_amount,
    onChange: function onChange(e) {
      return n({
        residual_amount: e
      });
    },
    onEditClose: l,
    editable: !0
  }))), a.createElement("div", {
    id: "payment-builder"
  }));
}, exports.Footer = g, exports.Form = at, exports.FormGroup = D, exports.GetStartedForm = function (e) {
  var n = t.useState(""),
      r = n[0],
      l = n[1],
      o = t.useState(""),
      c = o[0],
      s = o[1],
      i = t.useState(""),
      m = i[0],
      u = i[1],
      d = t.useState(""),
      E = d[0],
      p = d[1],
      C = t.useState(""),
      T = C[0],
      v = C[1],
      g = e.disabled,
      h = e.successfulRequest;
  return a.createElement("div", {
    className: "row justify-content-center mt-4"
  }, a.createElement("div", {
    className: "col-6"
  }, a.createElement(f, null, a.createElement("form", {
    onSubmit: function onSubmit(t) {
      t.preventDefault(), e.onSubmit({
        company: r,
        requestor: c,
        rep: m,
        email: E,
        phone: T
      });
    },
    className: e.className,
    style: e.style
  }, a.createElement(D, {
    label: "Company Name"
  }, a.createElement(re, {
    name: "company",
    required: !0,
    value: r,
    onChange: function onChange(e) {
      return l(e);
    },
    disabled: g
  })), a.createElement(D, {
    label: "Requestor Name"
  }, a.createElement(re, {
    name: "requestor",
    required: !0,
    value: c,
    onChange: function onChange(e) {
      return s(e);
    },
    disabled: g
  })), a.createElement(D, {
    label: "Navitas Sales Representative"
  }, a.createElement(re, {
    name: "rep",
    required: !0,
    value: m,
    onChange: function onChange(e) {
      return u(e);
    },
    disabled: g
  })), a.createElement(D, {
    label: "Email"
  }, a.createElement(re, {
    type: "email",
    name: "email",
    required: !0,
    value: E,
    onChange: function onChange(e) {
      return p(e);
    },
    disabled: g
  })), a.createElement(D, {
    label: "Phone"
  }, a.createElement(re, {
    type: "phone",
    name: "phone",
    required: !0,
    value: T,
    onChange: function onChange(e) {
      return v(e);
    },
    disabled: g
  })), h ? a.createElement("div", null, a.createElement("p", null, "Request submitted. Your Account Representative will contact you shortly.")) : a.createElement("div", {
    className: "text-right"
  }, a.createElement(N, {
    primary: !0,
    submit: !0,
    disabled: g
  }, "Send Request"))))));
}, exports.GuarantorForm = ge, exports.GuarantorInformation = ye, exports.IndustryChecker = function (e) {
  var t = a.useState(),
      r = t[0],
      l = t[1];
  return a.createElement("div", {
    style: e.style,
    className: e.className
  }, a.createElement("div", {
    className: "row"
  }, a.createElement(D, {
    for: "industry_checker",
    label: "Industry Checker"
  }, a.createElement(re, {
    name: "industry_checker",
    value: r && r.name,
    type: "select",
    onChange: function onChange(e) {
      return t = e, a = Ce.find(function (e) {
        return e.name === t;
      }), void l(a);
      var t, a;
    },
    options: fe
  }))), r && a.createElement("div", {
    className: "row"
  }, a.createElement("h4", {
    className: n(r.color, "pl-4")
  }, r.status)));
}, exports.Input = re, exports.LWWS = {
  __proto__: null,
  blankLeaseworksSubmitAppPayload: {
    CustInfo: {
      BusPhoneNum: "",
      Contact: "",
      CustAddr: {
        Street1: "",
        City: "",
        State: "",
        ZipCd: ""
      },
      DBANm: "",
      EmailAddr: "",
      FormOfBus: "",
      LegalNm: "",
      OwnerInYears: 0,
      YearInBus: 0
    },
    FinancialInfo: {
      Term: 0,
      TotCost: 0
    },
    AppProd: {},
    VendorInfo: {
      VenNm: "",
      VenNum: ""
    },
    UserInfo: {
      SalesLastNm: "",
      SalesFirstNm: ""
    }
  }
}, exports.LandingPage = function (e) {
  return a.createElement("div", {
    className: "landing-page"
  }, e.children);
}, exports.Leaseworks = {
  __proto__: null,
  blankApp: {
    app_id: 0,
    status: "",
    signer_name: "",
    signer_title: "",
    dba_name: "",
    assets: [],
    customer: {
      address: {
        city: "",
        state: "",
        street1: "",
        street2: "",
        zip: ""
      },
      company_name: "",
      customer_number: 0,
      form_of_business: "",
      phone: "",
      signer_name: "",
      signer_title: "",
      dba_name: ""
    },
    economics: {
      equipment_cost: "",
      security_deposit: "",
      advbeg: 0,
      advend: 0,
      term: 36,
      vendor_commission: "",
      app_yield: 0
    },
    vendor: {
      address: {
        city: "",
        state: "",
        street1: "",
        street2: "",
        zip: ""
      },
      company_name: "",
      phone: ""
    }
  }
}, exports.LoginForm = function (e) {
  var t = a.useState(""),
      n = t[0],
      r = t[1],
      l = a.useState(""),
      o = l[0],
      c = l[1],
      s = a.useState(e.remember || !1),
      i = s[0],
      m = s[1],
      u = e.disabled;
  return a.createElement("form", {
    onSubmit: function onSubmit(t) {
      t.preventDefault(), e.onSubmit({
        username: n || "",
        password: o || "",
        remember: i
      });
    },
    className: e.className,
    style: e.style
  }, a.createElement(D, {
    label: "Username",
    for: "username"
  }, a.createElement(re, {
    name: "username",
    required: !0,
    value: n,
    onChange: r,
    disabled: u
  })), a.createElement(D, {
    label: "Password",
    for: "password"
  }, a.createElement(re, {
    name: "password",
    required: !0,
    type: "password",
    value: o,
    onChange: c,
    disabled: u
  })), a.createElement("div", {
    className: "row"
  }, a.createElement("div", {
    className: "form-check mb-2 col ml-3"
  }, a.createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    checked: i,
    onChange: function onChange() {
      return m(!i);
    },
    disabled: u
  }), a.createElement("label", {
    className: "form-check-label"
  }, "Remember Me?")), a.createElement("div", {
    className: "col text-right"
  }, a.createElement(N, {
    primary: !0,
    submit: !0,
    disabled: u
  }, "Login"))));
}, exports.Modal = v, exports.NavItem = C, exports.Navbar = function (e) {
  return a.createElement("div", {
    style: e.style,
    className: e.className
  }, a.createElement("div", {
    className: "color-line"
  }), a.createElement("div", {
    className: "navbar navbar-expand-lg navbar-light justify-content-between"
  }, a.createElement("div", {
    className: "navbar-brand"
  }, e.brand), e.cobrand && a.createElement("div", {
    id: "cobrand-logo",
    className: "light-version"
  }, e.cobrand)));
}, exports.NumberBox = function (e) {
  var t = e.isCurrency ? r.formatMoney(e.number) : new Intl.NumberFormat().format(e.number);
  return a.createElement("div", {
    className: "bg-light d-flex flex-column align-items-center justify-content-end",
    style: {
      height: "100px"
    },
    onClick: e.onClick
  }, a.createElement("strong", {
    className: " pt-3 text-primary font-weight-bold",
    style: {
      fontSize: "4rem"
    }
  }, t), a.createElement("span", {
    className: "text-muted h4"
  }, e.description));
}, exports.POWER_OF_ATTORNEY = "Power of Attorney", exports.PROPERTY_WAIVER = "Property Waiver", exports.PageTop = function (e) {
  return a.createElement("div", {
    className: "jumbotron jumbotron-fluid",
    style: {
      color: "white",
      background: "linear-gradient(50deg, #3498db, #007c83)",
      marginBottom: 0
    }
  }, e.children);
}, exports.PaymentScheduleBuilder = function (e) {
  var t = a.useMemo(function () {
    return e.paymentSchedule.reduce(function (e, t) {
      var a = t.from,
          n = t.to,
          r = t.amount;
      return null == a || null == n ? e : e + (n - a + 1) * (void 0 === r ? 0 : r);
    }, 0);
  }, [e.paymentSchedule]);
  return a.createElement(f, {
    heading: "Payment Schedule Builder"
  }, a.createElement("table", {
    className: "table"
  }, a.createElement("thead", null, a.createElement("tr", null, a.createElement("th", null, "Payments From"), a.createElement("th", null, "Payments To"), a.createElement("th", null, "Amount"), a.createElement("th", null))), a.createElement("tbody", null, Array.from({
    length: e.paymentSchedule.length + 1
  }).map(function (t, n) {
    var r = e.paymentSchedule[n] || {};
    return a.createElement("tr", {
      key: n
    }, a.createElement("td", null, a.createElement(re, {
      type: "number",
      min: 0,
      name: "payment_schedule[" + n + "].from",
      value: r.from,
      onChange: function onChange(t) {
        return e.setPaymentSchedule({
          from: t
        }, n);
      }
    })), a.createElement("td", null, a.createElement(re, {
      type: "number",
      min: 0,
      name: "payment_schedule[" + n + "].to",
      value: r.to,
      onChange: function onChange(t) {
        return e.setPaymentSchedule({
          to: t
        }, n);
      }
    })), a.createElement("td", null, a.createElement(re, {
      type: "currency",
      name: "payment_schedule[" + n + "].amount",
      value: r.amount,
      onChange: function onChange(t) {
        return e.setPaymentSchedule({
          amount: t
        }, n);
      }
    })), a.createElement("td", null, a.createElement(N, {
      danger: !0,
      onClick: function onClick() {
        return e.removePaymentSchedule(n);
      }
    }, "×")));
  }), a.createElement("tr", null, a.createElement("td", {
    colSpan: 2
  }, a.createElement(N, {
    primary: !0,
    onClick: e.onSave
  }, "Save")), a.createElement("td", {
    colSpan: 2
  }, a.createElement("p", null, a.createElement("strong", null, "Total: "), r.formatMoney(t)))))));
}, exports.PortalQuoter = function (e) {
  var t = a.useState(),
      n = t[0],
      r = t[1],
      l = a.useState([]),
      c = l[0],
      s = l[1],
      i = a.useState([]),
      m = i[0],
      u = i[1],
      d = a.useState([]),
      E = d[0],
      p = d[1],
      C = a.useState({}),
      v = C[0],
      g = C[1],
      h = a.useState({}),
      y = h[0],
      A = h[1],
      b = e.products.map(function (e) {
    return e.name;
  }),
      S = a.useMemo(function () {
    return o.groupBy(function (e) {
      return e.product;
    }, c);
  }, [c]),
      R = a.useMemo(function () {
    return e.products.map(function (e, t) {
      return T({}, e, {
        index: t
      });
    }).filter(function (e) {
      return o.any(function (t) {
        return t.product === e.name;
      }, c);
    });
  }, [c, e.products]);
  return a.createElement(f, null, a.createElement(Pe, {
    label: "Equipment Cost",
    value: n,
    onChange: function onChange(t) {
      r(t), t && s(function (e, t, a, n) {
        return e.flatMap(function (e) {
          return e.factors.map(function (a) {
            return {
              payment: (a.rate_factor + 1) * t / a.months,
              product: e.product,
              term: a.months,
              selected: !1
            };
          });
        }).map(function (e) {
          return a.includes(e.term) || n.includes(e.product) ? T({}, e, {
            selected: !0
          }) : e;
        });
      }(e.rates, t, E, m));
    },
    className: "mb-3"
  }), c.length > 0 && a.createElement(De, {
    terms: e.terms,
    onTermToggle: function onTermToggle(e) {
      E.includes(e) ? (p(E.filter(function (t) {
        return t !== e;
      })), s(c.map(function (t) {
        return t.term === e ? T({}, t, {
          selected: !1
        }) : t;
      }))) : (p([].concat(E, [e])), s(c.map(function (t) {
        return t.term === e ? T({}, t, {
          selected: !0
        }) : t;
      })));
    },
    selectedTerms: E,
    products: b,
    selectedProducts: m,
    onProductToggle: function onProductToggle(e) {
      m.includes(e) ? (u(m.filter(function (t) {
        return t !== e;
      })), s(c.map(function (t) {
        return t.product === e ? T({}, t, {
          selected: !1
        }) : t;
      }))) : (u([].concat(m, [e])), s(c.map(function (t) {
        return t.product === e ? T({}, t, {
          selected: !0
        }) : t;
      })));
    }
  }), Object.entries(S).map(function (t) {
    var n = t[0];
    return a.createElement("div", {
      className: "row flex-wrap justify-content-between",
      key: n
    }, t[1].map(function (t) {
      return a.createElement("div", {
        className: "col-auto",
        key: "" + t.term + n,
        style: {
          width: "250px"
        }
      }, a.createElement(Le, {
        selected: t.selected,
        onToggle: function onToggle() {
          return e = t, void s(c.map(function (t) {
            return t === e ? T({}, t, {
              selected: !t.selected
            }) : t;
          }));
          var e;
        },
        term: t.term,
        cost: t.payment,
        category: t.product,
        footnotes: e.products.reduce(function (e, a, n) {
          return a.name === t.product ? [].concat(e, [n + 1]) : e;
        }, []).join(",")
      }));
    }));
  }), c.length > 0 && a.createElement("div", {
    className: "row"
  }, R.map(function (e) {
    return a.createElement("div", {
      key: e.name,
      className: "col-sm-6"
    }, a.createElement(Me, {
      number: "" + (e.index + 1)
    }, e.footnote));
  })), c.length > 0 && a.createElement("div", {
    className: "row"
  }, a.createElement("div", {
    className: "col-sm-6"
  }, a.createElement(f, {
    heading: "Customer Information"
  }, a.createElement(D, {
    horizontal: !0,
    label: "Company Name",
    for: "customerCompanyName"
  }, a.createElement(re, {
    name: "customerCompanyName",
    value: v.companyName,
    onChange: function onChange(e) {
      return g(T({}, v, {
        companyName: e
      }));
    }
  })), a.createElement(D, {
    horizontal: !0,
    label: "Contact Name",
    for: "customerContactName"
  }, a.createElement(re, {
    name: "customerContactName",
    value: v.contactName,
    onChange: function onChange(e) {
      return g(T({}, v, {
        contactName: e
      }));
    }
  })), a.createElement(D, {
    horizontal: !0,
    label: "Contact Email",
    for: "customerContactEmail"
  }, a.createElement(re, {
    name: "customerContactEmail",
    value: v.contactEmail,
    type: "email",
    onChange: function onChange(e) {
      return g(T({}, v, {
        contactEmail: e
      }));
    }
  })), a.createElement(D, {
    horizontal: !0,
    label: "Equipment Description",
    for: "customerEquipmentDescription"
  }, a.createElement(re, {
    name: "customerEquipmentDescription",
    value: v.equipmentDescription,
    onChange: function onChange(e) {
      return g(T({}, v, {
        equipmentDescription: e
      }));
    }
  })), a.createElement(D, {
    horizontal: !0,
    label: "Equipment Cost",
    for: "equipmentCost"
  }, a.createElement(re, {
    name: "equipmentCost",
    type: "currency",
    value: n,
    onChange: function onChange() {},
    disabled: !0
  })))), a.createElement("div", {
    className: "col-sm-6"
  }, a.createElement(f, {
    heading: "Vendor Information"
  }, a.createElement(D, {
    horizontal: !0,
    label: "Company Name",
    for: "vendorCompanyName"
  }, a.createElement(re, {
    name: "vendorCompanyName",
    value: y.companyName,
    onChange: function onChange(e) {
      return A(T({}, y, {
        companyName: e
      }));
    }
  })), a.createElement(D, {
    horizontal: !0,
    label: "Contact Name",
    for: "vendorContactName"
  }, a.createElement(re, {
    name: "vendorContactName",
    value: y.contactName,
    onChange: function onChange(e) {
      return A(T({}, y, {
        contactName: e
      }));
    }
  })), a.createElement(D, {
    horizontal: !0,
    label: "Contact Email",
    for: "vendorContactEmail"
  }, a.createElement(re, {
    name: "vendorContactEmail",
    type: "email",
    value: y.contactEmail,
    onChange: function onChange(e) {
      return A(T({}, y, {
        contactEmail: e
      }));
    }
  })), a.createElement(D, {
    horizontal: !0,
    label: "Contact Phone",
    for: "vendorContactPhone"
  }, a.createElement(re, {
    name: "vendorContactPhone",
    type: "tel",
    value: y.contactPhone,
    onChange: function onChange(e) {
      return A(T({}, y, {
        contactPhone: e
      }));
    }
  }))))), c.length > 0 && a.createElement(f, {
    className: "mx-1 mt-3"
  }, a.createElement("div", {
    className: "d-flex justify-content-between"
  }, a.createElement("div", {
    className: "btn-group"
  }, a.createElement(N, {
    success: !0,
    onClick: function onClick() {
      var t = v.companyName,
          a = v.contactEmail,
          r = v.contactName,
          l = v.equipmentDescription,
          o = y.companyName,
          s = y.contactEmail,
          i = y.contactName,
          m = y.contactPhone;
      e.onSend({
        customerCompanyName: void 0 === t ? "" : t,
        customerContactEmail: void 0 === a ? "" : a,
        customerContactName: void 0 === r ? "" : r,
        equipmentDescription: void 0 === l ? "" : l,
        eqCost: n || 0,
        plans: c,
        vendorCompanyName: void 0 === o ? "" : o,
        vendorContactEmail: void 0 === s ? "" : s,
        vendorContactName: void 0 === i ? "" : i,
        vendorPhone: void 0 === m ? "" : m
      });
    }
  }, "Send"), a.createElement(N, {
    secondary: !0,
    onClick: function onClick() {
      return window.print();
    }
  }, "Print"), a.createElement(N, {
    warning: !0,
    onClick: function onClick() {
      r(void 0), g({}), A({}), s([]);
    }
  }, "Clear")), a.createElement(N, {
    danger: !0,
    onClick: e.onCancel
  }, "Cancel"))));
}, exports.Prequalifier = function (e) {
  var t = a.useState({}),
      n = t[0],
      l = t[1],
      o = e.cobrandLogo,
      s = {
    state: rt.state("State").required(),
    fico: rt.select("Fico Score").options(ot).required(),
    months_in_business: rt.select("Months in Business").options(it).required(),
    home_ownership: rt.boolean("Home Ownership").required(),
    past_SLJ: rt.boolean("Any Open Suits, Liens, or Judgements").required(),
    past_NSF: rt.select("Past Bank Overdrafts? (Last 12 Months)").options(ct).required(),
    monthly_DDA: rt.select("Average Monthly Checking Account Balance").options(st).required(),
    equipment_type: rt.select("Equipment Type").options(mt).required(),
    past_BK: rt.boolean("Any Past Bankruptcies?").required()
  };
  return e.endUser && (s.first_name = rt.text("First Name").required(), s.last_name = rt.text("Last Name").required(), s.email = rt.text("Email").required()), a.createElement("div", {
    id: "navitas-prequalifier"
  }, a.createElement(lt, {
    cobrandLogo: o
  }), a.createElement("div", {
    className: "rainbow"
  }, a.createElement("div", {
    className: "blue"
  }), a.createElement("div", {
    className: "teal"
  }), a.createElement("div", {
    className: "green"
  })), a.createElement(at, {
    submitLabel: "Pre-Qualify Now",
    initialValues: {},
    schema: s,
    onSubmit: function onSubmit(e) {
      try {
        var t = Ue(function () {
          return Promise.resolve(c.post(ke + "/prequalify", {
            prequalification: T({}, e, {
              id: n.id
            })
          })).then(function (e) {
            var t = e.data.data;
            l({
              grade: t.grade,
              amount: t.amount,
              id: t.id
            });
          });
        }, function () {
          alert("Could not send prequalification.");
        });
        return Promise.resolve(t && t.then ? t.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    split: !0
  }), a.createElement(function () {
    var e,
        t = n.amount,
        o = n.grade;
    return null == t ? null : (e = t <= 0 ? a.createElement("p", {
      className: "score lead"
    }, "Based on the responses provided, we will need additional information to pre-qualify this customer. Please contact your Navitas Account Representative at ", a.createElement("a", {
      href: "tel:1-877-628-4827"
    }, "877.628.4827"), ".") : a.createElement("p", {
      className: "score lead"
    }, "Congratulations, this customer has pre-qualified for the maximum credit amount of ", r.formatMoney(t), "A" === o && " and our preferred pricing plan."), a.createElement("div", {
      className: "mt-5"
    }, e, n.mailMessage && a.createElement("div", {
      className: "row"
    }, a.createElement("h2", null, n.mailMessage)), a.createElement(at, {
      schema: {
        emailTo: rt.email("Email To:").required()
      },
      onSubmit: function onSubmit(e) {
        return function (e) {
          try {
            var t = n.id;
            if (!e || !t) return Promise.resolve();
            var a = ke + "/prequalify/" + t + "/mail",
                r = Ue(function () {
              return Promise.resolve(c.post(a, {
                to: e
              })).then(function (e) {
                l({
                  mailMessage: e.data.data.message
                });
              });
            }, function () {
              alert("Could not send email.");
            });
            return Promise.resolve(r && r.then ? r.then(function () {}) : void 0);
          } catch (e) {
            return Promise.reject(e);
          }
        }(e.emailTo);
      },
      submitLabel: "Send Result"
    })));
  }, null));
}, exports.PropertyWaiverInfoModal = function (e) {
  return a.createElement(v, {
    onClose: e.onCancel,
    closeConfirm: e.cancelConfirm,
    title: "Property Waiver Info"
  }, a.createElement("form", {
    onSubmit: e.onSubmit
  }, a.createElement(D, {
    label: "Landlord Signer Name"
  }, a.createElement(re, {
    name: "signer_name",
    value: e.data.signer_name,
    onChange: function onChange(t) {
      return e.onChange({
        signer_name: t
      });
    },
    required: !0
  })), a.createElement(D, {
    label: "Landlord Signer Title"
  }, a.createElement(re, {
    name: "signer_title",
    value: e.data.signer_title,
    onChange: function onChange(t) {
      return e.onChange({
        signer_title: t
      });
    },
    required: !0
  })), a.createElement(D, {
    label: "Landlord Signer Email"
  }, a.createElement(re, {
    name: "signer_email",
    type: "email",
    value: e.data.signer_email,
    onChange: function onChange(t) {
      return e.onChange({
        signer_email: t
      });
    },
    required: !0
  })), a.createElement("hr", null), a.createElement(D, {
    label: "Landlord Company Name"
  }, a.createElement(re, {
    name: "landlord_name",
    value: e.data.landlord_name,
    onChange: function onChange(t) {
      return e.onChange({
        landlord_name: t
      });
    },
    required: !0
  })), a.createElement(D, {
    label: "Landlord Phone"
  }, a.createElement(re, {
    name: "landlord_phone",
    value: e.data.landlord_phone,
    onChange: function onChange(t) {
      return e.onChange({
        landlord_phone: t
      });
    },
    type: "tel",
    required: !0
  })), a.createElement(D, {
    label: "Landlord Street Address"
  }, a.createElement(re, {
    name: "street",
    value: e.data.street,
    onChange: function onChange(t) {
      return e.onChange({
        street: t
      });
    },
    required: !0
  })), a.createElement(D, {
    label: "Landlord City"
  }, a.createElement(re, {
    name: "city",
    value: e.data.city,
    onChange: function onChange(t) {
      return e.onChange({
        city: t
      });
    },
    required: !0
  })), a.createElement(D, {
    label: "Landlord State"
  }, a.createElement(re, {
    name: "state",
    type: "state",
    value: e.data.state,
    onChange: function onChange(t) {
      return e.onChange({
        state: t
      });
    },
    required: !0
  })), a.createElement(D, {
    label: "Landlord Zip Code"
  }, a.createElement(re, {
    name: "zip",
    type: "zip",
    value: e.data.zip,
    onChange: function onChange(t) {
      return e.onChange({
        zip: t
      });
    },
    required: !0
  })), a.createElement(D, {
    label: "County Where Property Resides"
  }, a.createElement(re, {
    name: "county",
    value: e.data.county,
    onChange: function onChange(t) {
      return e.onChange({
        county: t
      });
    },
    required: !0
  })), a.createElement("div", {
    className: "pull-right"
  }, a.createElement(N, {
    className: "mr-3",
    onClick: function onClick() {
      return n = (t = e).onCancel, (a = t.cancelConfirm) ? window.confirm(a) && n() : n();
      var t, a, n;
    }
  }, "Cancel"), a.createElement(N, {
    submit: !0,
    success: !0
  }, "Submit"))));
}, exports.Quoter = function (e) {
  var t = T({}, we, e),
      n = a.useReducer(Ge, t),
      l = n[0],
      s = n[1],
      i = l.section179Active,
      m = e.cobrandLogo,
      u = e.slug,
      d = e.repSlug,
      E = l.quoteVendor && l.quoteVendor.max_points || 0,
      N = l.quoteVendor && l.quoteVendor.logo && l.quoteVendor.logo.url,
      C = l.quoteVendor ? l.quoteVendor.representatives : [],
      f = new URLSearchParams(window.location.search),
      v = parseInt(f.get("max") || "0"),
      g = v > 0 || E > 0,
      h = !d && !!u,
      y = a.useMemo(function () {
    return function (e) {
      var t = e.vendor,
          a = void 0 === t ? {} : t,
          n = e.customer,
          r = e.quoteVendor,
          l = a && a.id ? "&vendor_id=" + a.id : qe(a, "vendor"),
          o = r && r.rate_set_id ? "&rate_set_id=" + r.rate_set_id : "",
          c = r && r.id ? "&quote_vendor_id=" + r.id : "",
          s = e.estimates.filter(function (e) {
        return e.selected;
      }).map(function (e, t) {
        return "&selected[" + t + "][product]=" + e.product + "&selected[" + t + "][term]=" + e.term;
      }).join("");
      return ke + "/estimates/pdf?cost=" + (e.amount || 0) + "&monthly_passthrough=" + (e.monthlyPassthrough || 0) + "&state=" + (e.customer.state || '""') + "&description=" + (e.description || '""') + "&tax_rate=" + e.taxRate + "&points=" + (e.points || 0) + l + qe(n, "customer") + o + c + s;
    }(l);
  }, [l]),
      A = a.useMemo(function () {
    return function (e, t) {
      return !o.isNil(e.amount) && !o.isNil(e.description) && !o.isNil(e.customer.name) && !o.isNil(e.customer.email) && (t || !o.isNil(e.vendor.name)) && (t || !o.isNil(e.vendor.email));
    }(l, e.hideVendor);
  }, [l, e.hideVendor]);
  a.useEffect(function () {
    u && function (e) {
      try {
        return Promise.resolve(c.get("quote_vendors/slug/" + e)).then(function (e) {
          return e.data.data;
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }(u).then(function (e) {
      var t = o.dissoc("id", e.contact);
      d && (t = e.representatives.find(function (e) {
        return e.slug === d;
      }) || t), s({
        type: "setQuoteVendor",
        payload: e
      }), s({
        type: "update",
        payload: {
          vendor: t
        }
      });
    });
  }, [u, d]);

  var b = function b(e) {
    return s({
      type: "update",
      payload: e
    });
  },
      S = function S(e) {
    try {
      return s({
        type: "update",
        payload: e
      }), Promise.resolve(function (e) {
        try {
          return Xe && Xe(), Promise.resolve(c.post("estimates", $e(e), {
            cancelToken: new c.CancelToken(function (e) {
              return Xe = e;
            })
          })).then(function (e) {
            return e.data.data;
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }(T({}, l, e))).then(function (e) {
        s({
          type: "update",
          payload: {
            estimates: e
          }
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return a.createElement("div", {
    className: "container",
    id: "navitex-quoter"
  }, a.createElement(Je, {
    logo: N,
    cobrandLogo: m
  }), a.createElement(Be, null), a.createElement("p", {
    className: "no-print px-3"
  }, "Thank you for allowing Navitas Credit Corp. to meet your financing needs. Simply enter your transaction cost estimate and discover our affordable payment plan options. Navitas gives you the ability to select the right payment plan to meet any budget need."), a.createElement(Ve, {
    update: b,
    updateAndGetEstimates: S,
    amount: l.amount,
    points: l.points || 0,
    monthlyPassthrough: l.monthlyPassthrough,
    section179Active: l.section179Active,
    showMonthlyPassthrough: l.showMonthlyPassthrough,
    enableMonthlyPassthrough: !!e.slug,
    enablePoints: g,
    maxPoints: v || E
  }), a.createElement(et, {
    required: l.estimates.length > 0 && !l.description,
    description: l.description,
    onChange: function onChange(e) {
      return b({
        description: e
      });
    }
  }), i && a.createElement(He, {
    updateAndGetEstimates: S,
    taxRate: l.taxRate,
    amount: l.amount
  }), a.createElement(Qe, {
    amount: l.amount,
    estimates: l.estimates,
    toggleTerm: function toggleTerm(e) {
      return s({
        type: "toggleTerm",
        payload: e
      });
    },
    toggleProduct: function toggleProduct(e) {
      return s({
        type: "toggleProduct",
        payload: e
      });
    },
    toggleEstimate: function toggleEstimate(e) {
      return s({
        type: "toggleEstimate",
        payload: e
      });
    },
    clearSelection: function clearSelection() {
      return s({
        type: "clearSelection"
      });
    },
    copy: function copy() {
      p(l.estimates.filter(function (e) {
        return !!e.selected;
      }).map(function (e) {
        return e.label + " - " + e.term + " Months - " + ("number" == typeof (t = e.value) ? r.formatMoney(t) : r.formatMoney(t.low) + " to " + r.formatMoney(t.high));
        var t;
      }).join("\n")), window.alert("Copied");
    },
    hideCopy: e.hideCopy
  }), !!l.estimates.length && a.createElement("div", {
    className: "row no-print"
  }, a.createElement(We, {
    onChange: function onChange(e) {
      return s({
        type: "updateCustomer",
        payload: e
      });
    },
    type: "customer",
    label: "Customer",
    contact: l.customer
  }), !e.hideVendor && a.createElement(We, {
    onChange: function onChange(e) {
      return s({
        type: "updateVendor",
        payload: e
      });
    },
    type: "vendor",
    disabled: !!d,
    label: "Vendor",
    representatives: C,
    contact: l.vendor,
    renderReps: h
  })), a.createElement(Ke, {
    success: l.success,
    sendQuote: function sendQuote() {
      try {
        var e = Ue(function () {
          var e = T({}, l);
          return Promise.resolve(function (e) {
            try {
              return Promise.resolve(c.post("estimates/send", function (e) {
                return T({}, $e(e), {
                  distribution_list_id: e.quoteVendor && e.quoteVendor.distribution_list_id,
                  customer: e.customer,
                  vendor: o.isNil(e.vendor.id) && !o.isEmpty(e.vendor) ? e.vendor : void 0,
                  vendor_id: o.isNil(e.vendor.id) ? void 0 : e.vendor.id,
                  is_vendor: !o.isNil(e.quoteVendor),
                  selected: e.estimates.filter(function (e) {
                    return e.selected;
                  }).map(function (e) {
                    return {
                      product: e.product,
                      grade: e.grade,
                      term: e.term
                    };
                  })
                });
              }(e))).then(function (e) {
                return e.data.message;
              });
            } catch (e) {
              return Promise.reject(e);
            }
          }(e)).then(function (e) {
            s({
              type: "update",
              payload: {
                success: e
              }
            });
          });
        }, function () {
          window.alert("Could not send quote");
        });
        return Promise.resolve(e && e.then ? e.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    pdfHref: y,
    disabled: !A,
    hideSend: e.hideSend,
    hidePrint: e.hidePrint
  }), a.createElement(Ze, {
    state: l
  }), a.createElement(tt, null));
}, exports.QuoterEquipmentCost = Pe, exports.QuoterFilterer = De, exports.QuoterFootnote = Me, exports.QuoterPlanBox = Le, exports.QuoterPoints = xe, exports.ReimbursementInformation = be, exports.Sidebar = function (e) {
  return a.createElement("aside", {
    className: "sidebar"
  }, a.createElement("div", {
    className: "list-group"
  }, e.children));
}, exports.Spinner = function (e) {
  return a.createElement("div", {
    className: n("df jc-center ai-center w-100 h-100", e.className),
    style: e.style
  }, a.createElement("i", {
    className: "fa fa-spinner fa-pulse fa-3x"
  }));
}, exports.StatusLog = function (e) {
  var t = e.application.app_events;
  return a.createElement(f, {
    heading: "Status Log",
    style: e.style,
    className: e.className
  }, a.createElement("table", {
    className: "table table-striped table-sm table-hover mb-3"
  }, a.createElement("tbody", null, (void 0 === t ? [] : t).map(function (e) {
    return a.createElement("tr", {
      key: e.event_at
    }, a.createElement("td", null, s.DateTime.fromISO(e.event_at).toLocaleString()), a.createElement("td", null, function (e) {
      switch (e.to_status) {
        case "Funded":
        case "FUNDED":
        case "Funding":
          return a.createElement("span", {
            className: "label label-success"
          }, e.to_status);

        case "Approved":
        case "APPROVED":
          return a.createElement("span", {
            className: "label label-info"
          }, e.to_status);

        default:
          return e.to_status;
      }
    }(e)));
  }))));
}, exports.TermSelector = ce, exports.ToastProvider = function (e) {
  var t = a.useState(e.toasts || []),
      n = t[0],
      r = t[1],
      l = function l(e) {
    return r(function (t) {
      return t.filter(function (t) {
        return t !== e;
      });
    });
  };

  return a.createElement(h.Provider, {
    value: {
      toast: function toast(e, t) {
        void 0 === t && (t = "success");
        var a = {
          text: e,
          type: t
        };
        n.every(function (e) {
          return e.text !== a.text;
        }) && (setTimeout(function () {
          return l(a);
        }, 3e3), r(function (e) {
          return [].concat(e, [a]);
        }));
      },
      toasts: n,
      clearToast: l
    }
  }, a.createElement(y, null), e.children);
}, exports.appToPayload = function (e) {
  var t = Ie(e);
  return {
    comments: t.comments ? t.comments.map(function (e) {
      return e.text;
    }).join() : "",
    companyType: t.business_type || "",
    customerCompanyName: t.company_name || "",
    customerContactName: t.contact_name || "",
    customerContactEmail: t.email || "",
    customerContactPhone: "",
    customerDBA: t.dba || "",
    customerPhone: t.phone || "",
    customerRefNum: t.other_tracking || "",
    customerCity: t.city || "",
    customerState: t.state || "",
    customerStreet: t.street || "",
    customerStreet2: t.street2 || "",
    customerZip: t.zip || "",
    customerTID: "",
    customerYearsInBusiness: t.years_in_business ? +t.years_in_business : 0,
    assets: t.assets ? t.assets : [O],
    financeTerm: t.term || 0,
    financeType: "",
    guarantors: [{}],
    corp_guarantors: []
  };
}, exports.blankApplication = {
  cost: 0,
  guarantor_name: "",
  id: -1,
  web_rep_name: ""
}, exports.blankApplicationPayload = _, exports.blankAsset = O, exports.blankGuarantor = {
  email: "",
  fax: "",
  first_name: "",
  last_name: "",
  leaseworks_id: "",
  middle_initial: "",
  phone: "",
  city: "",
  state: "",
  street_number: "",
  street_name: "",
  street_type: "",
  title: "",
  zip: ""
}, exports.blankReimbursement = {}, exports.companyOptions = P, exports.duplicatableDocuments = ["Power of Attorney", "Certificate of Authorization for Guaranty", "Driver License Request"], exports.editableDocuments = ["Certificate of Authorization", "Certificate of Authorization for Guaranty", "Power of Attorney", "Property Waiver"], exports.field = rt, exports.getDocusignErrors = function (e) {
  for (var t = e.overrides, a = void 0 === t ? {} : t, n = e.email || a.email || o.path(["guarantors", 0, "email"], e) || o.path(["guarantors", 0, "email"], a), r = e.signer_name || a.signer_name, l = (o.path(["guarantors", 0, "first_name"], e) || o.path(["guarantors", 0, "first_name"], a)) && (o.path(["guarantors", 0, "last_name"], e) || o.path(["guarantors", 0, "last_name"], a)), c = Math.max(o.path(["guarantors", "length"], e) || 0, o.path(["guarantors", "length"], a) || 0), s = Math.max(o.path(["corp_guarantors", "length"], e) || 0, o.path(["corp_guarantors", "length"], a) || 0), i = !0, m = 1; m < c; m++) {
    var u = o.path(["guarantors", m, "first_name"], e) || o.path(["guarantors", m, "first_name"], a),
        d = o.path(["guarantors", m, "last_name"], e) || o.path(["guarantors", m, "last_name"], a),
        E = o.path(["guarantors", m, "email"], e) || o.path(["guarantors", m, "email"], a);
    i = !!(i && u && d && E);
  }

  for (var p = !0, N = 1; N < s; N++) {
    var C = o.path(["corp_guarantors", N, "signer"], e) || o.path(["corp_guarantors", N, "signer"], a),
        f = o.path(["corp_guarantors", N, "email"], e) || o.path(["corp_guarantors", N, "email"], a);
    p = !!(p && C && f);
  }

  var T = [];
  return n || T.push("Either a signer email, or an email is on the first guarantor is required."), r || l || T.push("Either a signer name, or a first and last name on the first guarantor is required."), i || T.push("A first name, last name, and email on all guarantors after the first is required."), p || T.push("A signer name and email on all corporate guarantors is required."), T.length > 0 && T;
}, exports.mergeAssets = Oe, exports.mergeGuarantors = _e, exports.mergeOverrides = Ie, exports.useAlert = function () {
  return a.useContext(A).alert;
}, exports.useToast = function () {
  return a.useContext(h).toast;
};